{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016 - 2022                               }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCToolBar;

{$I WEBLib.TMSFNCDefines.inc}


{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCPersistence, WEBLib.TMSFNCListBox, WEBLib.TMSFNCStyles, WEBLib.TMSFNCCustomControl, WEBLib.Controls, Types, WEBLib.TMSFNCBitmapSelector,
  WEBLib.TMSFNCPopup, WEBLib.TMSFNCTypes, WEBLib.TMSFNCBitmapContainer, WEBLib.StdCtrls, WEBLib.TMSFNCColorSelector,
  {%H-}WEBLib.TMSFNCToolBarRes, WEBLib.TMSFNCGraphicsTypes
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes, Generics.Collections, Generics.Defaults
  {$ENDIF}
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,FMX.ListBox, WEBLib.Menus, FMX.Types, FMX.Edit
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  {$IFNDEF WEBLIB}
  ,Menus
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,Contnrs, WEBLib.Menus
  {$ENDIF}
  ,WEBLib.ExtCtrls
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 2; // Release nr.
  BLD_VER = 6; // Build nr.

  // version history
  // v1.0.0.0 : first release
  // v1.0.1.0 : New : DisabledBitmaps property
  // v1.0.1.1 : Fixed : Issue with DropDownButton on VCL
  // v1.0.1.2 : Fixed : Issue with bounds loop on LCL
  // v1.0.1.3 : Fixed : Issue with Tag property being overriden
  // v1.0.1.4 : Fixed : Issue with BitmapContainer not being given to internal TTMSFNCBitmapSelector in TTMSFNCToolBarBitmapPicker
  // v1.0.1.5 : Improved: Added onAnchorClick for HTML text in the TAdvToolBar
  // v1.0.1.6 : Fixed : Issue updating Visible property triggering multiple unnecessary UpdateToolBar calls
  //          : Improved : IsLoading check expanded checking for loading subcontrols
  // v1.0.1.7 : Fixed : Issue in Delphi 11 with begin and end scene for CreateBitmapCanvas
  //          : Fixed : Issue with compact toolbars not getting hidden in combination with TTMSFNCRibbon
  // v1.0.2.0 : Improved : Support for Delphi 11 high dpi handling added
  // v1.0.2.1 : Fixed : Issue with realignment causing extreme slowness at designtime in FMX.
  // v1.0.2.2 : Fixed : Issue with aligning buttons when parenting
  // v1.0.2.3 : Fixed : access violation with compacting popup
  // v1.0.2.4 : Improved : Exposed font color properties for disabled, hover and down state
  //          : Improved : UseStyledDropDownIcon to allow toggling between a styled or bitmap container icon when AdaptToStyle is true
  //          : Fixed : Issue styling Text when AdaptToStyle is true
  // v1.0.2.5 : Improved : OnCustomizeCompactToolBar event added
  // v1.0.2.6 : Improved : bitmap stretching when no text is assigned

  {$IFDEF WEBLIB}
  TMSFNCTOOLBAREXPANDSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdo'
                +'dD0iMTIiIHdpZHRoPSIxMCI+DQogIDxwYXRoIGQ9Ik0gMiA0IEwgNSA3IEwgOCA0IFoiIHN0eWxlPSJzdHJva2U6YmxhY2s7'
                +'c3Ryb2tlLXdpZHRoOjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4NCjwvc3ZnPg==';
  {$ENDIF}

type
  TTMSFNCCustomToolBar = class;
  TTMSFNCCustomDockPanel = class;
  TTMSFNCCustomToolBarSeparator = class;
  TTMSFNCDefaultToolBarButton = class;
  TTMSFNCToolBarButton = class;
  TTMSFNCToolBarDropDownButton = class;

  TTMSFNCToolBarCustomButtonAppearance = class(TPersistent)
  private
    FOwner: TTMSFNCDefaultToolBarButton;
    FHoverStroke: TTMSFNCGraphicsStroke;
    FDownFill: TTMSFNCGraphicsFill;
    FNormalFill: TTMSFNCGraphicsFill;
    FDownStroke: TTMSFNCGraphicsStroke;
    FDisabledFill: TTMSFNCGraphicsFill;
    FNormalStroke: TTMSFNCGraphicsStroke;
    FDisabledStroke: TTMSFNCGraphicsStroke;
    FHoverFill: TTMSFNCGraphicsFill;
    FCorners: TTMSFNCGraphicsCorners;
    FRounding: Single;
    FTransparent: Boolean;
    FShowInnerStroke: Boolean;
    FInnerStroke: TTMSFNCGraphicsStroke;
    FFlatStyle: Boolean;
    FOnChange: TNotifyEvent;
    procedure SetDisabledFill(const Value: TTMSFNCGraphicsFill);
    procedure SetDisabledStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetDownFill(const Value: TTMSFNCGraphicsFill);
    procedure SetDownStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetHoverFill(const Value: TTMSFNCGraphicsFill);
    procedure SetHoverStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetNormalFill(const Value: TTMSFNCGraphicsFill);
    procedure SetNormalStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetCorners(const Value: TTMSFNCGraphicsCorners); virtual;
    procedure SetRounding(const Value: Single); virtual;
    procedure SetInnerStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetShowInnerStroke(const Value: Boolean);
    procedure SetTransparent(const Value: Boolean);
    function IsRoundingStored: Boolean;
    procedure SetFlatStyle(const Value: Boolean);
  protected
    procedure FillChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
    procedure Changed; virtual;
    property Transparent: Boolean read FTransparent write SetTransparent default False;
    property ShowInnerStroke: Boolean read FShowInnerStroke write SetShowInnerStroke default True;
    property Rounding: Single read FRounding write SetRounding stored IsRoundingStored nodefault;
    property Corners: TTMSFNCGraphicsCorners read FCorners write SetCorners default [gcTopLeft, gcTopRight, gcBottomLeft, gcBottomRight];
    property InnerStroke: TTMSFNCGraphicsStroke read FInnerStroke write SetInnerStroke;
    property NormalFill: TTMSFNCGraphicsFill read FNormalFill write SetNormalFill;
    property NormalStroke: TTMSFNCGraphicsStroke read FNormalStroke write SetNormalStroke;
    property HoverFill: TTMSFNCGraphicsFill read FHoverFill write SetHoverFill;
    property HoverStroke: TTMSFNCGraphicsStroke read FHoverStroke write SetHoverStroke;
    property DownFill: TTMSFNCGraphicsFill read FDownFill write SetDownFill;
    property DownStroke: TTMSFNCGraphicsStroke read FDownStroke write SetDownStroke;
    property DisabledFill: TTMSFNCGraphicsFill read FDisabledFill write SetDisabledFill;
    property DisabledStroke: TTMSFNCGraphicsStroke read FDisabledStroke write SetDisabledStroke;
    property FlatStyle: Boolean read FFlatStyle write SetFlatStyle default False;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TTMSFNCDefaultToolBarButton);
    destructor Destroy; override;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  end;

  TTMSFNCToolBarButtonAppearance = class(TTMSFNCToolBarCustomButtonAppearance)
  published
    property Transparent;
    property ShowInnerStroke;
    property Rounding;
    property Corners;
    property InnerStroke;
    property NormalFill;
    property NormalStroke;
    property HoverFill;
    property HoverStroke;
    property DownFill;
    property DownStroke;
    property DisabledFill;
    property DisabledStroke;
    property FlatStyle;
  end;

  TTMSFNCToolBarCompactAppearance = class(TTMSFNCToolBarCustomButtonAppearance)
  published
    property NormalFill;
    property NormalStroke;
    property HoverFill;
    property HoverStroke;
    property DownFill;
    property DownStroke;
    property DisabledFill;
    property DisabledStroke;
    property FlatStyle;
  end;

  TTMSFNCToolBarQuickMenuButtonAppearance = class(TTMSFNCToolBarCustomButtonAppearance)
  published
    property NormalFill;
    property NormalStroke;
    property HoverFill;
    property HoverStroke;
    property DownFill;
    property DownStroke;
    property DisabledFill;
    property DisabledStroke;
    property FlatStyle;
  end;

  TTMSFNCToolBarElementState = (esNormal, esLarge);

  TTMSFNCCustomToolBarElement = class(TTMSFNCCustomControl)
  private
    FBlockUpdate: Boolean;
    FOnUpdateToolBar: TNotifyEvent;
    FOnUpdateToolBarControl: TNotifyEvent;
    FCanCopy: Boolean;
    FState: TTMSFNCToolBarElementState;
    FLastElement: Boolean;
    FControlIndex: Integer;
    procedure SetState(const Value: TTMSFNCToolBarElementState);
    procedure SetLastElement(const Value: Boolean);
  protected
    function GetDocURL: string; override;
    procedure UpdateState; virtual;
    procedure UpdateToolBar; virtual;
    procedure UpdateToolBarControl; virtual;
    {$IFDEF FMXLIB}
    procedure SetVisible(const Value: Boolean); override;
    procedure DoMatrixChanged(Sender: TObject); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure VisibleChanging; override;
    {$ENDIF}
    procedure DefineProperties(Filer : TFiler); override;
    procedure ReadControlIndex(Reader: TReader);
    procedure WriteControlIndex(Writer: TWriter);
    procedure UpdateControlAfterResize; override;
    property OnUpdateToolBar: TNotifyEvent read FOnUpdateToolBar write FOnUpdateToolBar;
    property OnUpdateToolBarControl: TNotifyEvent read FOnUpdateToolBarControl write FOnUpdateToolBarControl;
    property State: TTMSFNCToolBarElementState read FState write SetState default esNormal;
    property LastElement: Boolean read FLastElement write SetLastElement default False;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    property CanCopy: Boolean read FCanCopy write FCanCopy default True;
    property ControlIndex: Integer read FControlIndex write FControlIndex default -1;
  end;

  TTMSFNCToolBarButtonBitmapPosition = (bbpLeft, bbpTop);

  TTMSFNCToolBarButtonLayout = (bblNone, bblBitmap, bblLabel, bblLarge);

  {$IFDEF FNCLIB}
  TTMSFNCDefaultToolBarButton = class(TTMSFNCCustomToolBarElement, ITMSFNCBitmapContainer)
  {$ENDIF}
  {$IFNDEF FNCLIB}
  TTMSFNCDefaultToolBarButton = class(TTMSFNCCustomToolBarElement)
  {$ENDIF}
  private
    FOldHeight: Single;
    FBitmapVisible: Boolean;
    FText: String;
    FPopup: TTMSFNCPopup;
    FPopupPlacement: TTMSFNCPopupPlacement;
    FDropDownHeight: Single;
    FDropDownWidth: Single;
    FDown, FHover, FPrevHover: Boolean;
    FAppearance: TTMSFNCToolBarButtonAppearance;
    FBitmapContainer: TTMSFNCBitmapContainer;
    FBitmaps: TTMSFNCScaledBitmaps;
    FApplyName: Boolean;
    FDropDownControl: TControl;
    FFont: TTMSFNCGraphicsFont;
    FOnBeforeDropDown: TNotifyEvent;
    FCloseOnSelection: Boolean;
    FDownState: Boolean;
    FTextVisible: Boolean;
    FOnCloseDropDown: TNotifyEvent;
    FOnDropDown: TNotifyEvent;
    FVerticalTextAlign: TTMSFNCGraphicsTextAlign;
    FHorizontalTextAlign: TTMSFNCGraphicsTextAlign;
    FWordWrapping: Boolean;
    FTrimming: TTMSFNCGraphicsTextTrimming;
    FBitmapSize: Single;
    FStretchText: Boolean;
    FDisabledBitmaps: TTMSFNCScaledBitmaps;
    FHoverBitmaps: TTMSFNCScaledBitmaps;
    FShowFocus: Boolean;
    FDropDownAutoWidth: Boolean;
    FHoverFontColor: TTMSFNCGraphicsColor;
    FDownFontColor: TTMSFNCGraphicsColor;
    FDisabledFontColor: TTMSFNCGraphicsColor;
    FStretchBitmapIfNoText: Boolean;
    FBitmapPosition: TTMSFNCToolBarButtonBitmapPosition;
    FMaximumLayout: TTMSFNCToolBarButtonLayout;
    FMinimumLayout: TTMSFNCToolBarButtonLayout;
    FLayout: TTMSFNCToolBarButtonLayout;
    FCompactLayout: TTMSFNCToolBarButtonLayout;
    FLargeLayoutBitmapSize: Single;
    FLargeLayoutBitmaps: TTMSFNCScaledBitmaps;
    FLargeLayoutHoverBitmaps: TTMSFNCScaledBitmaps;
    FLargeLayoutDisabledBitmaps: TTMSFNCScaledBitmaps;
    FAutoBitmapSize: Boolean;
    FLargeLayoutAutoBitmapSize: Boolean;
    FUseStyledDropDownIcon: Boolean;
    procedure SetAppearance(const Value: TTMSFNCToolBarButtonAppearance);
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer); virtual;
    procedure SetBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetText(const Value: String);
    procedure SetDropDownHeight(const Value: Single);
    procedure SetDropDownWidth(const Value: Single);
    procedure SetBitmapVisible(const Value: Boolean);
    procedure SetTextVisible(const Value: Boolean);
    procedure SetFont(const Value: TTMSFNCGraphicsFont); reintroduce;
    procedure SetDropDownControl(const Value: TControl);
    procedure SetCloseOnSelection(const Value: Boolean);
    procedure SetDownState(const Value: Boolean);
    function IsDropDownHeightStored: Boolean;
    function IsDropDownWidthStored: Boolean;
    procedure SetHorizontalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetVerticalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetWordWrapping(const Value: Boolean);
    procedure SetTrimming(const Value: TTMSFNCGraphicsTextTrimming);
    function IsBitmapSizeStored: Boolean;
    procedure SetBitmapSize(const Value: Single);
    procedure SetStretchText(const Value: Boolean);
    procedure SetDisabledBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetHoverBitmaps(const Value: TTMSFNCScaledBitmaps);
    function GetBitmapContainer: TTMSFNCBitmapContainer;
    procedure SetShowFocus(const Value: Boolean);
    procedure SetDropDownAutoWidth(const Value: Boolean);
    procedure SetDisabledFontColor(const Value: TTMSFNCGraphicsColor);
    procedure SetDownFontColor(const Value: TTMSFNCGraphicsColor);
    procedure SetHoverFontColor(const Value: TTMSFNCGraphicsColor);
    procedure SetStretchBitmapIfNoText(const Value: Boolean);
    procedure SetBitmapPosition(const Value: TTMSFNCToolBarButtonBitmapPosition);
    procedure SetMaximumLayout(const Value: TTMSFNCToolBarButtonLayout);
    procedure SetMinimumLayout(const Value: TTMSFNCToolBarButtonLayout);
    procedure SetLayout(const Value: TTMSFNCToolBarButtonLayout);
    procedure SetCompactLayout(const Value: TTMSFNCToolBarButtonLayout);
    function IsLargeLayoutBitmapSizeStored: Boolean;
    procedure SetLargeLayoutBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetLargeLayoutBitmapSize(const Value: Single);
    procedure SetLargeLayoutDisabledBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetLargeLayoutHoverBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetAutoBitmapSize(const Value: Boolean);
    procedure SetLargeLayoutAutoBitmapSize(const Value: Boolean);
    procedure SetUseStyledDropDownIcon(const Value: Boolean);
  protected
    function CanDrawDesignTime: Boolean; virtual;
    function HasHint: Boolean; override;
    function GetHintString: String; override;
    function GetText: String; virtual;
    function GetTextSize: TSizeF; virtual;
    {$IFNDEF WEBLIB}
    {$IFDEF FNCLIB}
    {$IFNDEF LCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION >= 30}
    procedure ActionChange(Sender: {$IFNDEF FMXLIB}TObject{$ELSE}TBasicAction{$ENDIF}; CheckDefaults: Boolean); override;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    {$ENDIF}
    {$ENDIF}
    procedure UpdateControlAfterResize; override;
    procedure ApplyStyle; override;
    procedure ResetToDefaultStyle; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure BitmapsChanged(Sender: TObject);
    procedure DoFontChanged(Sender: TObject);
    procedure UpdateLayout; virtual;
    procedure DoClosePopup(Sender: TObject);
    procedure DoPopup(Sender: TObject);
    procedure InitializePopup; virtual;
    procedure UpdateState; override;
    procedure ChangeDPIScale(M, D: Integer); override;
    procedure AppearanceChanged; virtual;
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure SetName(const Value: TComponentName); override;
    procedure HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseMove(Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure HandleKeyUp(var Key: Word; Shift: TShiftState); override;
    procedure HandleKeyDown(var Key: Word; Shift: TShiftState); override;
    procedure HandleKeyPress(var Key: Char); override;
    procedure HandleMouseEnter; override;
    procedure HandleMouseLeave; override;
    procedure SelectFirstValue; virtual;
    procedure SelectValueWithCharacter({%H-}ACharacter: Char); virtual;
    procedure SelectLastValue; virtual;
    procedure SelectNextValue; virtual;
    procedure SelectPreviousValue; virtual;
    procedure DrawText(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawBitmap(AGraphics: TTMSFNCGraphics; ARect: TRectF); virtual;
    procedure DrawButton({%H-}AGraphics: TTMSFNCGraphics); virtual;
    function CanDropDown: Boolean; virtual;
    function CanChangeText: Boolean; virtual;
    function GetTextRect: TRectF; virtual;
    function GetDropDownRect: TRectF; virtual;
    function GetBitmapRect: TRectF; overload; virtual;
    function GetBitmapRect(ARect: TRectF): TRectF; overload; virtual;
    function GetBitmapSize: Single; virtual;
    function GetLargeLayoutBitmapSize: Single; virtual;
    property Appearance: TTMSFNCToolBarButtonAppearance read FAppearance write SetAppearance;
    property BitmapVisible: Boolean read FBitmapVisible write SetBitmapVisible default False;
    property Bitmaps: TTMSFNCScaledBitmaps read FBitmaps write SetBitmaps;
    property DisabledBitmaps: TTMSFNCScaledBitmaps read FDisabledBitmaps write SetDisabledBitmaps;
    property HoverBitmaps: TTMSFNCScaledBitmaps read FHoverBitmaps write SetHoverBitmaps;
    property LargeLayoutBitmaps: TTMSFNCScaledBitmaps read FLargeLayoutBitmaps write SetLargeLayoutBitmaps;
    property LargeLayoutDisabledBitmaps: TTMSFNCScaledBitmaps read FLargeLayoutDisabledBitmaps write SetLargeLayoutDisabledBitmaps;
    property LargeLayoutHoverBitmaps: TTMSFNCScaledBitmaps read FLargeLayoutHoverBitmaps write SetLargeLayoutHoverBitmaps;
    property BitmapContainer: TTMSFNCBitmapContainer read GetBitmapContainer write SetBitmapContainer;
    property BitmapSize: Single read FBitmapSize write SetBitmapSize stored IsBitmapSizeStored nodefault;
    property AutoBitmapSize: Boolean read FAutoBitmapSize write SetAutoBitmapSize default false;
    property LargeLayoutBitmapSize: Single read FLargeLayoutBitmapSize write SetLargeLayoutBitmapSize stored IsLargeLayoutBitmapSizeStored nodefault;
    property LargeLayoutAutoBitmapSize: Boolean read FLargeLayoutAutoBitmapSize write SetLargeLayoutAutoBitmapSize default False;
    property StretchBitmapIfNoText: Boolean read FStretchBitmapIfNoText write SetStretchBitmapIfNoText default True;
    property Text: String read GetText write SetText;
    property Trimming: TTMSFNCGraphicsTextTrimming read FTrimming write SetTrimming default gttCharacter;
    property HorizontalTextAlign: TTMSFNCGraphicsTextAlign read FHorizontalTextAlign write SetHorizontalTextAlign default gtaCenter;
    property VerticalTextAlign: TTMSFNCGraphicsTextAlign read FVerticalTextAlign write SetVerticalTextAlign default gtaCenter;
    property Font: TTMSFNCGraphicsFont read FFont write SetFont;
    property HoverFontColor: TTMSFNCGraphicsColor read FHoverFontColor write SetHoverFontColor default gcNull;
    property DownFontColor: TTMSFNCGraphicsColor read FDownFontColor write SetDownFontColor default gcNull;
    property DisabledFontColor: TTMSFNCGraphicsColor read FDisabledFontColor write SetDisabledFontColor default gcNull;
    property TextVisible: Boolean read FTextVisible write SetTextVisible default True;
    property StretchText: Boolean read FStretchText write SetStretchText default False;
    property WordWrapping: Boolean read FWordWrapping write SetWordWrapping default False;
    property DropDownAutoWidth: Boolean read FDropDownAutoWidth write SetDropDownAutoWidth default False;
    property DropDownHeight: Single read FDropDownHeight write SetDropDownHeight stored IsDropDownHeightStored nodefault;
    property DropDownWidth: Single read FDropDownWidth write SetDropDownWidth stored IsDropDownWidthStored nodefault;
    property DropDownControl: TControl read FDropDownControl write SetDropDownControl;
    property CloseOnSelection: Boolean read FCloseOnSelection write SetCloseOnSelection default True;
    property OnBeforeDropDown: TNotifyEvent read FOnBeforeDropDown write FOnBeforeDropDown;
    property OnDropDown: TNotifyEvent read FOnDropDown write FOnDropDown;
    property OnCloseDropDown: TNotifyEvent read FOnCloseDropDown write FOnCloseDropDown;
    property ApplyName: Boolean read FApplyName write FApplyName default True;
    property ShowFocus: Boolean read FShowFocus write SetShowFocus default False;
    property BitmapPosition: TTMSFNCToolBarButtonBitmapPosition read FBitmapPosition write SetBitmapPosition default bbpLeft;
    property CompactLayout: TTMSFNCToolBarButtonLayout read FCompactLayout write SetCompactLayout default bblNone;
    property Layout: TTMSFNCToolBarButtonLayout read FLayout write SetLayout default bblNone;
    property MinimumLayout: TTMSFNCToolBarButtonLayout read FMinimumLayout write SetMinimumLayout default bblBitmap;
    property MaximumLayout: TTMSFNCToolBarButtonLayout read FMaximumLayout write SetMaximumLayout default bblLarge;
    property UseStyledDropDownIcon: Boolean read FUseStyledDropDownIcon write SetUseStyledDropDownIcon default True;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    procedure DropDown; virtual;
    procedure CloseDropDown; virtual;
    function GetPopupControl: TTMSFNCPopup;
    function GetBitmap: TTMSFNCBitmap; virtual;
    property DownState: Boolean read FDownState write SetDownState;
    property PopupPlacement: TTMSFNCPopupPlacement read FPopupPlacement write FPopupPlacement default ppBottom;
  end;

  TTMSFNCToolBarButtonDropDownKind = (ddkNormal, ddkDropDown, ddkDropDownButton);
  TTMSFNCToolBarButtonDropDownPosition = (ddpRight, ddpBottom);

  TTMSFNCToolBarDropDownButton = class(TTMSFNCDefaultToolBarButton)
  private
    FDefaultStyle: Boolean;
    procedure SetDefaultStyle(const Value: Boolean);
  protected
    procedure RegisterRuntimeClasses; override;
    procedure DrawBitmap(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    function GetBitmapRect(ARect: TRectF): TRectF; override;
  public
    constructor Create(AOwner: TComponent); override;
    procedure LoadSettingsFromFile(AFileName: string); override;
    procedure LoadSettingsFromStream(AStream: TStream); override;
  published
    property DefaultStyle: Boolean read FDefaultStyle write SetDefaultStyle default True;
    {$IFNDEF WEBLIB}
    {$IFNDEF LCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION >= 30}
    property Action;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    {$ENDIF}
    property UseStyledDropDownIcon;
    property Font;
    property Text;
    property ShowFocus;
    property TextVisible;
    property StretchText;
    property HoverFontColor;
    property DownFontColor;
    property DisabledFontColor;
    property WordWrapping;
    property HorizontalTextAlign;
    property VerticalTextAlign;
    property Trimming;
    property Bitmaps;
    property DisabledBitmaps;
    property HoverBitmaps;
    property BitmapVisible;
    property BitmapContainer;
    property State;
    property LastElement;
    property Appearance;
  end;

  TTMSFNCToolBarDropDownButtonClass = class of TTMSFNCToolBarDropDownButton;


  TTMSFNCCustomToolBarButton = class(TTMSFNCDefaultToolBarButton)
  private
    FDropDownButton: TTMSFNCToolBarDropDownButton;
    FDropDownKind: TTMSFNCToolBarButtonDropDownKind;
    FDropDownPosition: TTMSFNCToolBarButtonDropDownPosition;
    FHidden: Boolean;
    FAutoOptionsMenuText: String;
    procedure SetDropDownKind(const Value: TTMSFNCToolBarButtonDropDownKind);
    procedure SetDropDownPosition(
      const Value: TTMSFNCToolBarButtonDropDownPosition);
    procedure SetHidden(const Value: Boolean);
  protected
    procedure ChangeDPIScale(M, D: Integer); override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure DoFontChanged(Sender: TObject);
    procedure AppearanceChanged; override;
    procedure UpdateDropDownButton; virtual;
    procedure HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure DropDownButtonClick(Sender: TObject);
    procedure DrawButton(AGraphics: TTMSFNCGraphics); override;
    {$IFDEF FMXLIB}
    procedure SetEnabled(const Value: Boolean); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure SetEnabled(Value: Boolean); override;
    {$ENDIF}
    function GetDropDownButtonClass: TTMSFNCToolBarDropDownButtonClass; virtual;
    function GetDropDownRect: TRectF; override;
    function GetTextRect: TRectF; override;
    function GetBitmapRect(ARect: TRectF): TRectF; overload; override;
    function GetBitmapRect: TRectF; overload; override;
    function CanDropDown: Boolean; override;
    property DropDownKind: TTMSFNCToolBarButtonDropDownKind read FDropDownKind write SetDropDownKind default ddkNormal;
    property DropDownPosition: TTMSFNCToolBarButtonDropDownPosition read FDropDownPosition write SetDropDownPosition default ddpRight;
    property AutoOptionsMenuText: String read FAutoOptionsMenuText write FAutoOptionsMenuText;
    property Hidden: Boolean read FHidden write SetHidden default False;
    procedure Loaded; override;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    function GetDropDownButtonControl: TTMSFNCToolBarDropDownButton;
    procedure LoadSettingsFromFile(AFileName: string); override;
    procedure LoadSettingsFromStream(AStream: TStream); override;
  end;

  TTMSFNCCustomToolBarSeparatorAppearance = class(TPersistent)
  private
    FOwner: TTMSFNCCustomToolBarSeparator;
    FStroke: TTMSFNCGraphicsStroke;
    FInnerStroke: TTMSFNCGraphicsStroke;
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetInnerStroke(const Value: TTMSFNCGraphicsStroke);
  protected
    procedure StrokeChanged(Sender: TObject);
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property InnerStroke: TTMSFNCGraphicsStroke read FInnerStroke write SetInnerStroke;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TTMSFNCCustomToolBarSeparator);
    destructor Destroy; override;
  end;

  TTMSFNCToolBarSeparatorAppearance = class(TTMSFNCCustomToolBarSeparatorAppearance)
  published
    property Stroke;
    property InnerStroke;
  end;

  TTMSFNCToolBarSeperatorOrientation = (tbsoVertical, tbsoHorizontal);

  TTMSFNCCustomToolBarSeparator = class(TTMSFNCCustomToolBarElement)
  private
    FAppearance: TTMSFNCToolBarSeparatorAppearance;
    FOrientation: TTMSFNCToolBarSeperatorOrientation;
    procedure SetAppearance(const Value: TTMSFNCToolBarSeparatorAppearance);
    procedure SetOrientation(const Value: TTMSFNCToolBarSeperatorOrientation);
  protected
    procedure UpdateState; override;
    property Appearance: TTMSFNCToolBarSeparatorAppearance read FAppearance write SetAppearance;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    property Orientation: TTMSFNCToolBarSeperatorOrientation read FOrientation write SetOrientation;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarButton = class(TTMSFNCCustomToolBarButton)
  protected
    procedure RegisterRuntimeClasses; override;
  public
    property Hidden;
  published
    {$IFNDEF WEBLIB}
    {$IFNDEF LCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION >= 30}
    property Action;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    {$ENDIF}
    property Font;
    property AutoOptionsMenuText;
    property DropDownAutoWidth;
    property DropDownKind;
    property DropDownPosition;
    property DropDownHeight;
    property DropDownWidth;
    property DropDownControl;
    property OnBeforeDropDown;
    property OnDropDown;
    property OnCloseDropDown;
    property Text;
    property ShowFocus;
    property TextVisible;
    property StretchText;
    property HoverFontColor;
    property DownFontColor;
    property DisabledFontColor;
    property StretchBitmapIfNoText;
    property HorizontalTextAlign;
    property VerticalTextAlign;
    property Trimming;
    property Bitmaps;
    property LargeLayoutBitmaps;
    property Layout;
    property CompactLayout;
    property MinimumLayout;
    property MaximumLayout;
    property BitmapPosition;
    property DisabledBitmaps;
    property HoverBitmaps;
    property LargeLayoutDisabledBitmaps;
    property LargeLayoutHoverBitmaps;
    property BitmapVisible;
    property BitmapContainer;
    property BitmapSize;
    property AutoBitmapSize;
    property LargeLayoutBitmapSize;
    property LargeLayoutAutoBitmapSize;
    property State;
    property LastElement;
    property Appearance;
    property WordWrapping;
  end;

  TTMSFNCToolBarButtonClass = class of TTMSFNCToolBarButton;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarSeparator = class(TTMSFNCCustomToolBarSeparator)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property State;
    property LastElement;
    property Appearance;
  end;

  TTMSFNCToolBarSeparatorClass = class of TTMSFNCToolBarSeparator;

  TTMSFNCToolBarItemPickerItemSelected = procedure(Sender: TObject; AItemIndex: Integer) of object;

  TTMSFNCToolBarCustomItemPicker = class(TTMSFNCToolBarButton)
  private
    FEdit: TEdit;
    FTimer: TTimer;
    FItemIndex: Integer;
    FItems: TStringList;
    FKeyboardUsed: Boolean;
    FItemSelector: TListBox;
    FOnItemSelected: TTMSFNCToolBarItemPickerItemSelected;
    FEditable: Boolean;
    FOnEditChange: TNotifyEvent;
    function GetSelectedItemIndex: Integer;
    procedure SetSelectedItemIndex(const Value: Integer);
    function GetSelectedItem: String;
    procedure SetSelectedItem(const Value: String);
    procedure SetItems(const Value: TStringList);
    procedure SetEditable(const Value: Boolean);
  protected
    procedure ChangeDPIScale(M, D: Integer); override;
    function CanChangeText: Boolean; override;
    function GetText: String; override;
    procedure EnterTimerChanged(Sender: TObject);
    procedure EditChange(Sender: TObject);
    procedure HandleDialogKey(var Key: Word; Shift: TShiftState); override;
    procedure InitializePopup; override;
    procedure SelectValueWithString(AValue: string); virtual;
    procedure SelectValueWithCharacter(ACharacter: Char); override;
    procedure SelectFirstValue; override;
    procedure SelectLastValue; override;
    procedure SelectNextValue; override;
    procedure SelectPreviousValue; override;
    {$IFDEF FMXLIB}
    procedure ItemKeyUp(Sender: TObject; var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
    procedure ItemKeyDown(Sender: TObject; var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
    procedure ItemSelected(const Sender: TCustomListBox; const Item: TListBoxItem);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure ItemKeyUp(Sender: TObject; var {%H-}Key: Word; {%H-}Shift: TShiftState);
    procedure ItemKeyDown(Sender: TObject; var {%H-}Key: Word; {%H-}Shift: TShiftState);
    procedure ItemSelected(Sender: TObject);
    {$ENDIF}
    procedure DoItemSelected; virtual;
    procedure DoEnter; override;
    property CloseOnSelection;
    property Items: TStringList read FItems write SetItems;
    property OnItemSelected: TTMSFNCToolBarItemPickerItemSelected read FOnItemSelected write FOnItemSelected;
    property ListBox: TListBox read FItemSelector;
    property SelectedItemIndex: Integer read GetSelectedItemIndex write SetSelectedItemIndex default -1;
    property SelectedItem: String read GetSelectedItem write SetSelectedItem;
    property Editable: Boolean read FEditable write SetEditable default False;
    property OnEditChange: TNotifyEvent read FOnEditChange write FOnEditChange;
  public
    constructor Create(AOwner: TComponent); override;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    destructor Destroy; override;
    procedure DropDown; override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarItemPicker = class(TTMSFNCToolBarCustomItemPicker)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property OnItemSelected;
    property SelectedItemIndex;
    property Items;
    property Editable;
    property OnEditChange;
  end;

  {$IFDEF FNCLIB}
  TTMSFNCToolBarCustomComboBox = class(TTMSFNCToolBarButton)
  private
    FEdit: TEdit;
    FTimer: TTimer;
    FItemIndex: Integer;
    FItems: TStringList;
    FKeyboardUsed: Boolean;
    FItemSelector: TTMSFNCListBox;
    FOnItemSelected: TTMSFNCToolBarItemPickerItemSelected;
    FEditable: Boolean;
    FOnEditChange: TNotifyEvent;
    function GetSelectedItemIndex: Integer;
    procedure SetSelectedItemIndex(const Value: Integer);
    function GetSelectedItem: String;
    procedure SetSelectedItem(const Value: String);
    procedure SetItems(const Value: TStringList);
    procedure SetEditable(const Value: Boolean);
  protected
    procedure ChangeDPIScale(M, D: Integer); override;
    function CanChangeText: Boolean; override;
    function GetText: String; override;
    procedure EnterTimerChanged(Sender: TObject);
    procedure EditChange(Sender: TObject);
    procedure HandleDialogKey(var Key: Word; Shift: TShiftState); override;
    procedure InitializePopup; override;
    procedure SelectValueWithString(AValue: string); virtual;
    procedure SelectValueWithCharacter(ACharacter: Char); override;
    procedure SelectFirstValue; override;
    procedure SelectLastValue; override;
    procedure SelectNextValue; override;
    procedure SelectPreviousValue; override;
    {$IFDEF FMXLIB}
    procedure ItemKeyUp(Sender: TObject; var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
    procedure ItemKeyDown(Sender: TObject; var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure ItemKeyUp(Sender: TObject; var {%H-}Key: Word; {%H-}Shift: TShiftState);
    procedure ItemKeyDown(Sender: TObject; var {%H-}Key: Word; {%H-}Shift: TShiftState);
    {$ENDIF}
    procedure ItemSelected(Sender: TObject; AItem: TTMSFNCListBoxItem);
    procedure DoItemSelected; virtual;
    procedure DoEnter; override;
    property CloseOnSelection;
    property Items: TStringList read FItems write SetItems;
    property OnItemSelected: TTMSFNCToolBarItemPickerItemSelected read FOnItemSelected write FOnItemSelected;
    property ListBox: TTMSFNCListBox read FItemSelector;
    property SelectedItemIndex: Integer read GetSelectedItemIndex write SetSelectedItemIndex default -1;
    property SelectedItem: String read GetSelectedItem write SetSelectedItem;
    property Editable: Boolean read FEditable write SetEditable default False;
    property OnEditChange: TNotifyEvent read FOnEditChange write FOnEditChange;
  public
    constructor Create(AOwner: TComponent); override;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    destructor Destroy; override;
    procedure DropDown; override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarComboBox = class(TTMSFNCToolBarCustomComboBox)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property OnItemSelected;
    property SelectedItemIndex;
    property Items;
    property Editable;
    property OnEditChange;
  end;
  {$ENDIF}

  TTMSFNCToolBarFontNamePickerFontNameSelected = procedure(Sender: TObject; AFontName: String) of object;

  TTMSFNCToolBarItemPickerClass = class of TTMSFNCToolBarItemPicker;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarFontNamePicker = class(TTMSFNCToolBarCustomItemPicker)
  private
    FOnFontNameSelected: TTMSFNCToolBarFontNamePickerFontNameSelected;
    function GetSelectedFontName: String;
    procedure SetSelectedFontName(const Value: String);
  protected
    procedure RegisterRuntimeClasses; override;
    procedure DoItemSelected; override;
  public
    constructor Create(AOwner: TComponent); override;
    property SelectedFontName: String read GetSelectedFontName write SetSelectedFontName;
    property SelectedItemIndex;
    property Items;
  published
    property OnFontNameSelected: TTMSFNCToolBarFontNamePickerFontNameSelected read FOnFontNameSelected write FOnFontNameSelected;
    property CloseOnSelection;
    property Editable;
    property OnEditChange;
  end;

  TTMSFNCToolBarFontSizePickerFontSizeSelected = procedure(Sender: TObject; AFontSize: Single) of object;

  TTMSFNCToolBarFontNamePickerClass = class of TTMSFNCToolBarFontNamePicker;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarFontSizePicker = class(TTMSFNCToolBarCustomItemPicker)
  private
    FOnFontSizeSelected: TTMSFNCToolBarFontSizePickerFontSizeSelected;
    function GetSelectedFontSize: Single;
    procedure SetSelectedFontSize(const Value: Single);
  protected
    procedure RegisterRuntimeClasses; override;
    procedure DoItemSelected; override;
  public
    constructor Create(AOwner: TComponent); override;
    property SelectedFontSize: Single read GetSelectedFontSize write SetSelectedFontSize;
    property SelectedItemIndex;
    property Items;
  published
    property OnFontSizeSelected: TTMSFNCToolBarFontSizePickerFontSizeSelected read FOnFontSizeSelected write FOnFontSizeSelected;
    property CloseOnSelection;
    property Editable;
    property OnEditChange;
  end;

  TTMSFNCToolBarColorPickerColorSelected = procedure(Sender: TObject; AColor: TTMSFNCGraphicsColor) of object;

  TTMSFNCToolBarFontSizePickerClass = class of TTMSFNCToolBarFontSizePicker;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarColorPicker = class(TTMSFNCToolBarButton)
  private
    FColorSelector: TTMSFNCColorSelector;
    FOnColorSelected: TTMSFNCToolBarColorPickerColorSelected;
    function GetSelectedColor: TTMSFNCGraphicsColor;
    procedure SetSelectedColor(const Value: TTMSFNCGraphicsColor);
    function GetSelectedItemIndex: Integer;
    procedure SetSelectedItemIndex(const Value: Integer);
    function GetItems: TTMSFNCColorSelectorItems;
    procedure SetItems(const Value: TTMSFNCColorSelectorItems);
  protected
    procedure RegisterRuntimeClasses; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure DrawColor(AColor: TTMSFNCGraphicsColor; ARect: TRectF; AGraphics: TTMSFNCGraphics);
    procedure ColorSelected(Sender: TObject; AColor: TTMSFNCGraphicsColor);
    procedure DoColorSelected(AColor: TTMSFNCGraphicsColor); virtual;
    function CanChangeText: Boolean; override;
  public
    constructor Create(AOwner: TComponent); override;
    function BlockChange: Boolean;
    function ColorSelector: TTMSFNCColorSelector;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    procedure DrawSelectedColor(AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF); virtual;
  published
    property OnColorSelected: TTMSFNCToolBarColorPickerColorSelected read FOnColorSelected write FOnColorSelected;
    property SelectedColor: TTMSFNCGraphicsColor read GetSelectedColor write SetSelectedColor default gcNull;
    property SelectedItemIndex: Integer read GetSelectedItemIndex write SetSelectedItemIndex;
    property Items: TTMSFNCColorSelectorItems read GetItems write SetItems;
    property CloseOnSelection;
  end;

  TTMSFNCToolBarBitmapPickerBitmapSelected = procedure(Sender: TObject; ABitmap: TTMSFNCBitmap) of object;

  TTMSFNCToolBarColorPickerClass = class of TTMSFNCToolBarColorPicker;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBarBitmapPicker = class(TTMSFNCToolBarButton)
  private
    FBitmapSelector: TTMSFNCBitmapSelector;
    FOnBitmapSelected: TTMSFNCToolBarBitmapPickerBitmapSelected;
    function GetSelectedBitmap: TTMSFNCBitmap;
    function GetSelectedItemIndex: Integer;
    procedure SetSelectedItemIndex(const Value: Integer);
    function GetItems: TTMSFNCBitmapSelectorItems;
    procedure SetItems(const Value: TTMSFNCBitmapSelectorItems);
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer); override;
  protected
    function GetBitmapRect(ARect: TRectF): TRectF; override;
    function CanChangeText: Boolean; override;
    procedure RegisterRuntimeClasses; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure BitmapSelected(Sender: TObject; ABitmap: TTMSFNCBitmap);
    procedure DoBitmapSelected(ABitmap: TTMSFNCBitmap); virtual;
  public
    constructor Create(AOwner: TComponent); override;
    function BlockChange: Boolean;
    function BitmapSelector: TTMSFNCBitmapSelector;
    property SelectedBitmap: TTMSFNCBitmap read GetSelectedBitmap;
  published
    property OnBitmapSelected: TTMSFNCToolBarBitmapPickerBitmapSelected read FOnBitmapSelected write FOnBitmapSelected;
    property SelectedItemIndex: Integer read GetSelectedItemIndex write SetSelectedItemIndex;
    property Items: TTMSFNCBitmapSelectorItems read GetItems write SetItems;
    property CloseOnSelection;
  end;

  TTMSFNCToolBarBitmapPickerClass = class of TTMSFNCToolBarBitmapPicker;

  TTMSFNCCustomToolBarAppearance = class(TPersistent)
  private
    FOwner: TTMSFNCCustomToolBar;
    FFill: TTMSFNCGraphicsFill;
    FStroke: TTMSFNCGraphicsStroke;
    FVerticalSpacing: Single;
    FHorizontalSpacing: Single;
    FDragGripColor: TTMSFNCGraphicsColor;
    FDragGrip: Boolean;
    FFlatStyle: Boolean;
    FFont: TTMSFNCGraphicsFont;
    FSeparatorStroke: TTMSFNCGraphicsStroke;
    FSeparator: Boolean;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetHorizontalSpacing(const Value: Single);
    procedure SetVerticalSpacing(const Value: Single);
    procedure SetDragGrip(const Value: Boolean);
    procedure SetDragGripColor(const Value: TTMSFNCGraphicsColor);
    function IsHorizontalSpacingStored: Boolean;
    function IsVerticalSpacingStored: Boolean;
    procedure SetFlatStyle(const Value: Boolean);
    procedure SetSeparator(const Value: Boolean);
    procedure SetSeparatorStroke(const Value: TTMSFNCGraphicsStroke);
  protected
    procedure FillChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property HorizontalSpacing: Single read FHorizontalSpacing write SetHorizontalSpacing stored IsHorizontalSpacingStored nodefault;
    property VerticalSpacing: Single read FVerticalSpacing write SetVerticalSpacing stored IsVerticalSpacingStored nodefault;
    property DragGrip: Boolean read FDragGrip write SetDragGrip default True;
    property DragGripColor: TTMSFNCGraphicsColor read FDragGripColor write SetDragGripColor default gcLightgray;
    property FlatStyle: Boolean read FFlatStyle write SetFlatStyle default False;
    property Separator: Boolean read FSeparator write SetSeparator default False;
    property SeparatorStroke: TTMSFNCGraphicsStroke read FSeparatorStroke write SetSeparatorStroke;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TTMSFNCCustomToolBar);
    destructor Destroy; override;
  end;

  TTMSFNCToolBarAppearance = class(TTMSFNCCustomToolBarAppearance)
  published
    property FlatStyle;
    property Fill;
    property Stroke;
    property Separator;
    property SeparatorStroke;
    property HorizontalSpacing;
    property VerticalSpacing;
    property DragGrip;
    property DragGripColor;
  end;

  TTMSFNCToolBarOptionMenuItem = class(TMenuItem)
  private
    FControl: TControl;
    FGlyphWidth: Single;
    FCalculate: Boolean;
  protected
    property Calculate: Boolean read FCalculate write FCalculate;
    property GlyphWidth: Single read FGlyphWidth write FGlyphWidth;
  public
    property Control: TControl read FControl write FControl;
  end;

  TTMSFNCToolBarControl = class(TPersistent)
  private
    FControlIndex: Integer;
    FControl: TControl;
    FLayout: TTMSFNCToolBarButtonLayout;
    FBitmap: TTMSFNCBitmap;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TControlClass = class of TControl;

  TTMSFNCToolBarCustomizeOptionsMenu = procedure(Sender: TObject; APopupMenu: TPopupMenu) of object;
  TTMSFNCToolBarCustomizeOptionsMenuItem = procedure(Sender: TObject; AControl: TControl; AMenuItem: TMenuItem) of object;
  TTMSFNCToolBarCanShowOptionsMenuItem = procedure(Sender: TObject; AControl: TControl; var ACanShowItem: Boolean) of object;
  TTMSFNCToolBarOptionsMenuItemClick = procedure(Sender: TObject; AControl: TControl; AMenuItem: TMenuItem; var AExecuteDefaultAction: Boolean) of object;
  TTMSFNCToolBarIsLastElement = procedure(Sender: TObject; AControl: TControl; var AIsLastElement: Boolean) of object;
  TTMSFNCToolBarAnchorClickEvent = procedure(Sender: TObject; AAnchor: string) of object;

  TTMSFNCCustomToolBarOptionsMenu = class(TPersistent)
  private
    FOwner: TTMSFNCCustomToolBar;
    FShowItemText: Boolean;
    FShowItemBitmap: Boolean;
    FShowButton: Boolean;
    FItemBitmapWidth: Single;
    FAutoItemBitmapWidth: Boolean;
    procedure SetShowButton(const Value: Boolean);
    procedure SetShowItemBitmap(const Value: Boolean);
    procedure SetShowItemText(const Value: Boolean);
    procedure SetAutoItemBitmapWidth(const Value: Boolean);
    procedure SetItemBitmapWidth(const Value: Single);
    function IsItemBitmapWidthStored: Boolean;
  protected
    property ShowButton: Boolean read FShowButton write SetShowButton default True;
    property ShowItemBitmap: Boolean read FShowItemBitmap write SetShowItemBitmap default True;
    property ShowItemText: Boolean read FShowItemText write SetShowItemText default True;
    property AutoItemBitmapWidth: Boolean read FAutoItemBitmapWidth write SetAutoItemBitmapWidth default True;
    property ItemBitmapWidth: Single read FItemBitmapWidth write SetItemBitmapWidth stored IsItemBitmapWidthStored nodefault;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TTMSFNCCustomToolBar);
    destructor Destroy; override;
  end;

  TTMSFNCToolBarOptionsMenu = class(TTMSFNCCustomToolBarOptionsMenu)
  published
    property ShowButton;
    property ShowItemBitmap;
    property ShowItemText;
    property AutoItemBitmapWidth;
    property ItemBitmapWidth;
  end;

  {$IFDEF WEBLIB}
  TTMSFNCToolBarControlObjectList = class(TObjectList)
  private
    function GetItem(Index: Integer): TTMSFNCToolBarControl;
    procedure SetItem(Index: Integer; const Value: TTMSFNCToolBarControl);
  public
    property Items[Index: Integer]: TTMSFNCToolBarControl read GetItem write SetItem; default;
  end;
  TTMSFNCToolBarControlList = class(TList)
  private
    function GetItem(Index: Integer): TTMSFNCToolBarControl;
    procedure SetItem(Index: Integer; const Value: TTMSFNCToolBarControl);
  public
    property Items[Index: Integer]: TTMSFNCToolBarControl read GetItem write SetItem; default;
  end;
  TTMSFNCControlList = class(TList)
  private
    function GetItem(Index: Integer): TControl;
    procedure SetItem(Index: Integer; const Value: TControl);
  public
    property Items[Index: Integer]: TControl read GetItem write SetItem; default;
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCToolBarControlObjectList = TObjectList<TTMSFNCToolBarControl>;
  TTMSFNCToolBarControlList = TList<TTMSFNCToolBarControl>;
  TTMSFNCControlList = TList<TControl>;
  {$ENDIF}

  TTMSFNCToolBarDragGripMovingEvent = procedure(Sender: TObject; DeltaX: Double; DeltaY: Double) of object;

  TTMSFNCToolBarPopup = class(TTMSFNCPopup)
  public
    property OnClosePopup;
  end;

  TTMSFNCToolBar = class;

  TTMSFNCToolBarCustomizeCompactToolBarEvent = procedure(Sender: TObject; ACompactToolBar: TTMSFNCToolBar) of object;

  {$IFDEF FNCLIB}
  TTMSFNCCustomToolBar = class(TTMSFNCCustomControl, ITMSFNCStylesManager, ITMSFNCBitmapContainer)
  {$ENDIF}
  {$IFNDEF FNCLIB}
  TTMSFNCCustomToolBar = class(TTMSFNCCustomControl)
  {$ENDIF}
  private
    FCompactToolbar: TTMSFNCToolBar;
    FCompactPopup: TTMSFNCToolBarPopup;
    FHover, FHoverP, FQuickMenuButtonHover, FQuickMenuButtonHoverP: Boolean;
    FDown, FQuickMenuButtonDown: Boolean;
    FOldWidth: Single;
    FOldMenuButtonState: Boolean;
    FBitmapContainer: TTMSFNCBitmapContainer;
    FInsideDrag, FDragGripMoving, FDragGripDown: Boolean;
    FDragGripDownPt: TPointF;
    FTotalOptionsMenuWidth: Single;
    {$IFNDEF LCLLIB}
    {$IFNDEF WEBLIB}
    FCompareControls: IComparer<TControl>;
    FCompareHiddenControls: IComparer<TTMSFNCToolBarControl>;
    {$ENDIF}
    {$ENDIF}
    FHiddenControls: TTMSFNCToolBarControlObjectList;
    FCompactControls: TTMSFNCToolBarControlObjectList;
    FBlockUpdate, FBlockResize: Boolean;
    FAutoSize: Boolean;
    FAppearance: TTMSFNCToolBarAppearance;
    FAutoAlign: Boolean;
    FOptionsMenuButton: TTMSFNCToolBarDropDownButton;
    FAutoOptionsMenu: TPopupMenu;
    FOnOptionsMenuCustomize: TTMSFNCToolBarCustomizeOptionsMenu;
    FOnOptionsMenuItemCustomize: TTMSFNCToolBarCustomizeOptionsMenuItem;
    FOnOptionsMenuButtonClick: TNotifyEvent;
    FOptionsMenu: TTMSFNCToolBarOptionsMenu;
    FCustomOptionsMenu: TPopupMenu;
    FOnOptionsMenuItemCanShow: TTMSFNCToolBarCanShowOptionsMenuItem;
    FState: TTMSFNCToolBarElementState;
    FOnOptionsMenuItemClick: TTMSFNCToolBarOptionsMenuItemClick;
    FOnOptionsMenuItemApplyStyle: TTMSFNCToolBarCustomizeOptionsMenuItem;
    FOnUpdateDockPanel: TNotifyEvent;
    FOnUpdateControls: TNotifyEvent;
    FOnIsLastElement: TTMSFNCToolBarIsLastElement;
    FOnDragGripMoving: TTMSFNCToolBarDragGripMovingEvent;
    FAutoMoveToolBar: Boolean;
    FOnInternalDblClick: TNotifyEvent;
    FOnInternalMouseDown: TNotifyEvent;
    FOnInternalMouseMove: TNotifyEvent;
    FOnInternalMouseUp: TNotifyEvent;
    FAutoHeight: Boolean;
    FAutoWidth: Boolean;
    FOnInternalInsertControl: TNotifyEvent;
    FAutoStretchHeight: Boolean;
    FText: string;
    FFirstLoad: Boolean;
    FFont: TTMSFNCGraphicsFont;
    FVerticalTextAlign: TTMSFNCGraphicsTextAlign;
    FTrimming: TTMSFNCGraphicsTextTrimming;
    FHorizontalTextAlign: TTMSFNCGraphicsTextAlign;
    FWordWrapping: Boolean;
    FTextVisible: Boolean;
    FMinimumWidth: Single;
    FCompact: Boolean;
    FCanCompact: Boolean;
    FCompactWidth: Single;
    FCompactAppearance: TTMSFNCToolBarCompactAppearance;
    FCompactBitmaps: TTMSFNCScaledBitmaps;
    FOnCompactClick: TNotifyEvent;
    FCompactBitmapSize: Single;
    FCompactBitmapVisible: Boolean;
    FCompactExpanderBitmaps: TTMSFNCScaledBitmaps;
    FQuickMenuButton: Boolean;
    FQuickMenuButtonAppearance: TTMSFNCToolBarQuickMenuButtonAppearance;
    FOnQuickMenuButtonClick: TNotifyEvent;
    FQuickMenuButtonBitmaps: TTMSFNCScaledBitmaps;
    FQuickMenuButtonHint: string;
    FCompactAutoBitmapSize: Boolean;
    FOnAnchorClick: TTMSFNCToolBarAnchorClickEvent;
    FDisabledFontColor: TTMSFNCGraphicsColor;
    FOnCustomizeCompactToolBar: TTMSFNCToolBarCustomizeCompactToolBarEvent;
    procedure SetAppearance(const Value: TTMSFNCToolBarAppearance);
    procedure SetAS(const Value: Boolean);
    procedure SetAutoAlign(const Value: Boolean);
    procedure SetOptionsMenu(const Value: TTMSFNCToolBarOptionsMenu);
    procedure SetState(const Value: TTMSFNCToolBarElementState);
    procedure SetAutoHeight(const Value: Boolean);
    procedure SetAutoWidth(const Value: Boolean);
    procedure SetAutoStretchHeight(const Value: Boolean);
    procedure SetText(const Value: string);
    function GetBitmapContainer: TTMSFNCBitmapContainer;
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer);
    procedure SetFont(const Value: TTMSFNCGraphicsFont); reintroduce;
    procedure SetHorizontalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetTrimming(const Value: TTMSFNCGraphicsTextTrimming);
    procedure SetVerticalTextAlign(const Value: TTMSFNCGraphicsTextAlign);
    procedure SetWordWrapping(const Value: Boolean);
    procedure SetTextVisible(const Value: Boolean);
    function IsMinimumWidthStored: Boolean;
    procedure SetMinimumWidth(const Value: Single);
    procedure SetCompact(const Value: Boolean);
    procedure SetCanCompact(const Value: Boolean);
    function IsCompactWidthStored: Boolean;
    procedure SetCompactWidth(const Value: Single);
    procedure SetCompactAppearance(const Value: TTMSFNCToolBarCompactAppearance);
    procedure SetCompactBitmaps(const Value: TTMSFNCScaledBitmaps);
    function IsCompactBitmapSizeStored: Boolean;
    procedure SetCompactBitmapSize(const Value: Single);
    procedure SetCompactBitmapVisible(const Value: Boolean);
    procedure SetCompactExpanderBitmaps(const Value: TTMSFNCScaledBitmaps);
    procedure SetQuickMenuButton(const Value: Boolean);
    procedure SetQuickMenuButtonAppearance(
      const Value: TTMSFNCToolBarQuickMenuButtonAppearance);
    procedure SetQuickMenuButtonBitmaps(
      const Value: TTMSFNCScaledBitmaps);
    procedure SetCompactAutoBitmapSize(const Value: Boolean);
    function GetTextRect: TRectF;
    procedure SetDisabledFontColor(const Value: TTMSFNCGraphicsColor);
  protected
    {$IFDEF FNCLIB}
    function GetSubComponentArray: TTMSFNCStylesManagerComponentArray;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetVersion: String; override;
    function CanDrawDesignTime: Boolean; virtual;
    function CanBuildControls: Boolean; virtual;
    function GetOptionsMenuButtonClass: TTMSFNCToolBarDropDownButtonClass; virtual;
    function GetBitmapPickerClass: TTMSFNCToolBarBitmapPickerClass; virtual;
    function GetToolBarButtonClass: TTMSFNCToolBarButtonClass; virtual;
    function GetColorPickerClass: TTMSFNCToolBarColorPickerClass; virtual;
    function GetItemPickerClass: TTMSFNCToolBarItemPickerClass; virtual;
    function GetFontNamePickerClass: TTMSFNCToolBarFontNamePickerClass; virtual;
    function GetFontSizePickerClass: TTMSFNCToolBarFontSizePickerClass; virtual;
    function GetToolBarSeparatorClass: TTMSFNCToolBarSeparatorClass; virtual;
    function GetTextSize: TSizeF; virtual;
    function GetHiddenControl(AControl: TControl): TTMSFNCToolBarControl; virtual;
    function GetCompactControl(AControl: TControl): TTMSFNCToolBarControl; virtual;
    function GetHiddenControlCount(AControl: TControl): Integer; virtual;
    function GetCompactControlCount: Integer; virtual;
    function GetCompactTextRect: TRectF; virtual;
    function GetCompactBitmapRect(ARect: TRectF): TRectF; virtual;
    function GetCompactBitmapSize: Single; virtual;
    function GetQuickMenuButtonRect: TRectF; virtual;
    function HasHint: Boolean; override;
    function GetHintString: String; override;
    procedure ChangeDPIScale(M, D: Integer); override;
    procedure HandleQuickMenuButton; virtual;
    procedure CompactAppearanceChanged(Sender: TObject);
    procedure QuickMenuButtonAppearanceChanged(Sender: TObject);
    procedure CompactBitmapsChanged(Sender: TObject);
    procedure CompactExpanderBitmapsChanged(Sender: TObject);
    procedure QuickMenuButtonBitmapsChanged(Sender: TObject);    
    procedure ApplyFlatStyle; virtual;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure ApplyStyle; override;
    procedure ResetToDefaultStyle; override;
    procedure HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseMove(Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseLeave; override;
    procedure HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure HandleCompact; virtual;
    procedure DeactivateAllPopups; virtual;
    procedure DoCompactClick; virtual;
    procedure DoCustomizeCompactToolBar(ACompactToolBar: TTMSFNCToolBar); virtual;
    procedure HandleDblClick({%H-}X, {%H-}Y: Single); override;
    procedure UpdateDockPanel; virtual;
    procedure InsertToolBarControl(AControl: TControl; {%H-}AIndex: Integer);
    procedure DoDragGripMoving(ADeltaX, ADeltaY: Double); virtual;
    {$IFDEF FMXLIB}
    procedure SetVisible(const Value: Boolean); override;
    procedure DoMatrixChanged(Sender: TObject); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure VisibleChanging; override;
    {$ENDIF}
    function GetDragGripRect(AInteraction: Boolean = False): TRectF;
    procedure CompactControls; virtual;
    procedure UncompactControls; virtual;
    procedure DoCustomizeOptionsMenu; virtual;
    procedure DoCustomizeOptionsMenuItem(AControl: TControl; AMenuItem: TMenuItem); virtual;
    procedure DoCanShowOptionsMenuItem(AControl: TControl; var ACanShowItem: Boolean); virtual;
    procedure UpdateToolBar(Sender: TObject);
    procedure DoIsLastElement(AControl: TControl; var ALastElement: Boolean);
    procedure UpdateToolBarControl(Sender: TObject);
    procedure OptionMenuItemClick(Sender: TObject);
    {$IFDEF FMXLIB}
    procedure OptionMenuItemApplyStyleLookup(Sender: TObject);
    {$ENDIF}
    procedure OptionsButtonClick(Sender: TObject);
    procedure DoCloseCompactPopup(Sender: TObject);
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;

    {$IFDEF FMXLIB}
    procedure DoAddObject(const AObject: TFmxObject); override;
    procedure DoInsertObject(Index: Integer; const AObject: TFmxObject); override;
    procedure DoRemoveObject(const AObject: TFmxObject); override;
    {$ENDIF}

    {$IFDEF CMNWEBLIB}
    procedure AlignControls(AControl: TControl; var Rect: TRect); override;
    {$ENDIF}
    procedure UpdateControlAfterResize; override;
    procedure UpdateControls; virtual;
    procedure InitializeOptionsMenu; virtual;
    procedure DrawDragGrip(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawText(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawCompactBitmap(AGraphics: TTMSFNCGraphics; ARect: TRectF); virtual;
    procedure DrawCompactText(AGraphics: TTMSFNCGraphics); virtual;
    procedure DrawCompactExpander(AGraphics: TTMSFNCGraphics); virtual;
    procedure ShowOptionsMenu(X, Y: Single); virtual;
    function CheckIsLoading: Boolean; virtual;
    function XYToAnchor(AX, AY: Single): string;
    procedure DoAnchorClick(AAnchor: string); virtual;
    procedure Loaded; override;
    property BlockUpdate: Boolean read FBlockUpdate write FBlockUpdate;
    property OnCompactClick: TNotifyEvent read FOnCompactClick write FOnCompactClick;
    property OnUpdateControls: TNotifyEvent read FOnUpdateControls write FOnUpdateControls;
    property OnUpdateDockPanel: TNotifyEvent read FOnUpdateDockPanel write FOnUpdateDockPanel;
    property OnInternalMouseDown: TNotifyEvent read FOnInternalMouseDown write FOnInternalMouseDown;
    property OnInternalInsertControl: TNotifyEvent read FOnInternalInsertControl write FOnInternalInsertControl;
    property OnInternalMouseUp: TNotifyEvent read FOnInternalMouseUp write FOnInternalMouseUp;
    property OnInternalMouseMove: TNotifyEvent read FOnInternalMouseMove write FOnInternalMouseMove;
    property OnInternalDblClick: TNotifyEvent read FOnInternalDblClick write FOnInternalDblClick;
    property Version: String read GetVersion;
    property AutoSize: Boolean read FAutoSize write SetAS default True;
    property AutoHeight: Boolean read FAutoHeight write SetAutoHeight default True;
    property AutoWidth: Boolean read FAutoWidth write SetAutoWidth default True;
    property AutoAlign: Boolean read FAutoAlign write SetAutoAlign default True;
    property AutoStretchHeight: Boolean read FAutoStretchHeight write SetAutoStretchHeight default False;
    property AutoMoveToolBar: Boolean read FAutoMoveToolBar write FAutoMoveToolBar default True;
    property Appearance: TTMSFNCToolBarAppearance read FAppearance write SetAppearance;
    property WordWrapping: Boolean read FWordWrapping write SetWordWrapping default False;
    property Text: string read FText write SetText;
    property TextVisible: Boolean read FTextVisible write SetTextVisible default True;
    property Trimming: TTMSFNCGraphicsTextTrimming read FTrimming write SetTrimming default gttCharacter;
    property HorizontalTextAlign: TTMSFNCGraphicsTextAlign read FHorizontalTextAlign write SetHorizontalTextAlign default gtaCenter;
    property VerticalTextAlign: TTMSFNCGraphicsTextAlign read FVerticalTextAlign write SetVerticalTextAlign default gtaCenter;
    property Font: TTMSFNCGraphicsFont read FFont write SetFont;
    property DisabledFontColor: TTMSFNCGraphicsColor read FDisabledFontColor write SetDisabledFontColor default gcNull;
    property OptionsMenu: TTMSFNCToolBarOptionsMenu read FOptionsMenu write SetOptionsMenu;
    property OnOptionsMenuItemCanShow: TTMSFNCToolBarCanShowOptionsMenuItem read FOnOptionsMenuItemCanShow write FOnOptionsMenuItemCanShow;
    property OnOptionsMenuCustomize: TTMSFNCToolBarCustomizeOptionsMenu read FOnOptionsMenuCustomize write FOnOptionsMenuCustomize;
    property OnOptionsMenuItemCustomize: TTMSFNCToolBarCustomizeOptionsMenuItem read FOnOptionsMenuItemCustomize write FOnOptionsMenuItemCustomize;
    property OnOptionsMenuItemApplyStyle: TTMSFNCToolBarCustomizeOptionsMenuItem read FOnOptionsMenuItemApplyStyle write FOnOptionsMenuItemApplyStyle;
    property OnOptionsMenuButtonClick: TNotifyEvent read FOnOptionsMenuButtonClick write FOnOptionsMenuButtonClick;
    property OnOptionsMenuItemClick: TTMSFNCToolBarOptionsMenuItemClick read FOnOptionsMenuItemClick write FOnOptionsMenuItemClick;
    property CustomOptionsMenu: TPopupMenu read FCustomOptionsMenu write FCustomOptionsMenu;
    property State: TTMSFNCToolBarElementState read FState write SetState default esNormal;
    property OnIsLastElement: TTMSFNCToolBarIsLastElement read FOnIsLastElement write FOnIsLastElement;
    property OnDragGripMoving: TTMSFNCToolBarDragGripMovingEvent read FOnDragGripMoving write FOnDragGripMoving;
    property AutoOptionsMenu: TPopupMenu read FAutoOptionsMenu;
    property BitmapContainer: TTMSFNCBitmapContainer read GetBitmapContainer write SetBitmapContainer;
    property MinimumWidth: Single read FMinimumWidth write SetMinimumWidth stored IsMinimumWidthStored nodefault;
    property CompactBitmapVisible: Boolean read FCompactBitmapVisible write SetCompactBitmapVisible default False;
    property CompactAutoBitmapSize: Boolean read FCompactAutoBitmapSize write SetCompactAutoBitmapSize default False;
    property CompactBitmaps: TTMSFNCScaledBitmaps read FCompactBitmaps write SetCompactBitmaps;
    property Compact: Boolean read FCompact write SetCompact default False;
    property QuickMenuButton: Boolean read FQuickMenuButton write SetQuickMenuButton default False;
    property QuickMenuButtonHint: string read FQuickMenuButtonHint write FQuickMenuButtonHint;
    property CompactWidth: Single read FCompactWidth write SetCompactWidth stored IsCompactWidthStored nodefault;
    property CanCompact: Boolean read FCanCompact write SetCanCompact default True;
    property CompactAppearance: TTMSFNCToolBarCompactAppearance read FCompactAppearance write SetCompactAppearance;
    property QuickMenuButtonAppearance: TTMSFNCToolBarQuickMenuButtonAppearance read FQuickMenuButtonAppearance write SetQuickMenuButtonAppearance;
    property CompactBitmapSize: Single read FCompactBitmapSize write SetCompactBitmapSize stored IsCompactBitmapSizeStored nodefault;
    property CompactExpanderBitmaps: TTMSFNCScaledBitmaps read FCompactExpanderBitmaps write SetCompactExpanderBitmaps;
    property QuickMenuButtonBitmaps: TTMSFNCScaledBitmaps read FQuickMenuButtonBitmaps write SetQuickMenuButtonBitmaps;    
    property OnQuickMenuButtonClick: TNotifyEvent read FOnQuickMenuButtonClick write FOnQuickMenuButtonClick;
    property OnAnchorClick: TTMSFNCToolBarAnchorClickEvent read FOnAnchorClick write FOnAnchorClick;
    property OnCustomizeCompactToolBar: TTMSFNCToolBarCustomizeCompactToolBarEvent read FOnCustomizeCompactToolBar write FOnCustomizeCompactToolBar;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Build; virtual;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    {$IFDEF FMXLIB}
    procedure SetBounds(X, Y, AWidth, AHeight: Single); override;
    {$ENDIF}
    function CanExpand: Boolean; virtual;
    function CanShrink: Boolean; virtual;
    function DropDownActive: Boolean; virtual;
    procedure CloseCompactPopup; virtual;
    procedure AddCustomControl(AControl: TControl; AIndex: Integer = -1); virtual;
    function AddCustomControlClass(AControlClass: TControlClass; AIndex: Integer = -1): TControl; virtual;
    function AddButton(AWidth: Single = -1; AHeight: Single = -1; AResource: String = ''; AResourceLarge: String = ''; AText: String = '';
      AIndex: Integer = -1): TTMSFNCToolBarButton; overload; virtual;
    function AddSeparator(AIndex: Integer = -1): TTMSFNCToolBarSeparator; virtual;
    function AddFontNamePicker(AIndex: Integer = -1): TTMSFNCToolBarFontNamePicker; virtual;
    function AddFontSizePicker(AIndex: Integer = -1): TTMSFNCToolBarFontSizePicker; virtual;
    function AddColorPicker(AIndex: Integer = -1): TTMSFNCToolBarColorPicker; virtual;
    function AddItemPicker(AIndex: Integer = -1): TTMSFNCToolBarItemPicker; virtual;
    function AddBitmapPicker(AIndex: Integer = -1): TTMSFNCToolBarBitmapPicker; virtual;
    function GetOptionsMenuButtonControl: TTMSFNCToolBarDropDownButton; virtual;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCToolBar = class(TTMSFNCCustomToolBar)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property OnOptionsMenuButtonClick;
    property OnOptionsMenuItemCanShow;
    property OnOptionsMenuCustomize;
    property OnOptionsMenuItemCustomize;
    property OnOptionsMenuItemApplyStyle;
    property OnOptionsMenuItemClick;
    property OnIsLastElement;
    property OnDragGripMoving;
    property OnQuickMenuButtonClick;
    property OnAnchorClick;
    //
    property Version;
    property AutoHeight;
    property AutoWidth;
    property AutoSize;
    property AutoAlign;
    property AutoStretchHeight;
    property OnCustomizeCompactToolBar;
    property AutoMoveToolBar;
    property Appearance;
    property CanCompact;
    property OnCompactClick;
    property CompactBitmapVisible;
    property CompactBitmaps;
    property Compact;
    property CompactWidth;
    property CompactAppearance;
    property CompactBitmapSize;
    property CompactAutoBitmapSize;
    property QuickMenuButtonHint;
    property QuickMenuButton;
    property QuickMenuButtonAppearance;
    property MinimumWidth;
    property WordWrapping;
    property Text;
    property Trimming;
    property HorizontalTextAlign;
    property VerticalTextAlign;
    property Font;
    property DisabledFontColor;
    property OptionsMenu;
    property CustomOptionsMenu;
    property State;
  end;

  TTMSFNCCustomDockPanelAppearance = class(TPersistent)
  private
    FOwner: TTMSFNCCustomDockPanel;
    FFill: TTMSFNCGraphicsFill;
    FStroke: TTMSFNCGraphicsStroke;
    FMargins: TTMSFNCMargins;
    procedure SetFill(const Value: TTMSFNCGraphicsFill);
    procedure SetStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetMargins(const Value: TTMSFNCMargins);
  protected
    procedure FillChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
    procedure MarginsChanged(Sender: TObject);
    property Fill: TTMSFNCGraphicsFill read FFill write SetFill;
    property Stroke: TTMSFNCGraphicsStroke read FStroke write SetStroke;
    property Margins: TTMSFNCMargins read FMargins write SetMargins;
  public
    constructor Create(AOwner: TTMSFNCCustomDockPanel);
    destructor Destroy; override;
  end;

  TTMSFNCDockPanelAppearance = class(TTMSFNCCustomDockPanelAppearance)
  published
    property Fill;
    property Stroke;
  end;

  TTMSFNCCustomDockPanel = class(TTMSFNCCustomControl)
  private
    FBlockUpdate: Boolean;
    FAppearance: TTMSFNCDockPanelAppearance;
    FAutoSize: Boolean;
    FAutoAlign: Boolean;
    FState: TTMSFNCToolBarElementState;
    procedure SetAppearance(const Value: TTMSFNCDockPanelAppearance);
    procedure SetAutoAlign(const Value: Boolean);
    procedure SetAS(const Value: Boolean);
    procedure SetState(const Value: TTMSFNCToolBarElementState);
  protected
    function GetDocURL: string; override;
    function GetVersion: String; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure UpdateControls; virtual;
    procedure InitializeControls; virtual;
    procedure RearrangeControls; virtual;
    procedure UpdateDockPanel(Sender: TObject);
    procedure ApplyStyle; override;
    procedure ResetToDefaultStyle; override;

    {$IFDEF FMXLIB}
    procedure DoAddObject(const AObject: TFmxObject); override;
    procedure DoInsertObject(Index: Integer; const AObject: TFmxObject); override;
    procedure DoRemoveObject(const AObject: TFmxObject); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure AlignControls(AControl: TControl; var Rect: TRect); override;
    {$ENDIF}

    property Version: String read GetVersion;
    property Appearance: TTMSFNCDockPanelAppearance read FAppearance write SetAppearance;
    property AutoSize: Boolean read FAutoSize write SetAS default True;
    property AutoAlign: Boolean read FAutoAlign write SetAutoAlign default True;
    property State: TTMSFNCToolBarElementState read FState write SetState default esNormal;
  public
    procedure Assign(Source: TPersistent); override;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF); override;
    function AddToolBar({%H-}AIndex: Integer = -1): TTMSFNCToolBar;
    {$IFDEF FMXLIB}
    procedure SetBounds(X, Y, AWidth, AHeight: Single); override;
    {$ENDIF}
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCDockPanel = class(TTMSFNCCustomDockPanel)
  published
    property Version;
    property Appearance;
    property AutoSize;
    property AutoAlign;
    property State;
  end;

  {$IFDEF CMNWEBLIB}
  TTMSFNCToolBarParent = TWinControl;
  {$ENDIF}
  {$IFDEF FMXLIB}
  TTMSFNCToolBarParent = TControl;
  {$ENDIF}

implementation

uses
  Math, SysUtils, WEBLib.TMSFNCUtils
  {$IFNDEF WEBLIB}
  {$IFDEF FNCLIB}
  {$IFNDEF LCLLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION >= 30}
  ,WEBLib.ActnList, FMX.ImgList
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
  {$ENDIF}
  {$ENDIF}
  ,WEBLib.Graphics, {%H-}StrUtils;

type
  TControlOpen = class(TControl);

function TTMSFNCCustomToolBar.AddBitmapPicker(
  AIndex: Integer): TTMSFNCToolBarBitmapPicker;
begin
  FBlockUpdate := True;
  Result := GetBitmapPickerClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddButton(AWidth: Single = -1; AHeight: Single = -1;
  AResource: String = ''; AResourceLarge: String = ''; AText: String = ''; AIndex: Integer = -1): TTMSFNCToolBarButton;
begin
  FBlockUpdate := True;
  Result := GetToolBarButtonClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  Result.Text := AText;
  if AWidth <> -1 then
  begin
    {$IFDEF FMXLIB}
    Result.Width := AWidth;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result.Width := Round(AWidth);
    {$ENDIF}
  end;

  if AHeight <> -1 then
  begin
    {$IFDEF FMXLIB}
    Result.Height := AHeight;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Result.Height := Round(AHeight);
    {$ENDIF}
  end;

  if AResource <> '' then
  begin
    Result.Bitmaps.AddBitmapFromResource(AResource, HInstance, 1.0);
    Result.DisabledBitmaps.AddBitmapFromResource(AResource, HInstance, 1.0);
    Result.HoverBitmaps.AddBitmapFromResource(AResource, HInstance, 1.0);
  end;

  if AResourceLarge <> '' then
  begin
    Result.Bitmaps.AddBitmapFromResource(AResourceLarge, HInstance, 1.5);
    Result.DisabledBitmaps.AddBitmapFromResource(AResourceLarge, HInstance, 1.5);
    Result.HoverBitmaps.AddBitmapFromResource(AResourceLarge, HInstance, 1.5);
  end;

  InsertToolBarControl(Result, AIndex);

  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddColorPicker(
  AIndex: Integer): TTMSFNCToolBarColorPicker;
begin
  FBlockUpdate := True;
  Result := GetColorPickerClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.AddCustomControl(AControl: TControl; AIndex: Integer = -1);
begin
  FBlockUpdate := True;
  InsertToolBarControl(AControl, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddCustomControlClass(AControlClass: TControlClass;
  AIndex: Integer = -1): TControl;
begin
  FBlockUpdate := True;
  Result := AControlClass.Create(Self);
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddFontNamePicker(
  AIndex: Integer): TTMSFNCToolBarFontNamePicker;
begin
  FBlockUpdate := True;
  Result := GetFontNamePickerClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddFontSizePicker(
  AIndex: Integer): TTMSFNCToolBarFontSizePicker;
begin
  FBlockUpdate := True;
  Result := GetFontSizePickerClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddItemPicker(
  AIndex: Integer): TTMSFNCToolBarItemPicker;
begin
  FBlockUpdate := True;
  Result := GetItemPickerClass.Create(Self);
  Result.Appearance.FlatStyle := Appearance.FlatStyle;
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.AddSeparator(AIndex: Integer = -1): TTMSFNCToolBarSeparator;
begin
  FBlockUpdate := True;
  Result := GetToolBarSeparatorClass.Create(Self);
  InsertToolBarControl(Result, AIndex);
  FBlockUpdate := False;
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.ApplyFlatStyle;
var
  I: Integer;
  c: TControl;
begin
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if c is TTMSFNCDefaultToolBarButton then
      (c as TTMSFNCDefaultToolBarButton).Appearance.FlatStyle := Appearance.FlatStyle;

    if c is TTMSFNCCustomToolBar then
      (c as TTMSFNCCustomToolBar).Appearance.FlatStyle := Appearance.FlatStyle;
  end;

  Invalidate;
end;

procedure TTMSFNCCustomToolBar.ApplyStyle;
var
  c: TTMSFNCGraphicsColor;
begin
  inherited;
  c := gcNull;
  if TTMSFNCStyles.GetStyleHeaderFillColor(c) then
  begin
    Appearance.Fill.Kind := gfkSolid;
    Appearance.Fill.Color := c;
  end;

  if TTMSFNCStyles.GetStyleHeaderFillColorTo(c) then
  begin
    Appearance.Fill.Kind := gfkGradient;
    Appearance.Fill.ColorTo := c;
  end;

  if TTMSFNCStyles.GetStyleTextFontColor(c) then
    Font.Color := c;
end;

procedure TTMSFNCCustomToolBar.Assign(Source: TPersistent);
var
  c, cc: TControl;
  I: Integer;
begin
  inherited;
  if Source is TTMSFNCCustomToolBar then
  begin
    FCompactAppearance.Assign((Source as TTMSFNCCustomToolBar).CompactAppearance);
    FQuickMenuButtonAppearance.Assign((Source as TTMSFNCCustomToolBar).QuickMenuButtonAppearance);
    FQuickMenuButton := (Source as TTMSFNCCustomToolBar).QuickMenuButton;
    FCompactBitmaps.Assign((Source as TTMSFNCCustomToolBar).CompactBitmaps);
    FCompact := (Source as TTMSFNCCustomToolBar).Compact;
    FCanCompact := (Source as TTMSFNCCustomToolBar).CanCompact;
    FMinimumWidth := (Source as TTMSFNCCustomToolBar).MinimumWidth;
    FCompactWidth := (Source as TTMSFNCCustomToolBar).CompactWidth;
    FCompactBitmapSize := (Source as TTMSFNCCustomToolBar).CompactBitmapSize;
    FCompactAutoBitmapSize := (Source as TTMSFNCCustomToolBar).CompactAutoBitmapSize;
    FCompactExpanderBitmaps.Assign((Source as TTMSFNCCustomToolBar).CompactExpanderBitmaps);
    FQuickMenuButtonBitmaps.Assign((Source as TTMSFNCCustomToolBar).QuickMenuButtonBitmaps);    
    FCompactBitmapVisible := (Source as TTMSFNCCustomToolBar).CompactBitmapVisible;
    FText := (Source as TTMSFNCCustomToolBar).Text;
    FTextVisible := (Source as TTMSFNCCustomToolBar).TextVisible;
    FWordWrapping := (Source as TTMSFNCCustomToolBar).WordWrapping;
    FHorizontalTextAlign := (Source as TTMSFNCCustomToolBar).HorizontalTextAlign;
    FVerticalTextAlign := (Source as TTMSFNCCustomToolBar).VerticalTextAlign;
    FTrimming := (Source as TTMSFNCCustomToolBar).Trimming;
    FFont.Assign((Source as TTMSFNCCustomToolBar).Font);
    FAutoSize := (Source as TTMSFNCCustomToolBar).AutoSize;
    FAutoHeight := (Source as TTMSFNCCustomToolBar).AutoHeight;
    FAutoWidth := (Source as TTMSFNCCustomToolBar).AutoWidth;
    FAutoAlign := (Source as TTMSFNCCustomToolBar).AutoAlign;
    FAutoStretchHeight := (Source as TTMSFNCCustomToolBar).AutoStretchHeight;
    FAutoMoveToolBar := (Source as TTMSFNCCustomToolBar).AutoMoveToolBar;
    FAppearance.Assign((Source as TTMSFNCCustomToolBar).Appearance);
    for I := 0 to (Source as TTMSFNCCustomToolBar).ControlCount - 1 do
    begin
      cc := (Source as TTMSFNCCustomToolBar).Controls[I];
      if ((cc is TTMSFNCDefaultToolBarButton) and (cc as TTMSFNCDefaultToolBarButton).CanCopy) or not ((cc is TTMSFNCDefaultToolBarButton) and (cc is TControl)) then
      begin
        if cc is TTMSFNCDefaultToolBarButton then
          (cc as TTMSFNCDefaultToolBarButton).ApplyName := False;

        c := (TTMSFNCUtils.Clone(cc) as TControl);
        if cc is TTMSFNCDefaultToolBarButton then
          (cc as TTMSFNCDefaultToolBarButton).ApplyName := True;

        AddCustomControl(c);
      end;
    end;
    Invalidate;
  end
  else
    inherited;
end;

procedure TTMSFNCCustomToolBar.Build;
begin
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.ChangeDPIScale(M, D: Integer);
begin
  inherited;
  Font.Height := TTMSFNCUtils.MulDivInt(Font.Height, M, D);
  Appearance.HorizontalSpacing := TTMSFNCUtils.MulDivSingle(Appearance.HorizontalSpacing, M, D);
  Appearance.VerticalSpacing := TTMSFNCUtils.MulDivSingle(Appearance.VerticalSpacing, M, D);
  CompactWidth := TTMSFNCUtils.MulDivSingle(CompactWidth, M, D);
  CompactBitmapSize := TTMSFNCUtils.MulDivSingle(CompactBitmapSize, M, D);
end;

function TTMSFNCCustomToolBar.CheckIsLoading: Boolean;
begin
  Result := IsLoading;
end;

function TTMSFNCCustomToolBar.CanShrink: Boolean;
var
  I: Integer;
  c: TControl;
  btn: TTMSFNCDefaultToolBarButton;
begin
  Result := False;

  if not Compact and CanCompact then
  begin
    Result := True;
    Exit;
  end;

  for I := Self.ControlCount - 1 downto 0 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if c <> FOptionsMenuButton then
    begin
      if c is TTMSFNCDefaultToolBarButton then
      begin
        btn := c as TTMSFNCDefaultToolBarButton;
        if (Integer(btn.Layout) > Integer(btn.MinimumLayout)) and (btn.Layout <> bblNone) then
        begin
          Result := True;
          Break;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCCustomToolBar.CloseCompactPopup;
begin
  if Assigned(FCompactPopup) then
    FCompactPopup.IsOpen := False;
end;

function TTMSFNCCustomToolBar.CanBuildControls: Boolean;
begin
  Result := True;
end;

function TTMSFNCCustomToolBar.CanDrawDesignTime: Boolean;
begin
  Result := False;
end;

function TTMSFNCCustomToolBar.CanExpand: Boolean;
var
  I: Integer;
  c: TControl;
  btn: TTMSFNCDefaultToolBarButton;
begin
  Result := False;

  if Compact then
  begin
    Result := True;
    Exit;
  end;

  for I := Self.ControlCount - 1 downto 0 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if c <> FOptionsMenuButton then
    begin
      if c is TTMSFNCDefaultToolBarButton then
      begin
        btn := c as TTMSFNCDefaultToolBarButton;
        if (Integer(btn.Layout) < Integer(btn.MaximumLayout)) and (btn.Layout <> bblNone) then
        begin
          Result := True;
          Break;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCCustomToolBar.CompactAppearanceChanged(Sender: TObject);
begin
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.CompactBitmapsChanged(Sender: TObject);
var
  bmp: TTMSFNCBitmap;
begin
  bmp := TTMSFNCGraphics.GetScaledBitmap(CompactBitmaps, 0, BitmapContainer);
  CompactBitmapVisible := Assigned(bmp) and not IsBitmapEmpty(bmp);
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.CompactControls;
var
  I: Integer;
  cc: TTMSFNCToolBarControl;
  c: TControl;
begin
  FBlockUpdate := True;
  FCompactControls.Clear;
  for I := Self.ControlCount - 1 downto 0 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if c <> FOptionsMenuButton then
    begin
      cc := TTMSFNCToolBarControl.Create;
      cc.FControl := c;
      if c is TTMSFNCDefaultToolBarButton then
      begin
        cc.FLayout := (c as TTMSFNCDefaultToolBarButton).Layout;
        if ((c as TTMSFNCDefaultToolBarButton).CompactLayout = bblNone) and ((c as TTMSFNCDefaultToolBarButton).Layout <> bblNone) then
          (c as TTMSFNCDefaultToolBarButton).CompactLayout := (c as TTMSFNCDefaultToolBarButton).MaximumLayout;
      end;

      if c is TTMSFNCCustomToolBarElement then
        cc.FControlIndex := (c as TTMSFNCCustomToolBarElement).ControlIndex
      else
        cc.FControlIndex := c.Tag;

      c.Parent := nil;
      c.Visible := False;
      FCompactControls.Add(cc);
    end;
  end;
  FBlockUpdate := True;
  UpdateControls;
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.CompactExpanderBitmapsChanged(Sender: TObject);
begin
  Invalidate;
end;

constructor TTMSFNCCustomToolBar.Create(AOwner: TComponent);
var
  c: TTMSFNCGraphicsColor;
begin
  inherited;
  FFirstLoad := True;
  FHiddenControls := TTMSFNCToolBarControlObjectList.Create;
  FCompactControls := TTMSFNCToolBarControlObjectList.Create;
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  FCompareControls := TDelegatedComparer<TControl>.Create(
    function(const Item1, Item2: TControl): Integer
    var
      c1, c2: Integer;
    begin
      if Item1 is TTMSFNCCustomToolBarElement then
        c1 := (Item1 as TTMSFNCCustomToolBarElement).ControlIndex
      else
        c1 := Item1.Tag;

      if Item2 is TTMSFNCCustomToolBarElement then
        c2 := (Item2 as TTMSFNCCustomToolBarElement).ControlIndex
      else
        c2 := Item2.Tag;

      Result := CompareValue(c1, c2);
    end);
  FCompareHiddenControls := TDelegatedComparer<TTMSFNCToolBarControl>.Create(
    function(const Item1, Item2: TTMSFNCToolBarControl): Integer
    begin
      Result := CompareValue(Item1.FControlIndex, Item2.FControlIndex);
    end);
  {$ENDIF}
  {$ENDIF}
  FState := esNormal;
  FDisabledFontColor := gcNull;
  FAppearance := TTMSFNCToolBarAppearance.Create(Self);
  FCompactAppearance := TTMSFNCToolBarCompactAppearance.Create(nil);
  FCompactAppearance.OnChange := @CompactAppearanceChanged;
  FQuickMenuButtonAppearance := TTMSFNCToolBarQuickMenuButtonAppearance.Create(nil);
  FQuickMenuButtonAppearance.OnChange := @QuickMenuButtonAppearanceChanged;
  FCompactBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FCompactBitmaps.OnChange := @CompactBitmapsChanged;
  FOptionsMenu := TTMSFNCToolBarOptionsMenu.Create(Self);
  FMinimumWidth := 30;
  FCompactWidth := 50;
  FCompactBitmapSize := 24;
  FCompactAutoBitmapSize := False;
  FCompactBitmapVisible := False;
  FCompactExpanderBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FCompactExpanderBitmaps.OnChange := @CompactExpanderBitmapsChanged;
  FQuickMenuButtonBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FQuickMenuButtonBitmaps.OnChange := @QuickMenuButtonBitmapsChanged;
  FCanCompact := True;
  FQuickMenuButton := False;
  FCompact := False;
  FAutoSize := True;
  FAutoWidth := True;
  FAutoHeight := True;
  FAutoAlign := True;
  FAutoStretchHeight := False;
  FAutoMoveToolBar := True;
  FOptionsMenuButton := GetOptionsMenuButtonClass.Create(Self);
  FOptionsMenuButton.Appearance.NormalFill.Kind := gfkSolid;
  c := gcLightgray;
  FOptionsMenuButton.Appearance.NormalFill.Color := c;
  FOptionsMenuButton.Appearance.ShowInnerStroke := False;
  FOptionsMenuButton.Appearance.Rounding := 0;

  FOptionsMenuButton.Appearance.HoverFill.Assign(FOptionsMenuButton.Appearance.NormalFill);
  FOptionsMenuButton.Appearance.DisabledFill.Assign(FOptionsMenuButton.Appearance.NormalFill);
  FOptionsMenuButton.Appearance.DownFill.Assign(FOptionsMenuButton.Appearance.NormalFill);

  FOptionsMenuButton.Appearance.HoverFill.Color := gcLightblue;
  FOptionsMenuButton.Appearance.DownFill.Color := gcLightsteelblue;
  FOptionsMenuButton.Appearance.DisabledFill.Color := gcLightgray;

  {$IFDEF VCLWEBLIB}
  FOptionsMenuButton.AlignWithMargins := True;
  {$ENDIF}
  
  {$IFNDEF LCLLIB}
  FOptionsMenuButton.Margins.Top := 3;
  FOptionsMenuButton.Margins.Bottom := 3;
  FOptionsMenuButton.Margins.Right := 3;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FOptionsMenuButton.BorderSpacing.Top := 3;
  FOptionsMenuButton.BorderSpacing.Bottom := 3;
  FOptionsMenuButton.BorderSpacing.Right := 3;
  {$ENDIF}

  FOptionsMenuButton.CanCopy := False;
  FAutoOptionsMenu := TPopupMenu.Create(Self);
  {$IFDEF FMXLIB}
  FAutoOptionsMenu.Parent := Self;
  FAutoOptionsMenu.Stored := False;
  {$ENDIF}
  FOptionsMenuButton.OnClick := @OptionsButtonClick;
  FOptionsMenuButton.Width := 17;
  FOptionsMenuButton.Text := '';
  FOptionsMenuButton.Stored := False;

  FOptionsMenuButton.Bitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENU, HInstance, 1.0);
  FOptionsMenuButton.Bitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENULARGE, HInstance, 1.5);
  FOptionsMenuButton.DisabledBitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENU, HInstance, 1.0);
  FOptionsMenuButton.DisabledBitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENULARGE, HInstance,1.5);
  FOptionsMenuButton.HoverBitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENU, HInstance, 1.0);
  FOptionsMenuButton.HoverBitmaps.AddBitmapFromResource(TMSFNCTOOLBAROPTIONSMENULARGE, HInstance,1.5);

  FHorizontalTextAlign := gtaCenter;
  FVerticalTextAlign := gtaCenter;
  FTrimming := gttCharacter;
  FWordWrapping := False;
  FTextVisible := True;

  FFont := TTMSFNCGraphicsFont.Create;

  FCompactExpanderBitmaps.AddBitmapFromResource(TMSFNCGRAPHICSDOWN, HInstance, 1.0);
  FQuickMenuButtonBitmaps.AddBitmapFromResource(TMSFNCTOOLBARQUICKMENU, HInstance, 1.0);  
end;

procedure TTMSFNCCustomToolBar.DeactivateAllPopups;
var
  I: Integer;
begin
  if Assigned(Parent) and (Parent is TTMSFNCToolBarParent) then
    for I := 0 to (Parent as TTMSFNCToolBarParent).ControlCount - 1 do
      if (Parent as TTMSFNCToolBarParent).Controls[I] is TTMSFNCCustomToolBar then
        ((Parent as TTMSFNCToolBarParent).Controls[I] as TTMSFNCCustomToolBar).CloseCompactPopup;
end;

destructor TTMSFNCCustomToolBar.Destroy;
begin
  FQuickMenuButtonBitmaps.Free;
  FCompactExpanderBitmaps.Free;
  FCompactPopup.Free;
  FQuickMenuButtonAppearance.Free;
  FCompactAppearance.Free;
  FCompactBitmaps.Free;
  FFont.Free;
  FOptionsMenu.Free;
  FAppearance.Free;
  FHiddenControls.Free;
  FCompactControls.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBar.DoAnchorClick(AAnchor: string);
begin
  if Assigned(OnAnchorClick) then
    OnAnchorClick(Self, AAnchor)
  else
    TTMSFNCUtils.OpenURL(AAnchor);
end;

procedure TTMSFNCCustomToolBar.DoCanShowOptionsMenuItem(AControl: TControl;
  var ACanShowItem: Boolean);
begin
  if Assigned(OnOptionsMenuItemCanShow) then
    OnOptionsMenuItemCanShow(Self, AControl, ACanShowItem);
end;

procedure TTMSFNCCustomToolBar.DoCloseCompactPopup(Sender: TObject);
var
  I: Integer;
  cc: TTMSFNCToolBarControl;
begin
  FCompactPopup.ContentControl := nil;

  for I := 0 to FCompactControls.Count - 1 do
  begin
    cc := TTMSFNCToolBarControl(FCompactControls[I]);
    if Assigned(cc.FControl) then
    begin
      if cc.FControl is TTMSFNCDefaultToolBarButton then
        (cc.FControl as TTMSFNCDefaultToolBarButton).Layout := cc.FLayout;

      cc.FControl.Parent := nil;
      cc.FControl.Visible := False;
    end;
  end;

  if Assigned(FCompactToolbar) then
  begin
    FCompactToolbar.Free;
    FCompactToolbar := nil;
  end;
end;

procedure TTMSFNCCustomToolBar.DoCompactClick;
begin
  if Assigned(OnCompactClick) then
    OnCompactClick(Self);
end;

procedure TTMSFNCCustomToolBar.DoCustomizeCompactToolBar(
  ACompactToolBar: TTMSFNCToolBar);
begin
  if Assigned(OnCustomizeCompactToolBar) then
    OnCustomizeCompactToolBar(Self, ACompactToolBar);
end;

procedure TTMSFNCCustomToolBar.DoCustomizeOptionsMenu;
begin
  if Assigned(OnOptionsMenuCustomize) then
    OnOptionsMenuCustomize(Self, FAutoOptionsMenu);
end;

procedure TTMSFNCCustomToolBar.DoCustomizeOptionsMenuItem(AControl: TControl; AMenuItem: TMenuItem);
begin
  if Assigned(OnOptionsMenuItemCustomize) then
    OnOptionsMenuItemCustomize(Self, AControl, AMenuItem);
end;

procedure TTMSFNCCustomToolBar.DoDragGripMoving(ADeltaX, ADeltaY: Double);
begin
  if Assigned(OnDragGripMoving) then
    OnDragGripMoving(Self, ADeltaX, ADeltaY);
end;

procedure TTMSFNCCustomToolBar.DoIsLastElement(AControl: TControl; var ALastElement: Boolean);
begin
  if Assigned(OnIsLastElement) then
    OnIsLastElement(Self, AControl, ALastElement);
end;

procedure TTMSFNCCustomToolBar.HandleQuickMenuButton;
begin
  if Assigned(OnQuickMenuButtonClick) then
    OnQuickMenuButtonClick(Self);
end;

function TTMSFNCCustomToolBar.HasHint: Boolean;
begin
  Result := inherited HasHint;
  if FQuickMenuButtonHover then
    Result := QuickMenuButtonHint <> '';
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBar.DoMatrixChanged(Sender: TObject);
begin
  inherited;
  UpdateDockPanel;
end;
{$ENDIF}

procedure TTMSFNCCustomToolBar.HandleMouseLeave;
begin
  inherited;
  FHoverP := False;
  FQuickMenuButtonHover := False;
  Cursor := crDefault;
  FInsideDrag := False;
  if FHoverP <> FHover then
  begin
    FHover := False;
    Invalidate;
  end;
end;

{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomToolBar.AlignControls(AControl: TControl; var Rect: TRect);
begin
  inherited;
  UpdateControls;
end;
{$ENDIF}

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBar.DoAddObject(const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.DoInsertObject(Index: Integer;
  const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.SetBounds(X, Y, AWidth, AHeight: Single);
var
  r: TRectF;
begin
  r := BoundsRect;
  inherited;
  if (csDesigning in ComponentState) and not ((csLoading in ComponentState) or (csReading in ComponentState)) then
  begin
    if ((r.Width <> AWidth) or (r.Height <> AHeight)) then
      UpdateControls;
  end
  else
    UpdateControls;
end;

procedure TTMSFNCCustomToolBar.DoRemoveObject(const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;
{$ENDIF}

procedure TTMSFNCCustomToolBar.DrawDragGrip(AGraphics: TTMSFNCGraphics);
var
  cnt: Integer;

  procedure DrawDots(ARect: TRectF);
  var
    i: integer;
    rdg: TRectF;
    sz: Integer;
  begin
    if State = esLarge then
      sz := ScalePaintValue(3)
    else
      sz := ScalePaintValue(2);

    ARect.Left := ARect.Left;
    ARect.Top := ARect.Top;
    cnt := Round(ARect.Bottom) div (Round(sz) * 2);
    for i := 1 to cnt do
    begin
      rdg := RectF(ARect.Left + ((ARect.Right - ARect.Left) - sz) / 2, ARect.Top + 1, ARect.Left + sz + ((ARect.Right - ARect.Left) - sz) / 2, ARect.Top + 1 + sz);
      rdg := RectF(int(rdg.Left), int(rdg.Top), int(rdg.Right), int(rdg.Bottom));
      AGraphics.DrawRectangle(rdg);
      ARect.Top := ARect.Top + sz * 2;
    end;
  end;
var
  r: TRectF;
begin
  AGraphics.Fill.Color := Appearance.DragGripColor;
  AGraphics.Fill.Kind := gfkSolid;
  r := GetDragGripRect;
  DrawDots(r);
end;

procedure TTMSFNCCustomToolBar.DrawText(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
begin
  if TextVisible and (Text <> '') then
  begin
    AGraphics.Font.Assign(Font);

    if not Enabled and (DisabledFontColor <> gcNull) then
      AGraphics.Font.Color := DisabledFontColor;

    r := GetTextRect;

    AGraphics.DrawText(r, Text, WordWrapping, HorizontalTextAlign, VerticalTextAlign, Trimming);
  end;
end;

function TTMSFNCCustomToolBar.DropDownActive: Boolean;
var
  I: Integer;
  c: TControl;
begin
  Result := False;
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];
    if c is TTMSFNCDefaultToolBarButton then
    begin
      if Assigned((c as TTMSFNCDefaultToolBarButton).FPopup) then
      begin
        Result := (c as TTMSFNCDefaultToolBarButton).FPopup.IsOpen;
        if Result then
          Break;
      end;
    end;
  end;
end;

function TTMSFNCCustomToolBar.GetBitmapContainer: TTMSFNCBitmapContainer;
begin
  Result := FBitmapContainer;
end;

function TTMSFNCCustomToolBar.GetBitmapPickerClass: TTMSFNCToolBarBitmapPickerClass;
begin
  Result := TTMSFNCToolBarBitmapPicker;
end;

function TTMSFNCCustomToolBar.GetCompactBitmapRect(ARect: TRectF): TRectF;
var
  r: TRectF;
  bs: Single;
begin
  r := ARect;
  Result := RectF(r.Left, r.Top, r.Right, r.Top);
  if CompactBitmapVisible then
  begin
    bs := GetCompactBitmapSize;
    if not TextVisible or (Text = '') then
    begin
      Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, r.Bottom - 3);
      if (bs <> -1) then
      begin
        Result.Left := Round(r.Left + ((r.Right - r.Left) - bs) / 2);
        Result.Top := Round(r.Top + ((r.Bottom - r.Top) - bs) / 2);
        Result.Right := Result.Left + bs;
        Result.Bottom := Result.Top + bs;
      end;
    end
    else if TextVisible and not (Text = '') then
      Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, r.Top + bs);
  end;
end;

function TTMSFNCCustomToolBar.GetCompactBitmapSize: Single;
var
  bmp: TTMSFNCBitmap;
begin
  Result := CompactBitmapSize;
  if CompactAutoBitmapSize then
  begin
    bmp := TTMSFNCGraphics.GetScaledBitmap(CompactBitmaps, 0, BitmapContainer);
    if Assigned(bmp) and not IsBitmapEmpty(bmp) then
      Result := Max(bmp.Height, bmp.Width);
  end;
end;

function TTMSFNCCustomToolBar.GetColorPickerClass: TTMSFNCToolBarColorPickerClass;
begin
  Result := TTMSFNCToolBarColorPicker;
end;

function TTMSFNCCustomToolBar.GetCompactControl(
  AControl: TControl): TTMSFNCToolBarControl;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to FCompactControls.Count - 1 do
  begin
    if TTMSFNCToolBarControl(FCompactControls[I]).FControl = AControl then
    begin
      Result := TTMSFNCToolBarControl(FCompactControls[I]);
      Break;
    end;
  end;
end;

function TTMSFNCCustomToolBar.GetCompactControlCount: Integer;
begin
  Result := FCompactControls.Count;
end;

function TTMSFNCCustomToolBar.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncuipack/components/' + LowerCase(ClassName);
end;

function TTMSFNCCustomToolBar.GetDragGripRect(AInteraction: Boolean = False): TRectF;
var
  r: TRectF;
  f: Single;
begin
  r := LocalRect;
  f := 1;
  if State = esLarge then
    f := 1.75;

  if AInteraction then
    Result := RectF(r.Left, r.Top, r.Left + ScalePaintValue(8 * f), r.Bottom)
  else
    Result := RectF(r.Left + ScalePaintValue(3), r.Top + ScalePaintValue(3), r.Left + ScalePaintValue(6 * f), r.Bottom - ScalePaintValue(3));
end;

function TTMSFNCCustomToolBar.GetFontNamePickerClass: TTMSFNCToolBarFontNamePickerClass;
begin
  Result := TTMSFNCToolBarFontNamePicker;
end;

function TTMSFNCCustomToolBar.GetFontSizePickerClass: TTMSFNCToolBarFontSizePickerClass;
begin
  Result := TTMSFNCToolBarFontSizePicker;
end;

function TTMSFNCCustomToolBar.GetHiddenControl(
  AControl: TControl): TTMSFNCToolBarControl;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to FHiddenControls.Count - 1 do
  begin
    if TTMSFNCToolBarControl(FHiddenControls[I]).FControl = AControl then
    begin
      Result := TTMSFNCToolBarControl(FHiddenControls[I]);
      Break;
    end;
  end;              
end;

function TTMSFNCCustomToolBar.GetHiddenControlCount(
  AControl: TControl): Integer;
var
  I: Integer;
  lst: TTMSFNCToolBarControlList;
begin
  lst := TTMSFNCToolBarControlList.Create;
  for I := 0 to FHiddenControls.Count - 1 do
    lst.Add(FHiddenControls[I]);

  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  lst.Sort(FCompareHiddenControls);
  {$ENDIF}
  {$ENDIF}
  Result := 0;
  for I := 0 to lst.Count - 1 do
  begin
    if TTMSFNCToolBarControl(lst[I]).FControl = AControl then
      Break
    else
      Inc(Result);
  end;
  lst.Free;
end;

function TTMSFNCCustomToolBar.GetHintString: String;
begin
  Result := inherited GetHintString;
  if FQuickMenuButtonHover then
    Result := QuickMenuButtonHint
end;

function TTMSFNCCustomToolBar.GetItemPickerClass: TTMSFNCToolBarItemPickerClass;
begin
  Result := TTMSFNCToolBarItemPicker;
end;

function TTMSFNCCustomToolBar.GetOptionsMenuButtonClass: TTMSFNCToolBarDropDownButtonClass;
begin
  Result := TTMSFNCToolBarDropDownButton;
end;

function TTMSFNCCustomToolBar.GetOptionsMenuButtonControl: TTMSFNCToolBarDropDownButton;
begin
  Result := FOptionsMenuButton;
end;

function TTMSFNCCustomToolBar.GetQuickMenuButtonRect: TRectF;
begin
  Result := RectF(Width - 16, Height - 16, Width, Height);
  if Appearance.Separator then
  begin
    Result.Left := Result.Left - Appearance.SeparatorStroke.Width;
    Result.Right := Result.Right - Appearance.SeparatorStroke.Width;
  end;
end;

{$IFDEF FNCLIB}
function TTMSFNCCustomToolBar.GetSubComponentArray: TTMSFNCStylesManagerComponentArray;
var
  I: Integer;
begin
  SetLength(Result, ControlCount + FHiddenControls.Count + 1);
  for I := 0 to ControlCount - 1 do
    Result[I] := Controls[I];

  for I := 0 to FHiddenControls.Count - 1 do
    Result[I + ControlCount] := FHiddenControls[I].FControl;

  Result[Length(Result) - 1] := FOptionsMenuButton;
end;
{$ENDIF}

function TTMSFNCCustomToolBar.GetCompactTextRect: TRectF;
var
  bmpr: TRectF;
  r: TRectF;
begin
  r := LocalRect;
  bmpr := GetCompactBitmapRect(r);
  Result := RectF(r.Left + 3, bmpr.Bottom + 3, r.Right - 3, r.Bottom - 23)
end;

function TTMSFNCCustomToolBar.GetTextRect: TRectF;
var
  r: TRectF;
  h, sz: Single;
begin
  sz := 0;
  if Appearance.DragGrip then
  begin
    if State = esLarge then
      sz := 3
    else
      sz := 2;
  end;
  r := LocalRect;
  r := RectF(r.Left + ScalePaintValue(sz), r.Top, r.Right, r.Bottom);
  InflateRectEx(r, ScalePaintValue(-2), ScalePaintValue(-2));

  h := GetTextSize.cy;

  Result := RectF(r.Left, r.Bottom - h, r.Right, r.Bottom);
end;

function TTMSFNCCustomToolBar.GetTextSize: TSizeF;
var
  g: TTMSFNCGraphics;
  sz: Single;
  r: TRectF;
begin
  Result.cx := 0;
  Result.cy := 0;
  if TextVisible and (Text <> '') then
  begin
    g := TTMSFNCGraphics.CreateBitmapCanvas(1, 1, NativeCanvas);
    if not NativeCanvas then
      g.BeginScene;
    g.BitmapContainer := BitmapContainer;
    g.OptimizedHTMLDrawing := OptimizedHTMLDrawing;
    try
      sz := 0;
      if Appearance.DragGrip then
      begin
        if State = esLarge then
          sz := 3
        else
          sz := 2;
      end;

      g.Font.Assign(Font);

      r := LocalRect;
      r := RectF(r.Left + sz, r.Top, r.Right, r.Bottom);
      InflateRectEx(r, -2, -2);
      Result := g.CalculateTextSize(Text, r, WordWrapping);
    finally
      if not NativeCanvas then
        g.EndScene;
      g.Free;
    end;
  end;
end;

function TTMSFNCCustomToolBar.GetToolBarButtonClass: TTMSFNCToolBarButtonClass;
begin
  Result := TTMSFNCToolBarButton;
end;

function TTMSFNCCustomToolBar.GetToolBarSeparatorClass: TTMSFNCToolBarSeparatorClass;
begin
  Result := TTMSFNCToolBarSeparator;
end;

function TTMSFNCCustomToolBar.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCCustomToolBar.UpdateToolBar(Sender: TObject);
begin
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.UpdateToolBarControl(Sender: TObject);
var
  tb: TTMSFNCToolBarControl;
  bmp: TTMSFNCBitmapHelperClass;
  c: TControl;
  tc: TControl;
  tci: Integer;
begin
  if not Assigned(Sender) then
    Exit;

  FBlockUpdate := True;

  c := Sender as TControl;

  tb := GetHiddenControl(c);
  if Assigned(tb) then
  begin
    tc := tb.FControl;
    tci := Max(0, Min(ControlCount, tb.FControlIndex - GetHiddenControlCount(tc)));
    FHiddenControls.Remove(tb);
    InsertToolBarControl(tc, tci);
    tc.Visible := True;
  end
  else
  begin
    tb := TTMSFNCToolBarControl.Create;

    if c is TTMSFNCCustomToolBarElement then
      tb.FControlIndex := (c as TTMSFNCCustomToolBarElement).ControlIndex
    else
      tb.FControlIndex := c.Tag;

    tb.FControl := c;
    FBlockUpdate := True;
    bmp := c.MakeScreenshot;
    FBlockUpdate := False;
    tb.FBitmap.Assign(bmp);
    bmp.Free;
    FHiddenControls.Add(tb);
    c.Parent := nil;
    c.Visible := False;
  end;

  FBlockUpdate := False;
  UpdateControls;
end;

function TTMSFNCCustomToolBar.XYToAnchor(AX, AY: Single): string;
var
  r: TRectF;
  g: TTMSFNCGraphics;
begin
  Result := '';
  r := GetTextRect;

  g := TTMSFNCGraphics.CreateBitmapCanvas;
  g.BeginScene;
  g.BitmapContainer := BitmapContainer;
  try
    g.Font.Assign(Font);
    Result := g.DrawText(r, FText, FWordWrapping, FHorizontalTextAlign, FVerticalTextAlign, FTrimming, 0, -1, -1, True, True, AX, AY);
  finally
    g.EndScene;
    g.Free;
  end;
end;

procedure TTMSFNCCustomToolBar.InitializeOptionsMenu;
{$IFDEF WEBLIB}
begin
{$ENDIF}
{$IFNDEF WEBLIB}
var
  mnu: TTMSFNCToolBarOptionMenuItem;
  bmp: TTMSFNCBitmapHelperClass;
  I: Integer;
  c: TControl;
  lst: TTMSFNCControlList;
  tb: TTMSFNCToolBarControl;
  sh: Boolean;
  bmpw, bw, bh: Single;
  {$IFDEF FMXLIB}
  o: TFmxObject;
  {$ENDIF}
  maxh: Single;
begin
  lst := nil;
  try
    lst := TTMSFNCControlList.Create;
    for I := 0 to Self.ControlCount - 1 do
      lst.Add(Controls[I]);

    for I := 0 to FHiddenControls.Count - 1 do
      lst.Add(TTMSFNCToolBarControl(FHiddenControls[I]).FControl);

    {$IFNDEF LCLLIB}
    {$IFNDEF WEBLIB}
    lst.Sort(FCompareControls);
    {$ENDIF}
    {$ENDIF}

    {$IFDEF FMXLIB}
    FAutoOptionsMenu.Clear;
    {$ENDIF}
    {$IFDEF CMNLIB}
    FAutoOptionsMenu.Items.Clear;
    {$ENDIF}

    FTotalOptionsMenuWidth := 0;

    for I := 0 to lst.Count - 1 do
    begin
      c := TControl(lst[I]);

      {$IFDEF FMXLIB}
      if Supports(c, IDesignerControl) then
        Continue;
      {$ENDIF}

      if not (c = FOptionsMenuButton) and not (c is TTMSFNCCustomToolBarSeparator) then
      begin
        sh := True;
        DoCanShowOptionsMenuItem(c, sh);
        if sh then
        begin
          mnu := TTMSFNCToolBarOptionMenuItem.Create(FAutoOptionsMenu);
          mnu.OnClick := @OptionMenuItemClick;
          {$IFDEF FMXLIB}
          mnu.OnApplyStyleLookup := @OptionMenuItemApplyStyleLookup;
          mnu.Calculate := True;
          mnu.ApplyStyleLookup;
          {$ENDIF}

          bmpw := 0;
          bw := 0;
          bh := 0;
          {$IFDEF FMXLIB}
          o := mnu.FindStyleResource('checkmark');
          if Assigned(o) and (o is TControl) then
            bmpw := (o as TControl).Width;
          {$ENDIF}

          maxh := 20;
          if OptionsMenu.ShowItemBitmap then
          begin
            tb := GetHiddenControl(c);
            if Assigned(tb) then
            begin
              bmp := tb.FBitmap;
              mnu.Bitmap.Assign(bmp);
              bw := bmp.Width;
              bh := bmp.Height;
            end
            else
            begin
              FBlockUpdate := True;
              bmp := c.MakeScreenshot;
              FBlockUpdate := False;
              mnu.Bitmap.Assign(bmp);
              bw := bmp.Width;
              bh := bmp.Height;
              bmp.Free;
            end;
          end;

          TTMSFNCGraphics.GetAspectSize(bw, bh, bw, bh, bw, maxh, True, False, False);
          bmpw := bmpw + int(bw);

          if OptionsMenu.ShowItemText then
          begin
            if c is TTMSFNCCustomToolBarButton then
              mnu.Text := (c as TTMSFNCCustomToolBarButton).AutoOptionsMenuText;

            if mnu.Text = '' then
              mnu.Text := c.Name;
          end;

          mnu.Control := c;
          mnu.IsChecked := Assigned(c.Parent);

          DoCustomizeOptionsMenuItem(c, mnu);

          {$IFDEF FMXLIB}
          FAutoOptionsMenu.AddObject(mnu);
          {$ENDIF}
          {$IFDEF CMNLIB}
          FAutoOptionsMenu.Items.Add(mnu);
          {$ENDIF}
          FTotalOptionsMenuWidth := Max(FTotalOptionsMenuWidth, bmpw);
        end;
      end;
    end;

    {$IFDEF FMXLIB}
    for I := 0 to FAutoOptionsMenu.ItemsCount - 1 do
    {$ENDIF}
    {$IFDEF CMNLIB}
    for I := 0 to FAutoOptionsMenu.Items.Count - 1 do
    {$ENDIF}
    begin
      if FAutoOptionsMenu.Items[I] is TTMSFNCToolBarOptionMenuItem then
      begin
        mnu := (FAutoOptionsMenu.Items[I] as TTMSFNCToolBarOptionMenuItem);
        {$IFDEF FMXLIB}
        mnu.NeedStyleLookup;
        mnu.Calculate := False;
        {$ENDIF}
        if OptionsMenu.AutoItemBitmapWidth then
          mnu.GlyphWidth := FTotalOptionsMenuWidth
        else
          mnu.GlyphWidth := OptionsMenu.ItemBitmapWidth;
      end;
    end;

  finally
    if Assigned(lst) then
      lst.Free;
  end;
{$ENDIF}
end;

procedure TTMSFNCCustomToolBar.InsertToolBarControl(AControl: TControl;
  AIndex: Integer);
begin
  {$IFDEF FMXLIB}
  if (AIndex >= 0) and (AIndex <= Self.ControlCount - 1) then
    InsertObject(AIndex, AControl)
  else
    AddObject(AControl);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  AControl.Parent := Self;
  if AIndex > -1 then
    SetChildOrder(AControl, AIndex);
  {$ENDIF}

  if Assigned(OnInternalInsertControl) then
    OnInternalInsertControl(AControl);
end;

function TTMSFNCCustomToolBar.IsCompactBitmapSizeStored: Boolean;
begin
  Result := CompactBitmapSize <> 24;
end;

function TTMSFNCCustomToolBar.IsCompactWidthStored: Boolean;
begin
  Result := CompactWidth <> 50;
end;

function TTMSFNCCustomToolBar.IsMinimumWidthStored: Boolean;
begin
  Result := MinimumWidth <> 30;
end;

procedure TTMSFNCCustomToolBar.Loaded;
begin
  inherited;
  {$IFDEF FMXLIB}
  if (csDesigning in ComponentState) or (FFirstLoad) then
    UpdateControls;
  {$ENDIF}
end;

procedure TTMSFNCCustomToolBar.HandleCompact;
var
  I: Integer;
  cc: TTMSFNCToolBarControl;
begin
  inherited;

  DeactivateAllPopups;

  if Assigned(FCompactToolbar) then
  begin
    FCompactToolbar.Free;
    FCompactToolbar := nil;
  end;

  if Assigned(FCompactPopup) then
  begin
    FCompactPopup.Free;
    FCompactPopup := nil;
  end;

  FCompactPopup := TTMSFNCToolBarPopup.Create(Self);
  FCompactPopup.OnClosePopup := @DoCloseCompactPopup;

  FCompactToolbar := TTMSFNCToolBar.Create(FCompactPopup);

  {$IFDEF VCLLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION >= 33}
  FCompactToolbar.ScaleForPPI(CurrentPPI);
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}

  FCompactToolbar.Assign(Self);
  FCompactToolbar.Compact := False;
  FCompactToolbar.AutoSize := True;
  FCompactToolbar.AutoHeight := False;
  FCompactToolbar.AutoWidth := True;
  FCompactToolbar.AutoStretchHeight := False;
  FCompactToolbar.Appearance.Separator := False;
  FCompactToolbar.SetControlMargins(1, 1, 1, 1);
  FCompactToolbar.Height := Height + 2;

  DoCustomizeCompactToolBar(FCompactToolBar);

  for I := FCompactControls.Count - 1 downto 0 do
  begin
    cc := TTMSFNCToolBarControl(FCompactControls[I]);
    if Assigned(cc.FControl) then
    begin
      if cc.FControl is TTMSFNCDefaultToolBarButton then
        (cc.FControl as TTMSFNCDefaultToolBarButton).Layout := (cc.FControl as TTMSFNCDefaultToolBarButton).CompactLayout;
      cc.FControl.Visible := True;
      cc.FControl.Parent := FCompactToolbar;
    end;
  end;

  FCompactToolbar.UpdateControls;
  FCompactPopup.PlacementControl := Self;
  FCompactPopup.ContentControl := FCompactToolbar;
  FCompactPopup.IsOpen := True;
  DoCompactClick;
end;

procedure TTMSFNCCustomToolBar.HandleDblClick(X, Y: Single);
begin
  inherited;
  if Assigned(OnInternalDblClick) then
    OnInternalDblClick(Self);
end;

procedure TTMSFNCCustomToolBar.HandleMouseDown(Button: TTMSFNCMouseButton;
  Shift: TShiftState; X, Y: Single);
begin
  inherited;
  if Appearance.DragGrip and not FDragGripMoving then
  begin
    FDragGripDown := PtInRectEx(GetDragGripRect(True), PointF(X, Y));
    FDragGripDownPt := PointF(X, Y);
  end;

  if not FDragGripDown then
  begin
    if Compact then
    begin
      FDown := True;
      Invalidate;
      CaptureEx;
    end
    else if QuickMenuButton then
    begin
      FQuickMenuButtonDown := PtInRectEx(GetQuickMenuButtonRect, PointF(X, Y));
      if FQuickMenuButtonDown then
      begin
        Invalidate;
        CaptureEx;
      end;
    end;
  end;

  if Assigned(OnInternalMouseDown) and not (Button = TTMSFNCMouseButton.mbRight) then
    OnInternalMouseDown(Self);
end;

procedure TTMSFNCCustomToolBar.HandleMouseMove(Shift: TShiftState; X, Y: Single);
var
  r: TRectF;
  absx, absy: Single;
  pt: TPointF;
  d: TTMSFNCCustomDockPanel;
  a: string;
begin
  inherited;

  if Compact then
  begin
    FHoverP := FHover;
    FHover := True;
    if FHover <> FHoverP then
      Invalidate;
  end
  else if QuickMenuButton then
  begin
    FQuickMenuButtonHoverP := FQuickMenuButtonHover;
    FQuickMenuButtonHover := PtInRectEx(GetQuickMenuButtonRect, PointF(X, Y));
    if FQuickMenuButtonHover <> FQuickMenuButtonHoverP then
      Invalidate;
  end;

  if Appearance.DragGrip then
  begin
    if FDragGripDown then
    begin
      if not FDragGripMoving then
      begin
        CaptureEx;
        FDragGripMoving := True;
      end;

      if FDragGripMoving then
      begin
        absx := (FDragGripDownPt.X - X);
        absy := (FDragGripDownPt.Y - Y);
        if AutoMoveToolBar then
        begin
          {$IFDEF FMXLIB}
          pt := PointF(Position.Point.X - absx, Position.Point.Y - absy);
          {$ENDIF}
          {$IFDEF CMNWEBLIB}
          pt := PointF(Left - absx, Top - absy);
          {$ENDIF}

          if Parent is TTMSFNCCustomDockPanel then
          begin
            d := Parent as TTMSFNCCustomDockPanel;
            if d.AutoAlign then
            begin
              if pt.Y < d.Appearance.Margins.Top then
                pt.Y := Round(d.Appearance.Margins.Top);
              if pt.X < d.Appearance.Margins.Left then
                pt.X := Round(d.Appearance.Margins.Left)
              else if pt.X + Width > d.Width - d.Appearance.Margins.Right then
                pt.X := Round(d.Width - d.Appearance.Margins.Right - Width);

              SetBounds(Round(pt.X), Round(pt.Y), Width, Height);
            end;
          end;
        end;
        FDragGripDownPt := PointF(X + absx, Y + absy);
        DoDragGripMoving(absx, absy);
      end;
    end
    else
    begin
      r := GetDragGripRect(True);
      if PtInRectEx(r, PointF(X, Y)) then
      begin
        if not FInsideDrag then
        begin
          FInsideDrag := True;
          Cursor := crSize;
        end;
      end
      else if FInsideDrag then
      begin
        FInsideDrag := False;
        Cursor := crDefault;
      end;
    end;
  end;

  a := XYToAnchor(X, Y);

  if a <> '' then
    Cursor := crHandPoint
  else if (Cursor = crHandPoint) then
    Cursor := crDefault;

  if Assigned(OnInternalMouseMove) then
    OnInternalMouseMove(Self);
end;

procedure TTMSFNCCustomToolBar.HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState;
  X, Y: Single);
var
  a: string;
begin
  inherited;
  if FDragGripDown then
    ReleaseCaptureEx
  else if FDown and Compact then
  begin
    Invalidate;
    ReleaseCaptureEx;
    HandleCompact;
  end
  else if FQuickMenuButtonDown and QuickMenuButton and not Compact then
  begin
    Invalidate;
    ReleaseCaptureEx;
    HandleQuickMenuButton;
  end;

  FDragGripDown := False;
  FDragGripMoving := False;
  FDown := False;
  FQuickMenuButtonDown := False;

  a := XYToAnchor(X, Y);
  if a <> '' then
    DoAnchorClick(a);

  if Assigned(OnInternalMouseUp) and not (Button = TTMSFNCMouseButton.mbRight) then
    OnInternalMouseUp(Self);
end;

procedure TTMSFNCCustomToolBar.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited;
  if (Operation = opRemove) and (AComponent = FBitmapContainer) then
    FBitmapContainer := nil;

  if (Operation = opRemove) and (AComponent = FCustomOptionsMenu) then
    FCustomOptionsMenu := nil;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBar.OptionMenuItemApplyStyleLookup(Sender: TObject);
var
  c: TControl;
begin
  c := nil;
  if (Sender is TTMSFNCToolBarOptionMenuItem) then
    c := (Sender as TTMSFNCToolBarOptionMenuItem).FControl;

  if Assigned(OnOptionsMenuItemApplyStyle) and (Sender is TMenuItem) then
    OnOptionsMenuItemApplyStyle(Self, c, Sender as TMenuItem);
end;
{$ENDIF}

procedure TTMSFNCCustomToolBar.OptionMenuItemClick(Sender: TObject);
var
  a: Boolean;
  c: TControl;
begin
  a := True;
  c := nil;
  if (Sender is TTMSFNCToolBarOptionMenuItem) then
    c := (Sender as TTMSFNCToolBarOptionMenuItem).FControl;

  if Assigned(OnOptionsMenuItemClick) and (Sender is TMenuItem) then
    OnOptionsMenuItemClick(Self, c, Sender as TMenuItem, a);

  if a then
    UpdateToolBarControl(c);
end;

procedure TTMSFNCCustomToolBar.OptionsButtonClick(Sender: TObject);
var
  pt: TPointF;
begin
  if Assigned(OnOptionsMenuButtonClick) then
    OnOptionsMenuButtonClick(Self)
  else
  begin
    {$IFDEF FMXLIB}
    pt := FOptionsMenuButton.Position.Point;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    pt := PointF(FOptionsMenuButton.Left, FOptionsMenuButton.Top);
    {$ENDIF}
    pt := LocalToScreenEx(PointF(pt.X, pt.Y + FOptionsMenuButton.Height));
    ShowOptionsMenu(pt.X, pt.Y);
  end;
end;

procedure TTMSFNCCustomToolBar.QuickMenuButtonAppearanceChanged(
  Sender: TObject);
begin
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.QuickMenuButtonBitmapsChanged(
  Sender: TObject);
begin
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.ResetToDefaultStyle;
begin
  inherited;
  Appearance.DragGripColor := gcLightgray;
  Appearance.Fill.Color := gcWhite;
  Appearance.Stroke.Color := gcGray;
  Appearance.Fill.Kind := gfkGradient;
  Appearance.Stroke.Kind := gskSolid;
  Appearance.Fill.Color := gcWhite;
  Appearance.Fill.ColorTo := MakeGraphicsColor(230, 230, 230);
end;

procedure TTMSFNCCustomToolBar.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  qr, r: TRectF;
  w: Single;  
begin
  inherited;

  r := LocalRect;

  if Compact then
  begin
    if FDown then
    begin
      AGraphics.Fill.Assign(CompactAppearance.DownFill);
      AGraphics.Stroke.Assign(CompactAppearance.DownStroke);
    end
    else if FHover then
    begin
      AGraphics.Fill.Assign(CompactAppearance.HoverFill);
      AGraphics.Stroke.Assign(CompactAppearance.HoverStroke);
    end
    else
    begin
      AGraphics.Fill.Assign(CompactAppearance.NormalFill);
      AGraphics.Stroke.Assign(CompactAppearance.NormalStroke);
    end;

    if CompactAppearance.FlatStyle then
      AGraphics.Fill.Kind := gfkSolid;

    AGraphics.DrawRectangle(RectF(r.Left, r.Top + 2, r.Right - 3, r.Bottom - 2));
  end
  else
  begin
    AGraphics.Fill.Assign(Appearance.Fill);
    AGraphics.Stroke.Assign(Appearance.Stroke);

    if Appearance.FlatStyle then
      AGraphics.Fill.Kind := gfkSolid;

    AGraphics.DrawRectangle(r);
  end;

  if Compact then
  begin
    DrawCompactBitmap(AGraphics, ARect);
    DrawCompactText(AGraphics);
    DrawCompactExpander(AGraphics);
  end
  else
  begin
    if Appearance.DragGrip then
      DrawDragGrip(AGraphics);

    DrawText(AGraphics);

    if QuickMenuButton then
    begin
      if FQuickMenuButtonDown then
      begin
        AGraphics.Fill.Assign(QuickMenuButtonAppearance.DownFill);
        AGraphics.Stroke.Assign(QuickMenuButtonAppearance.DownStroke);
      end
      else if FQuickMenuButtonHover then
      begin
        AGraphics.Fill.Assign(QuickMenuButtonAppearance.HoverFill);
        AGraphics.Stroke.Assign(QuickMenuButtonAppearance.HoverStroke);
      end
      else
      begin
        AGraphics.Fill.Assign(QuickMenuButtonAppearance.NormalFill);
        AGraphics.Stroke.Assign(QuickMenuButtonAppearance.NormalStroke);
      end;

      if QuickMenuButtonAppearance.FlatStyle then
        AGraphics.Fill.Kind := gfkSolid;
      
      qr := GetQuickMenuButtonRect;
      AGraphics.DrawRectangle(qr);

      InflateRectEx(qr, -2, -2);
      AGraphics.DrawScaledBitmap(qr, QuickMenuButtonBitmaps);      
    end;
  end;

  if Appearance.Separator then
  begin
    AGraphics.Stroke.Assign(Appearance.SeparatorStroke);
    w := Appearance.SeparatorStroke.Width;
    AGraphics.DrawLine(PointF(r.Right - w, r.Top + 4), PointF(r.Right - w, r.Bottom - 4));
  end;

  if IsDesignTime and CanDrawDesignTime then
    AGraphics.DrawFocusRectangle(ARect, gcBlack);
end;

procedure TTMSFNCCustomToolBar.DrawCompactBitmap(AGraphics: TTMSFNCGraphics;
  ARect: TRectF);
var
  r: TRectF;
begin
  r := GetCompactBitmapRect(ARect);
  AGraphics.BitmapContainer := BitmapContainer;
  AGraphics.DrawScaledBitmap(r, CompactBitmaps)
end;

procedure TTMSFNCCustomToolBar.DrawCompactExpander(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
begin
  r := LocalRect;
  r := RectF(r.Left, r.Bottom - 20, r.Right, r.Bottom);
  InflateRectEx(r, -2, -2);
  AGraphics.DrawScaledBitmap(r, CompactExpanderBitmaps);
end;

procedure TTMSFNCCustomToolBar.DrawCompactText(AGraphics: TTMSFNCGraphics);
var
  tr: TRectF;
  st: TTMSFNCGraphicsSaveState;
begin
  if not TextVisible or (Text = '') then
    Exit;

  tr := GetCompactTextRect;
  st := AGraphics.SaveState;
  try
    AGraphics.ClipRect(tr);
    AGraphics.Font.Assign(Font);
    AGraphics.DrawText(tr, Text, WordWrapping, HorizontalTextAlign, VerticalTextAlign, Trimming);
  finally
    AGraphics.RestoreState(st);
  end;
end;

procedure TTMSFNCCustomToolBar.UncompactControls;
var
  I: Integer;
  cc: TTMSFNCToolBarControl;
  c: TControl;
begin
  FBlockUpdate := True;
  for I := FCompactControls.Count - 1 downto 0 do
  begin
    cc := TTMSFNCToolBarControl(FCompactControls[I]);
    c := cc.FControl;
    if Assigned(c) then
    begin
      if c is TTMSFNCCustomToolBarElement then
        (c as TTMSFNCCustomToolBarElement).FBlockUpdate := True;
      c.Parent := Self;
      c.Visible := True;
      if c is TTMSFNCCustomToolBarElement then
        (c as TTMSFNCCustomToolBarElement).FBlockUpdate := False;
      {$IFDEF VCLLIB}
      {$HINTS OFF}
      {$IF COMPILERVERSION >= 33}
      c.ScaleForPPI(CurrentPPI);
      {$IFEND}
      {$HINTS ON}
      {$ENDIF}
    end;
  end;

  FBlockUpdate := False;
  UpdateControls;

  Invalidate;
end;

procedure TTMSFNCCustomToolBar.UpdateControlAfterResize;
begin
  inherited;
  UpdateDockPanel;
end;

procedure TTMSFNCCustomToolBar.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomToolBar.SetAppearance(
  const Value: TTMSFNCToolBarAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetOptionsMenu(
  const Value: TTMSFNCToolBarOptionsMenu);
begin
  FOptionsMenu.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetQuickMenuButton(const Value: Boolean);
begin
  if FQuickMenuButton <> Value then
  begin
    FQuickMenuButton := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetQuickMenuButtonAppearance(
  const Value: TTMSFNCToolBarQuickMenuButtonAppearance);
begin
  FQuickMenuButtonAppearance.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetQuickMenuButtonBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FQuickMenuButtonBitmaps.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetState(const Value: TTMSFNCToolBarElementState);
var
  I: Integer;
  c: TControl;
begin
  if FState <> Value then
  begin
    FState := Value;
    for I := 0 to Self.ControlCount - 1 do
    begin
      c := Self.Controls[I];
      if c is TTMSFNCCustomToolBarElement then
        (c as TTMSFNCCustomToolBarElement).State := FState;
    end;
  end;
end;

procedure TTMSFNCCustomToolBar.SetText(const Value: string);
begin
  if FText <> Value then
  begin
    FText := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetTextVisible(const Value: Boolean);
begin
  if FTextVisible <> Value then
  begin
    FTextVisible := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetTrimming(
  const Value: TTMSFNCGraphicsTextTrimming);
begin
  if FTrimming <> Value then
  begin
    FTrimming := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetVerticalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FVerticalTextAlign <> Value then
  begin
    FVerticalTextAlign := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetWordWrapping(const Value: Boolean);
begin
  if FWordWrapping <> Value then
  begin
    FWordWrapping := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetAutoAlign(const Value: Boolean);
begin
  if FAutoAlign <> Value then
  begin
    FAutoAlign := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetAutoHeight(const Value: Boolean);
begin
  if FAutoHeight <> Value then
  begin
    FAutoHeight := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetAutoStretchHeight(const Value: Boolean);
begin
  if FAutoStretchHeight <> Value then
  begin
    FAutoStretchHeight := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetAutoWidth(const Value: Boolean);
begin
  if FAutoWidth <> Value then
  begin
    FAutoWidth := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
var
  I: Integer;
  {$IFDEF FNCLIB}
  c: TControl;
  b: ITMSFNCBitmapContainer;
  {$ENDIF}
begin
  FBitmapContainer := Value;
  for I := 0 to Self.ControlCount - 1 do
  begin
    {$IFDEF FNCLIB}
    {$IFNDEF WEBLIB}
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}
    {$ENDIF}
    {$ENDIF}

    {$IFDEF FNCLIB}
    if Supports(c, ITMSFNCBitmapContainer, b) then
      b.BitmapContainer := Value;
    {$ENDIF}
  end;
  Invalidate;
end;

procedure TTMSFNCCustomToolBar.SetCanCompact(const Value: Boolean);
begin
  if FCanCompact <> Value then
    FCanCompact := Value;
end;

procedure TTMSFNCCustomToolBar.SetCompact(const Value: Boolean);
begin
  if FCompact <> Value then
  begin
    if CanCompact then
    begin
      FCompact := Value;
      if Compact then
      begin
        FOldMenuButtonState := OptionsMenu.ShowButton;
        OptionsMenu.ShowButton := False;
        FOldWidth := Width;
        CompactControls;
        Width := Round(CompactWidth);
      end
      else
      begin
        Width := Round(FOldWidth);
        UncompactControls;
        OptionsMenu.ShowButton := FOldMenuButtonState;
      end;

      UpdateControls;
    end;
  end;
end;

procedure TTMSFNCCustomToolBar.SetCompactAppearance(
  const Value: TTMSFNCToolBarCompactAppearance);
begin
  FCompactAppearance.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetCompactAutoBitmapSize(const Value: Boolean);
begin
  if FCompactAutoBitmapSize <> Value then
  begin
    FCompactAutoBitmapSize := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetCompactBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FCompactBitmaps.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetCompactBitmapSize(const Value: Single);
begin
  if FCompactBitmapSize <> Value then
  begin
    FCompactBitmapSize := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetCompactBitmapVisible(const Value: Boolean);
begin
  if FCompactBitmapVisible <> Value then
  begin
    FCompactBitmapVisible := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetCompactExpanderBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FCompactExpanderBitmaps.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetCompactWidth(const Value: Single);
begin
  if FCompactWidth <> Value then
  begin
    FCompactWidth := Value;
    if Compact then
      Width := Round(CompactWidth);
  end;
end;

procedure TTMSFNCCustomToolBar.SetDisabledFontColor(
  const Value: TTMSFNCGraphicsColor);
begin
  if FDisabledFontColor <> Value then
  begin
    FDisabledFontColor := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetFont(const Value: TTMSFNCGraphicsFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCCustomToolBar.SetHorizontalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FHorizontalTextAlign <> Value then
  begin
    FHorizontalTextAlign := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBar.SetMinimumWidth(const Value: Single);
begin
  if FMinimumWidth <> Value then
  begin
    FMinimumWidth := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBar.SetAS(const Value: Boolean);
begin
  if FAutoSize <> Value then
  begin
    FAutoSize := Value;
    UpdateControls;
  end;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBar.SetVisible(const Value: Boolean);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomToolBar.VisibleChanging;
{$ENDIF}
begin
  inherited;
  UpdateDockPanel;
end;

procedure TTMSFNCCustomToolBar.ShowOptionsMenu(X, Y: Single);
begin
  {$IFDEF FMXLIB}
  if not Assigned(CustomOptionsMenu) then
  begin
    InitializeOptionsMenu;
    DoCustomizeOptionsMenu;
    if FAutoOptionsMenu.ItemsCount > 0 then
      FAutoOptionsMenu.Popup(X, Y);
  end
  else
    CustomOptionsMenu.Popup(X, Y);
 {$ENDIF}
 {$IFDEF CMNLIB}
  if not Assigned(CustomOptionsMenu) then
  begin
    InitializeOptionsMenu;
    DoCustomizeOptionsMenu;
    if FAutoOptionsMenu.Items.Count > 0 then
      FAutoOptionsMenu.Popup(Round(X), Round(Y));
  end
  else
    CustomOptionsMenu.Popup(Round(X), Round(Y));
  {$ENDIF}
end;

procedure TTMSFNCCustomToolBar.UpdateControls;
var
  I: Integer;
  c: TControl;
  idx: Integer;
  fu: Boolean;
  hc: TTMSFNCToolBarControl;
  {$IFDEF FMXLIB}
  maxx, x, w, y, h, hs, hsm, vs, xs, ys, txth, txtw: Single;
  mgr: TBounds;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  maxx, x, w, y, h, hs, hsm, vs, xs, ys, txth, txtw: Integer;
  {$ENDIF}
  {$IFDEF LCLLIB}
  mgr: TControlBorderSpacing;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  mgr: TMargins;
  {$ENDIF}
  l: Boolean;
  {$IFDEF FNCLIB}
  ia: ITMSFNCAdaptToStyle;
  {$ENDIF}
  sz: TSizeF;
  cn: TControl;
  lm, tm, rm, bm: Single;

  function GetControl(AIndex: Integer): TControl;
  begin
    Result := nil;

    if (AIndex >= 0) and (AIndex <= Self.ControlCount - 1) then
    begin
      if Self.Controls[AIndex].Visible then
      begin
        Result := Self.Controls[AIndex];
        Exit;
      end;
    end;

    while (AIndex >= 0) and (AIndex <= Self.ControlCount - 1) do
    begin
      Inc(AIndex);
      if (AIndex >= 0) and (AIndex <= Self.ControlCount - 1) then
      begin
        if Self.Controls[AIndex].Visible then
        begin
          Result := Self.Controls[AIndex];
          Exit;
        end;
      end;
    end;
  end;

  function IsLoadingEx: Boolean;
  var
    ii: Integer;
    ctl: TControl;
  begin
    Result := CheckIsLoading;
    if not Result then
    begin
      for ii := ControlCount - 1 downto 0 do
      begin
        ctl := Controls[ii];
        if (csLoading in ctl.ComponentState) then
        begin
          Result := True;
          Exit;
        end;
      end;
    end;
  end;

begin
  if FBlockUpdate or FBlockResize or IsLoadingEx or IsDestroying or not CanBuildControls then
    Exit;

  FFirstLoad := False;

  FBlockUpdate := True;
  {$IFDEF FMXLIB}
  BeginUpdate;
  hs := Appearance.HorizontalSpacing;
  vs := Appearance.VerticalSpacing;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  hs := Round(Appearance.HorizontalSpacing);
  vs := Round(Appearance.VerticalSpacing);
  {$ENDIF}

  x := hs;
  if Appearance.DragGrip then
  begin
    {$IFDEF FMXLIB}
    x := x + GetDragGripRect.Right;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    x := x + Round(GetDragGripRect.Right);
    {$ENDIF}
    if hs = 0 then
      x := x + ScalePaintValue(3);
  end;

  y := vs;

  xs := x;
  ys := y;

  hsm := ScalePaintValue(30);
  txth := 0;
  txtw := 0;
  sz := GetTextSize;
  if sz.cy > 0 then
    txth := Round(sz.cy + ScalePaintValue(4));

  if sz.cx > 0 then
    txtw := Round(sz.cx + ScalePaintValue(8));

  w := txtw;
  maxx := 0;
  h := 0;
  idx := 0;

  fu := False;
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    hc := GetHiddenControl(c);
    fu := not Assigned(hc);
    if fu then
      Break;
  end;

  l := False;
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    {$IFDEF FNCLIB}
    if Supports(c, ITMSFNCAdaptToStyle, ia) then
      ia.AdaptToStyle := AdaptToStyle;
    {$ENDIF}

    if l then
    begin
      x := xs;
      y := h;
      ys := y;
    end;

    l := False;
    if c is TTMSFNCCustomToolBarElement then
    begin
      l := (c as TTMSFNCCustomToolBarElement).LastElement;
      (c as TTMSFNCCustomToolBarElement).OnUpdateToolBar := @UpdateToolBar;
      (c as TTMSFNCCustomToolBarElement).OnUpdateToolBarControl := @UpdateToolBarControl;
    end;

    DoIsLastElement(c, l);

    if not (c = FOptionsMenuButton) then
    begin
      if fu then
      begin
        if c is TTMSFNCCustomToolBarElement then
          (c as TTMSFNCCustomToolBarElement).ControlIndex := idx
        else
          c.Tag := idx;
      end;

      if c.Visible then
      begin
        {$IFDEF FMXLIB}
        if AutoAlign then
        begin
          c.Position.X := x + c.Margins.Left;
          c.Position.Y := y + c.Margins.Top;
        end;

        if AutoStretchHeight or ((c is TTMSFNCDefaultToolBarButton) and ((c as TTMSFNCDefaultToolBarButton).Layout = bblLarge)) then
        begin
          h := Height - c.Margins.Bottom - txth - y;
          c.Height := h;
        end
        else
          h := Max(h, c.Position.y + c.Height + vs + c.Margins.Bottom);

        cn := GetControl(I + 1);
        if Assigned(cn) and (cn is TTMSFNCDefaultToolBarButton) then
        begin
          case (cn as TTMSFNCDefaultToolBarButton).Layout of
            bblBitmap, bblLabel:
            begin
              y := Max(y, c.Position.Y + c.Height + vs + c.Margins.Bottom);
              if y + cn.Margins.Top + cn.Height > Height - cn.Margins.Bottom - txth then
              begin
                x := Max(x, Max(maxx, c.Position.x + c.Width + hs + c.Margins.Right));
                y := ys;
              end
              else
              begin
                c.Position.X := x + c.Margins.Left;
                maxx := Max(x, Max(maxx, c.Position.x + c.Width + hs + c.Margins.Right));
              end;
            end;
            bblNone, bblLarge:
            begin
              y := ys;
              x := Max(x, c.Position.x + c.Width + hs + c.Margins.Right);
            end;
          end;
        end
        else
        begin
          y := ys;
          x := Max(x, Max(maxx, c.Position.x + c.Width + hs + c.Margins.Right));
        end;

        {$ENDIF}
        {$IFDEF VCLWEBLIB}
        if c.AlignWithMargins then
        begin
          if AutoAlign then
          begin
            c.Left := x + c.Margins.Left;
            c.Top := y + c.Margins.Top;
          end;

          if AutoStretchHeight or ((c is TTMSFNCDefaultToolBarButton) and ((c as TTMSFNCDefaultToolBarButton).Layout = bblLarge)) then
          begin
            h := Height - c.Margins.Bottom - txth - y;
            c.Height := h;
          end
          else
            h := Max(h, c.Top + c.Height + vs + c.Margins.Bottom);

          cn := GetControl(I + 1);
          if Assigned(cn) and (cn is TTMSFNCDefaultToolBarButton) then
          begin
            case (cn as TTMSFNCDefaultToolBarButton).Layout of
              bblBitmap, bblLabel:
              begin
                y := Max(y, c.Top + c.Height + vs + c.Margins.Bottom);
                if y + cn.Margins.Top + cn.Height > Height - cn.Margins.Bottom - txth then
                begin
                  x := Max(x, Max(maxx, c.Left + c.Width + hs + c.Margins.Right));
                  y := ys;
                end
                else
                begin
                  c.Left := x + c.Margins.Left;
                  maxx := Max(x, Max(maxx, c.Left + c.Width + hs + c.Margins.Right));
                end;
              end;
              bblNone, bblLarge:
              begin
                x := Max(x, c.Left + c.Width + hs + c.Margins.Right);
                y := ys;
              end;
            end;
          end
          else
          begin
            x := Max(x, Max(maxx, c.Left + c.Width + hs + c.Margins.Right));
            y := ys;
          end;
        end
        else
        begin
          if AutoAlign then
          begin
            c.Left := x;
            c.Top := y;
          end;

          if AutoStretchHeight or ((c is TTMSFNCDefaultToolBarButton) and ((c as TTMSFNCDefaultToolBarButton).Layout = bblLarge)) then
          begin
            h := Height - txth - y;
            c.Height := h
          end
          else
            h := Max(h, c.Top + c.Height + vs);

          cn := GetControl(I + 1);
          if Assigned(cn) and (cn is TTMSFNCDefaultToolBarButton) then
          begin
            case (cn as TTMSFNCDefaultToolBarButton).Layout of
              bblBitmap, bblLabel:
              begin
                y := Max(y, c.Top + c.Height + vs);
                if y + cn.Height > Height - txth then
                begin
                  x := Max(x, Max(maxx, c.Left + c.Width + hs));
                  y := ys;
                end
                else
                begin
                  c.Left := x;
                  maxx := Max(x, Max(maxx, c.Left + c.Width + hs));
                end;
              end;
              bblNone, bblLarge:
              begin
                x := Max(x, c.Left + c.Width + hs);
                y := ys;
              end;
            end;
          end
          else
          begin
            x := Max(x, Max(maxx, c.Left + c.Width + hs));
            y := ys;
          end;
        end;
        {$ENDIF}
        {$IFDEF LCLLIB}
        if AutoAlign then
        begin
          c.Left := x + c.BorderSpacing.Left;
          c.Top := y + c.BorderSpacing.Top;
        end;

        if AutoStretchHeight or ((c is TTMSFNCDefaultToolBarButton) and ((c as TTMSFNCDefaultToolBarButton).Layout = bblLarge)) then
        begin
          h := Height - c.BorderSpacing.Bottom - txth - y;
          c.Height := h;
        end
        else
          h := Max(h, c.Top + c.Height + vs + c.BorderSpacing.Bottom);

        cn := GetControl(I + 1);
        if Assigned(cn) and (cn is TTMSFNCDefaultToolBarButton) then
        begin
          case (cn as TTMSFNCDefaultToolBarButton).Layout of
            bblBitmap, bblLabel:
            begin
              y := Max(y, c.Top + c.Height + vs + c.BorderSpacing.Bottom);
              if y + cn.BorderSpacing.Top + cn.Height > Height - cn.BorderSpacing.Bottom - txth then
              begin
                x := Max(x, Max(maxx, c.Left + c.Width + hs + c.BorderSpacing.Right));
                y := ys;
              end
              else
              begin
                c.Left := x + c.BorderSpacing.Left;
                maxx := Max(x, Max(maxx, c.Left + c.Width + hs + c.BorderSpacing.Right));
              end;
            end;
            bblNone, bblLarge:
            begin
              x := Max(x, c.Left + c.Width + hs + c.BorderSpacing.Right);
              y := ys;
            end;
          end;
        end
        else
        begin
          x := Max(x, Max(maxx, c.Left + c.Width + hs + c.BorderSpacing.Right));
          y := ys;
        end;

        {$ENDIF}
        w := Max(w, x);
      end;
      inc(idx);
    end;
  end;

  if h = 0 then
    h := hsm;

  FOptionsMenuButton.Visible := OptionsMenu.ShowButton;
  if OptionsMenu.ShowButton then
    FOptionsMenuButton.Parent := Self
  else
    FOptionsMenuButton.Parent := nil;

  {$IFDEF FMXLIB}
  if FOptionsMenuButton.Visible then
  begin
    FOptionsMenuButton.Index := Self.ControlCount;
    FOptionsMenuButton.ControlIndex := Self.ControlCount - 1;
    FOptionsMenuButton.Position.Y := FOptionsMenuButton.Margins.Top;
    mgr := FOptionsMenuButton.Margins;

    if AutoSize then
    begin
      FOptionsMenuButton.Position.X := w + mgr.Left;
      if AutoHeight then
        FOptionsMenuButton.Height := h - mgr.Bottom - mgr.Top - txth
      else if AutoStretchHeight then
        FOptionsMenuButton.Height := Height - mgr.Bottom - mgr.Top - txth;
    end
    else
    begin
      FOptionsMenuButton.Position.X := Width - FOptionsMenuButton.Width - mgr.Right;
      FOptionsMenuButton.Height := Height - mgr.Bottom - mgr.Top - txth;
    end;
    w := w + FOptionsMenuButton.Width + mgr.Right + mgr.Left;
  end;

  if AutoSize then
  begin
    if Appearance.Separator then
      w := w + Appearance.SeparatorStroke.Width;

    w := Round(Max(MinimumWidth, w));

    if ControlAlignment = caNone then
    begin
      lm := 0;
      rm := 0;
      tm := 0;
      bm := 0;
      GetControlMargins(lm, tm, rm, bm);
      w := w + lm + rm;
    end;

    h := h + txth;

    if AutoHeight and AutoWidth and (ControlAlignment = caNone) then
      SetBounds(Position.X, Position.Y, w, h)
    else if AutoHeight and not (ControlAlignment in [caLeft, caRight, caClient]) then
      SetBounds(Position.X, Position.Y, Width, h)
    else if AutoWidth and not (ControlAlignment in [caTop, caBottom, caClient]) then
      SetBounds(Position.X, Position.Y, w, Height);
  end;

  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  if FOptionsMenuButton.Visible then
  begin
    FOptionsMenuButton.ControlIndex := Self.ControlCount - 1;
    {$IFDEF LCLLIB}
    FOptionsMenuButton.Top := FOptionsMenuButton.BorderSpacing.Top;
    mgr := FOptionsMenuButton.BorderSpacing;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    FOptionsMenuButton.Top := FOptionsMenuButton.Margins.Top;
    mgr := FOptionsMenuButton.Margins;
    if not FOptionsMenuButton.AlignWithMargins then
    begin
      mgr.Left := 0;
      mgr.Top := 0;
      mgr.Right := 0;
      mgr.Bottom := 0;
    end;
    {$ENDIF}

    if AutoSize then
    begin
      FOptionsMenuButton.Left := w + mgr.Left;
      if AutoHeight then
        FOptionsMenuButton.Height := h - mgr.Bottom - mgr.Top
      else if AutoStretchHeight then
        FOptionsMenuButton.Height := Height - mgr.Bottom - txth - mgr.Top;
    end
    else
    begin
      FOptionsMenuButton.Left := Width - FOptionsMenuButton.Width - mgr.Right;
      FOptionsMenuButton.Height := Height - mgr.Bottom - mgr.Top - txth;
    end;
    w := w + FOptionsMenuButton.Width + mgr.Right + mgr.Left;
  end;

  if AutoSize then
  begin
    if Appearance.Separator then
      w := w + Round(Appearance.SeparatorStroke.Width);

    w := Round(Max(MinimumWidth, w));

    if ControlAlignment = caNone then
    begin
      lm := 0;
      rm := 0;
      tm := 0;
      bm := 0;
      GetControlMargins(lm, tm, rm, bm);
      w := w + Round(lm + rm);
    end;

    h := h + txth;

    if AutoHeight and AutoWidth and (ControlAlignment = caNone) then
      SetBounds(Left, Top, w, h)
    else if AutoHeight and not (ControlAlignment in [caLeft, caRight, caClient]) then
      SetBounds(Left, Top, Width, h)
    else if AutoWidth and not (ControlAlignment in [caTop, caBottom, caClient]) then
      SetBounds(Left, Top, w, Height);
  end;
  {$ENDIF}

  {$IFDEF FMXLIB}
  EndUpdate;
  {$ENDIF}

  if Assigned(OnUpdateControls) then
    OnUpdateControls(Self);

  FBlockUpdate := False;
end;

procedure TTMSFNCCustomToolBar.UpdateDockPanel;
begin
  if Assigned(OnUpdateDockPanel) then
    OnUpdateDockPanel(Self);
end;

{ TTMSFNCDefaultToolBarButton }

{$IFNDEF WEBLIB}
{$IFDEF FNCLIB}
{$IFNDEF LCLLIB}
{$HINTS OFF}
{$IF COMPILERVERSION >= 30}
procedure TTMSFNCDefaultToolBarButton.ActionChange(Sender: {$IFNDEF FMXLIB}TObject{$ELSE}TBasicAction{$ENDIF};
  CheckDefaults: Boolean);
var
  l: TCustomImageList;
  idx: Integer;
  b: TTMSFNCBitmap;
begin
  inherited ActionChange(Sender, CheckDefaults);
  if Sender is TCustomAction then
  begin
    if (not CheckDefaults) or (Text = '') or (Text = Name) then
     Text := TCustomAction(Sender).Text;
  end;

  if (Sender is TCustomAction) and not CheckDefaults then
  begin
    if (TCustomAction(Sender).ActionList <> nil) and (TCustomAction(Sender).ActionList.Images is TCustomImageList) then
    begin
      l := TCustomImageList(TCustomAction(Sender).ActionList.Images);
      idx := TCustomAction(Sender).ImageIndex;
      b := TTMSFNCBitmap.Create;
      try
        TTMSFNCUtils.LoadBitmapFromImageList(b, l, idx);
        if not IsBitmapEmpty(b) then
        begin
          Bitmaps.Clear;
          Bitmaps.Add.Bitmap.Assign(b);
        end;
      finally
        b.free;
      end;
    end;
  end;
end;
{$IFEND}
{$HINTS ON}
{$ENDIF}
{$ENDIF}
{$ENDIF}

procedure TTMSFNCDefaultToolBarButton.AppearanceChanged;
begin
  Invalidate;
end;

procedure TTMSFNCDefaultToolBarButton.ApplyStyle;
var
  c: TTMSFNCGraphicsColor;
begin
  inherited;
  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundFillColor(c) then
  begin
    Appearance.NormalFill.Color := c;
    Appearance.NormalFill.Kind := gfkSolid;
    Appearance.DisabledFill.Color := Lighter(c, 20);
    Appearance.DisabledFill.Kind := gfkSolid;
    Appearance.InnerStroke.Color := Blend(Appearance.NormalFill.Color, Appearance.NormalStroke.Color, 75);
    Appearance.InnerStroke.Kind := gskSolid;
  end;

  c := gcNull;
  if TTMSFNCStyles.GetStyleTextFontColor(c) then
    Font.Color := c;

  c := gcNull;
  if TTMSFNCStyles.GetStyleBackgroundStrokeColor(c) then
  begin
    Appearance.NormalStroke.Color := c;
    Appearance.DownStroke.Color := c;
    Appearance.DisabledStroke.Color := c;
    Appearance.NormalStroke.Color := c;
    Appearance.DownStroke.Color := c;
    Appearance.DisabledStroke.Color := c;
    Appearance.HoverStroke.Color := c;
  end;

  c := gcNull;
  if TTMSFNCStyles.GetStyleSelectionFillColor(c) then
  begin
    Appearance.HoverFill.Color := c;
    Appearance.HoverFill.Kind := gfkSolid;
    Appearance.DownFill.Color := Blend(c, Fill.Color, 20);
    Appearance.DownFill.Kind := gfkSolid;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCDefaultToolBarButton then
  begin
    FLayout := (Source as TTMSFNCDefaultToolBarButton).Layout;
    FCompactLayout := (Source as TTMSFNCDefaultToolBarButton).CompactLayout;
    FMinimumLayout := (Source as TTMSFNCDefaultToolBarButton).MinimumLayout;
    FMaximumLayout := (Source as TTMSFNCDefaultToolBarButton).MaximumLayout;
    FBitmapPosition := (Source as TTMSFNCDefaultToolBarButton).BitmapPosition;
    FBitmapSize := (Source as TTMSFNCDefaultToolBarButton).BitmapSize;
    FLargeLayoutBitmapSize := (Source as TTMSFNCDefaultToolBarButton).LargeLayoutBitmapSize;
    FAutoBitmapSize := (Source as TTMSFNCDefaultToolBarButton).AutoBitmapSize;
    FLargeLayoutAutoBitmapSize := (Source as TTMSFNCDefaultToolBarButton).LargeLayoutAutoBitmapSize;
    FStretchBitmapIfNoText := (Source as TTMSFNCDefaultToolBarButton).StretchBitmapIfNoText;
    FAppearance.Assign((Source as TTMSFNCDefaultToolBarButton).Appearance);
    FBitmapContainer := (Source as TTMSFNCDefaultToolBarButton).BitmapContainer;
    FBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).Bitmaps);
    FDisabledBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).DisabledBitmaps);
    FLargeLayoutHoverBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).LargeLayoutHoverBitmaps);
    FLargeLayoutBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).LargeLayoutBitmaps);
    FLargeLayoutDisabledBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).LargeLayoutDisabledBitmaps);
    FHoverBitmaps.Assign((Source as TTMSFNCDefaultToolBarButton).HoverBitmaps);
    FBitmapVisible := (Source as TTMSFNCDefaultToolBarButton).BitmapVisible;
    FText := (Source as TTMSFNCDefaultToolBarButton).Text;
    FTextVisible := (Source as TTMSFNCDefaultToolBarButton).TextVisible;
    FDropDownHeight := (Source as TTMSFNCDefaultToolBarButton).DropDownHeight;
    FDropDownWidth := (Source as TTMSFNCDefaultToolBarButton).DropDownWidth;
    FDropDownAutoWidth := (Source as TTMSFNCDefaultToolBarButton).DropDownAutoWidth;
    FWordWrapping := (Source as TTMSFNCDefaultToolBarButton).WordWrapping;
    FHorizontalTextAlign := (Source as TTMSFNCDefaultToolBarButton).HorizontalTextAlign;
    FVerticalTextAlign := (Source as TTMSFNCDefaultToolBarButton).VerticalTextAlign;
    FTrimming := (Source as TTMSFNCDefaultToolBarButton).Trimming;
    FFont.Assign((Source as TTMSFNCDefaultToolBarButton).Font);
    FHoverFontColor := (Source as TTMSFNCDefaultToolBarButton).HoverFontColor;
    FDownFontColor := (Source as TTMSFNCDefaultToolBarButton).DownFontColor;
    FDisabledFontColor := (Source as TTMSFNCDefaultToolBarButton).DisabledFontColor;
    FStretchText := (Source as TTMSFNCDefaultToolBarButton).StretchText;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.BitmapsChanged(Sender: TObject);
var
  bmp: TTMSFNCBitmap;
begin
  bmp := TTMSFNCGraphics.GetScaledBitmap(Bitmaps, 0, BitmapContainer);
  BitmapVisible := Assigned(bmp) and not IsBitmapEmpty(bmp);

  if not BitmapVisible and (Layout = bblLarge) then
  begin
    bmp := TTMSFNCGraphics.GetScaledBitmap(LargeLayoutBitmaps, 0, BitmapContainer);
    BitmapVisible := Assigned(bmp) and not IsBitmapEmpty(bmp);
  end;

  Invalidate;
end;

function TTMSFNCDefaultToolBarButton.CanChangeText: Boolean;
begin
  Result := True;
end;

function TTMSFNCDefaultToolBarButton.CanDrawDesignTime: Boolean;
begin
  Result := False;
end;

function TTMSFNCDefaultToolBarButton.CanDropDown: Boolean;
begin
  Result := False;
end;

procedure TTMSFNCDefaultToolBarButton.ChangeDPIScale(M, D: Integer);
begin
  inherited;

  BeginUpdate;
  Font.Height := TTMSFNCUtils.MulDivInt(Font.Height, M, D);
  BitmapSize := TTMSFNCUtils.MulDivSingle(BitmapSize, M, D);
  LargeLayoutBitmapSize := TTMSFNCUtils.MulDivSingle(LargeLayoutBitmapSize, M, D);

  if FOldHeight <> -1 then
    FOldHeight := TTMSFNCUtils.MulDivSingle(FOldHeight, M, D);
  FDropDownHeight := TTMSFNCUtils.MulDivSingle(FDropDownHeight, M, D);
  FDropDownWidth := TTMSFNCUtils.MulDivSingle(FDropDownWidth, M, D);

  FPopup.DropDownWidth := TTMSFNCUtils.MulDivSingle(FPopup.DropDownWidth, M, D);
  FPopup.DropDownHeight := TTMSFNCUtils.MulDivSingle(FPopup.DropDownHeight, M, D);

//  FAppearance.Rounding := TTMSFNCUtils.MulDivSingle(FAppearance.Rounding, M, D);
  EndUpdate;
end;

procedure TTMSFNCDefaultToolBarButton.CloseDropDown;
begin
  if not Assigned(FPopup) then
    Exit;

  if FPopup.IsOpen then
    FPopup.IsOpen := False;
end;

constructor TTMSFNCDefaultToolBarButton.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF FMXLIB}
  EnableExecuteAction := True;
  {$ENDIF}
  FUseStyledDropDownIcon := True;
  FOldHeight := -1;
  FLayout := bblNone;
  FCompactLayout := bblNone;
  FMinimumLayout := bblBitmap;
  FMaximumLayout := bblLarge;

  FFont := TTMSFNCGraphicsFont.Create;
  FFont.OnChanged := @DoFontChanged;

  FHoverFontColor := gcNull;
  FDownFontColor := gcNull;
  FDisabledFontColor := gcNull;

  FDownState := False;
  FApplyName := True;
  FCloseOnSelection := True;
  FBitmapSize := 24;
  FLargeLayoutBitmapSize := 32;
  FAutoBitmapSize := False;
  FLargeLayoutAutoBitmapSize := False;
  FStretchBitmapIfNoText := True;
  FStretchText := False;

  FDropDownWidth := 135;
  FDropDownHeight := 135;
  FDropDownAutoWidth := False;
  FPopup := TTMSFNCPopup.Create(Self);
  FPopup.DragWithParent := True;
  FPopup.DropDownWidth := FDropDownWidth;
  FPopup.DropDownHeight := FDropDownHeight;
  FPopup.OnPopup := @DoPopup;
  FPopup.OnClosePopup := @DoClosePopup;
  FPopupPlacement := ppBottom;

  FBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FBitmaps.OnChange := @BitmapsChanged;
  FDisabledBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FDisabledBitmaps.OnChange := @BitmapsChanged;
  FHoverBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FHoverBitmaps.OnChange := @BitmapsChanged;

  FLargeLayoutBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FLargeLayoutBitmaps.OnChange := @BitmapsChanged;
  FLargeLayoutDisabledBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FLargeLayoutDisabledBitmaps.OnChange := @BitmapsChanged;
  FLargeLayoutHoverBitmaps := TTMSFNCScaledBitmaps.Create(Self);
  FLargeLayoutHoverBitmaps.OnChange := @BitmapsChanged;

  FAppearance := TTMSFNCToolBarButtonAppearance.Create(Self);

  FTextVisible := True;
  FBitmapVisible := False;
  FWordWrapping := False;
  FHorizontalTextAlign := gtaCenter;
  FVerticalTextAlign := gtaCenter;
  FTrimming := gttCharacter;
  FBitmapPosition := bbpLeft;

  Width := 100;
  Height := 24;
end;

procedure TTMSFNCDefaultToolBarButton.SetDisabledBitmaps(const Value: TTMSFNCScaledBitmaps);
begin
  FDisabledBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetDisabledFontColor(
  const Value: TTMSFNCGraphicsColor);
begin
  if FDisabledFontColor <> Value then
  begin
    FDisabledFontColor := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetHoverBitmaps(const Value: TTMSFNCScaledBitmaps);
begin
  FHoverBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetDownFontColor(
  const Value: TTMSFNCGraphicsColor);
begin
  if FDownFontColor <> Value then
  begin
    FDownFontColor := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetHoverFontColor(
  const Value: TTMSFNCGraphicsColor);
begin
  if FHoverFontColor <> Value then
  begin
    FHoverFontColor := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetMaximumLayout(
  const Value: TTMSFNCToolBarButtonLayout);
begin
  if FMaximumLayout <> Value then
  begin
    FMaximumLayout := Value;
    UpdateToolBar;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetMinimumLayout(
  const Value: TTMSFNCToolBarButtonLayout);
begin
  if FMinimumLayout <> Value then
  begin
    FMinimumLayout := Value;
    UpdateToolBar;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetDownState(const Value: Boolean);
begin
  FDownState := Value;
  Invalidate;
end;

procedure TTMSFNCDefaultToolBarButton.SetDropDownControl(const Value: TControl);
begin
  FDropDownControl := Value;
  if Assigned(FDropDownControl) then
  begin
    if not (csDesigning in ComponentState) then
    begin
      if Assigned(FPopup) then
      begin
        FPopup.ContentControl := FDropDownControl;
        FPopup.FocusedControl := FDropDownControl;
      end;
    end
    else if (csDesigning in ComponentState) then
    begin
      DropDownHeight := FDropDownControl.Height;
      DropDownWidth := FDropDownControl.Width;
    end;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetDropDownAutoWidth(
  const Value: Boolean);
begin
  if FDropDownAutoWidth <> Value then
  begin
    FDropDownAutoWidth := Value;
    if Assigned(FPopup) then
    begin
      if FDropDownAutoWidth then
        FPopup.DropDownWidth := Width
      else
        FPopup.DropDownWidth := FDropDownWidth;
    end;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetDropDownHeight(const Value: Single);
begin
  FDropDownHeight := Value;
  if Assigned(FPopup) and not DropDownAutoWidth then
    FPopup.DropDownHeight := FDropDownHeight;
end;

procedure TTMSFNCDefaultToolBarButton.SetDropDownWidth(const Value: Single);
begin
  FDropDownWidth := Value;
  if Assigned(FPopup) then
    FPopup.DropDownWidth := FDropDownWidth;
end;

procedure TTMSFNCDefaultToolBarButton.SetFont(const Value: TTMSFNCGraphicsFont);
begin
  FFont.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetHorizontalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FHorizontalTextAlign <> Value then
  begin
    FHorizontalTextAlign := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBarButton.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FDropDownButton) then
    FDropDownButton.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCCustomToolBarButton.SetDropDownKind(
  const Value: TTMSFNCToolBarButtonDropDownKind);
begin
  if FDropDownKind <> Value then
  begin
    FDropDownKind := Value;
    if Assigned(FDropDownButton) then
    begin
      case DropDownKind of
        ddkNormal:
        begin
          FDropDownButton.Visible := False;
          FDropDownButton.Parent := nil;
          {$IFDEF FMXLIB}
          FDropDownButton.HitTest := True;
          {$ENDIF}
          FDropDownButton.Appearance.Transparent := False;
        end;
        ddkDropDown:
        begin
          FDropDownButton.Visible := False;
          FDropDownButton.Parent := Self;
          {$IFDEF FMXLIB}
          FDropDownButton.HitTest := False;
          {$ENDIF}
          FDropDownButton.Appearance.Transparent := True;
        end;
        ddkDropDownButton:
        begin
          FDropDownButton.Visible := True;
          FDropDownButton.Parent := Self;
          {$IFDEF FMXLIB}
          FDropDownButton.HitTest := True;
          {$ENDIF}
          FDropDownButton.Appearance.Transparent := False;
        end;
      end;
    end;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBarButton.SetDropDownPosition(const Value: TTMSFNCToolBarButtonDropDownPosition);
var
  sc: Single;
begin
  if FDropDownPosition <> Value then
  begin
    sc := TTMSFNCUtils.GetDPIScale(Self, 96);

    FDropDownPosition := Value;
    if Assigned(FDropDownButton) then
    begin
      case Value of
        ddpRight:
        begin
          {$IFDEF FMXLIB}
          FDropDownButton.Align := TAlignLayout.Right;
          {$ENDIF}
          {$IFDEF CMNWEBLIB}
          FDropDownButton.Align := alRight;
          {$ENDIF}
          FDropDownButton.Width := Round(sc *17);
          FDropDownButton.Appearance.Corners := [gcTopRight, gcBottomRight];
        end;
        ddpBottom:
        begin
          {$IFDEF FMXLIB}
          FDropDownButton.Align := TAlignLayout.Bottom;
          {$ENDIF}
          {$IFDEF CMNWEBLIB}
          FDropDownButton.Align := alBottom;
          {$ENDIF}
          FDropDownButton.Height := Round(sc * 10);
          FDropDownButton.Appearance.Corners := [gcBottomLeft, gcBottomRight];
        end;
      end;
    end;
  end;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBarButton.SetEnabled(const Value: Boolean);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomToolBarButton.SetEnabled(Value: Boolean);
{$ENDIF}
var
  d: TTMSFNCToolBarDropDownButton;
begin
  inherited;
  d := GetDropDownButtonControl;
  if Assigned(d) then
    d.Enabled := Value;
end;

procedure TTMSFNCCustomToolBarButton.SetHidden(const Value: Boolean);
begin
  if FHidden <> Value then
  begin
    FHidden := Value;
    UpdateToolBarControl;
  end;
end;

procedure TTMSFNCCustomToolBarButton.UpdateDropDownButton;
begin
  if Assigned(FDropDownButton) then
    FDropDownButton.Appearance.Rounding := Appearance.Rounding;
end;

destructor TTMSFNCDefaultToolBarButton.Destroy;
begin
  FFont.Free;
  FPopup.Free;
  FBitmaps.Free;
  FDisabledBitmaps.Free;
  FHoverBitmaps.Free;
  FLargeLayoutBitmaps.Free;
  FLargeLayoutDisabledBitmaps.Free;
  FLargeLayoutHoverBitmaps.Free;
  FAppearance.Free;
  inherited;
end;

procedure TTMSFNCDefaultToolBarButton.DoPopup(Sender: TObject);
begin
  InitializePopup;
end;

procedure TTMSFNCDefaultToolBarButton.HandleMouseEnter;
begin
  inherited;
end;

procedure TTMSFNCDefaultToolBarButton.HandleMouseLeave;
begin
  inherited;
  FDown := False;
  FHover := False;
  FPrevHover := False;
  Invalidate;
end;

procedure TTMSFNCCustomToolBarButton.DoFontChanged(Sender: TObject);
begin
  Invalidate;
end;

procedure TTMSFNCCustomToolBarButton.AppearanceChanged;
begin
  inherited;
  UpdateDropDownButton;
end;

procedure TTMSFNCCustomToolBarButton.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomToolBarButton then
  begin
    FDropDownKind := (Source as TTMSFNCCustomToolBarButton).DropDownKind;
    FDropDownPosition := (Source as TTMSFNCCustomToolBarButton).DropDownPosition;
    FAutoOptionsMenuText := (Source as TTMSFNCCustomToolBarButton).AutoOptionsMenuText;
    FHidden := (Source as TTMSFNCCustomToolBarButton).Hidden;
    Invalidate;
  end;
end;

function TTMSFNCCustomToolBarButton.CanDropDown: Boolean;
begin
  Result := DropDownKind <> ddkNormal;
end;

procedure TTMSFNCCustomToolBarButton.ChangeDPIScale(M, D: Integer);
begin
  inherited;

end;

constructor TTMSFNCCustomToolBarButton.Create(AOwner: TComponent);
var
  res: string;
begin
  inherited;
  FHidden := False;
  FDropDownPosition := ddpRight;
  FDropDownButton := GetDropDownButtonClass.Create(Self);
  FDropDownButton.TabStop := False;
  FDropDownButton.Text := '';
  FDropDownButton.OnClick := @DropDownButtonClick;
  FDropDownButton.Visible := False;
  FDropDownButton.Width := 17;
  FDropDownButton.Appearance.Corners := [gcTopRight, gcBottomRight];
  {$IFDEF FMXLIB}
  FDropDownButton.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FDropDownButton.Align := alRight;
  {$ENDIF}
  FDropDownButton.Stored := False;

  {$IFNDEF WEBLIB}
  res := TMSFNCTOOLBAREXPANDSVG;
  {$ELSE}
  res := TMSFNCTOOLBAREXPANDSVG;
  {$ENDIF}

  FDropDownButton.Bitmaps.AddBitmapFromResource(res, HInstance);
  FDropDownButton.DisabledBitmaps.AddBitmapFromResource(res, HInstance);
  FDropDownButton.HoverBitmaps.AddBitmapFromResource(res, HInstance);
end;

destructor TTMSFNCCustomToolBarButton.Destroy;
begin
  FDropDownButton.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBarButton.DrawButton(AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
begin
  inherited;
  if Assigned(FDropDownButton) and (DropDownKind = ddkDropDown) then
  begin
    case DropDownPosition of
      ddpRight: r := RectF(Width - FDropDownButton.Width, 0, Width, Height);
      ddpBottom: r := RectF(0, Height - FDropDownButton.Height, Width, Height);
    end;
    FDropDownButton.DrawBitmap(AGraphics, r);
  end;
end;

procedure TTMSFNCCustomToolBarButton.DropDownButtonClick(Sender: TObject);
begin
  DropDown;
end;

procedure TTMSFNCDefaultToolBarButton.DrawBitmap(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  r: TRectF;
  bmpa: TBitmap;
  bmp: TTMSFNCBitmap;
  g: TTMSFNCGraphics;
  x, y: Integer;
  bs: Single;
  s: Boolean;
begin
  if not BitmapVisible then
    Exit;

  r := GetBitmapRect(ARect);

  if (Self is TTMSFNCToolBarDropDownButton) and AdaptToStyle and UseStyledDropDownIcon then
  begin
    bmpa := TBitmap.Create;
    bmpa.SetSize(ScalePaintValue(7), ScalePaintValue(7));
    {$IFDEF CMNLIB}
    bmpa.TransparentMode := tmFixed;
    bmpa.Transparent := True;
    bmpa.TransparentColor := gcWhite;
    {$ENDIF}
    g := TTMSFNCGraphics.Create(bmpa.Canvas);
    try
      g.BeginScene;
      {$IFDEF CMNLIB}
      g.Fill.Color := gcWhite;
      g.Fill.Kind := gfkSolid;
      g.Stroke.Kind := gskSolid;
      g.Stroke.Color := gcWhite;
      g.DrawRectangle(0, 0, bmpa.Width, bmpa.Height);
      {$ENDIF}
      g.Stroke.Kind := gskSolid;
      g.Stroke.Color := TTMSFNCGraphics.DefaultSelectionFillColor;
//      g.DrawLine(PointF(0, 1), PointF(6, 1), gcpmRightDown);
//      g.DrawLine(PointF(0, 2), PointF(6, 2), gcpmRightDown);
//      g.DrawLine(PointF(1, 3), PointF(5, 3), gcpmRightDown);
//      g.DrawLine(PointF(2, 4), PointF(4, 4), gcpmRightDown);
//      g.DrawLine(PointF(3, 5), PointF(3, 5), gcpmRightDown);

      for y := ScalePaintValue(1) to ScalePaintValue(5) do
      begin
        x := Max(0, y - ScalePaintValue(2));
        g.DrawLine(PointF(x, y), PointF((bmpa.Width - 1) - x, y), gcpmRightDown);
        if x >= ((bmpa.Width - 1) - x) then
          Break;
      end;

    finally
      g.EndScene;
      g.Free;
    end;

    try
      bmp := TTMSFNCBitmap.Create;
      try
        bmp.Assign(bmpa);
        AGraphics.DrawBitmap(r, bmp);
      finally
        bmp.Free;
      end;
    finally
      bmpa.Free;
    end;
  end
  else
  begin
    AGraphics.BitmapContainer := BitmapContainer;

    bs := GetBitmapSize;
    case Layout of
      bblLarge: bs := GetLargeLayoutBitmapSize;
    end;

    s := False;
    if not TextVisible or (Text = '') then
      if not ((bs <> -1) and not StretchBitmapIfNoText) then
        s := True;

    case Layout of
      bblLarge:
      begin
        if Enabled then
        begin
          if FHover and (LargeLayoutHoverBitmaps.Count > 0) then
            AGraphics.DrawScaledBitmap(r, LargeLayoutHoverBitmaps, ResourceScaleFactor, True, s)
          else if FHover and (HoverBitmaps.Count > 0) then
            AGraphics.DrawScaledBitmap(r, HoverBitmaps, ResourceScaleFactor, True, s)
          else if LargeLayoutBitmaps.Count > 0 then
            AGraphics.DrawScaledBitmap(r, LargeLayoutBitmaps, ResourceScaleFactor, True, s)
          else
            AGraphics.DrawScaledBitmap(r, Bitmaps, ResourceScaleFactor, True, s)
        end
        else
        begin
          if LargeLayoutDisabledBitmaps.Count > 0 then
            AGraphics.DrawScaledBitmap(r, LargeLayoutDisabledBitmaps, ResourceScaleFactor, True, s)
          else if DisabledBitmaps.Count > 0 then
            AGraphics.DrawScaledBitmap(r, DisabledBitmaps, ResourceScaleFactor, True, s)
          else
            AGraphics.DrawScaledBitmap(r, Bitmaps, ResourceScaleFactor, True, s)
        end;
      end
      else
      begin
        if Enabled then
        begin
          if FHover and (HoverBitmaps.Count > 0) then
            AGraphics.DrawScaledBitmap(r, HoverBitmaps, ResourceScaleFactor, True, s)
          else
            AGraphics.DrawScaledBitmap(r, Bitmaps, ResourceScaleFactor, True, s)
        end
        else if DisabledBitmaps.Count > 0 then
          AGraphics.DrawScaledBitmap(r, DisabledBitmaps, ResourceScaleFactor, True, s)
        else
          AGraphics.DrawScaledBitmap(r, Bitmaps, ResourceScaleFactor, True, s)
      end;
    end;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.DrawButton(AGraphics: TTMSFNCGraphics);
begin

end;

procedure TTMSFNCDefaultToolBarButton.DrawText(AGraphics: TTMSFNCGraphics);
var
  tr: TRectF;
  st: TTMSFNCGraphicsSaveState;
begin
  if not TextVisible or (Text = '') then
    Exit;

  tr := GetTextRect;
  st := AGraphics.SaveState;
  try
    AGraphics.ClipRect(tr);
    AGraphics.Font.Assign(Font);

    if Enabled then
    begin
      if (FDown or FDownState) and (DownFontColor <> gcNull) then
        AGraphics.Font.Color := DownFontColor
      else if FHover and (HoverFontColor <> gcNull) then
        AGraphics.Font.Color := HoverFontColor
    end
    else if DisabledFontColor <> gcNull then
      AGraphics.Font.Color := DisabledFontColor;

    AGraphics.DrawText(tr, Text, WordWrapping, HorizontalTextAlign, VerticalTextAlign, Trimming);
  finally
    AGraphics.RestoreState(st);
  end;
end;

procedure TTMSFNCDefaultToolBarButton.DropDown;
begin
  if not Assigned(FPopup) then
    Exit;

  FPopup.PlacementControl := Self;

  if not FPopup.IsOpen then
  begin
    if Assigned(OnBeforeDropDown) then
      OnBeforeDropDown(Self);

    if DropDownAutoWidth then
      FPopup.DropDownWidth := Width;

    FPopup.Placement := FPopupPlacement;
    FPopup.IsOpen := True;
    if Assigned(OnDropDown) then
      OnDropDown(Self);
  end
  else
    FPopup.IsOpen := False;
end;

procedure TTMSFNCDefaultToolBarButton.DoFontChanged(Sender: TObject);
begin
  Invalidate;
end;

function TTMSFNCCustomToolBarButton.GetBitmapRect: TRectF;
begin
  Result := inherited GetBitmapRect;
end;

function TTMSFNCCustomToolBarButton.GetBitmapRect(ARect: TRectF): TRectF;
var
  r: TRectF;
  dr: TRectf;
  bs: Single;
begin
  bs := GetBitmapSize;
  case Layout of
    bblLarge: bs := GetLargeLayoutBitmapSize;
  end;

  r := ARect;
  Result := RectF(r.Left, r.Top, r.Left, r.Bottom);
  if BitmapVisible then
  begin
    if DropDownKind <> ddkNormal then
    begin
      dr := GetDropDownRect;
      case BitmapPosition of
        bbpLeft:
        begin
          case DropDownPosition of
            ddpRight: Result := RectF(Result.Left + 3, Result.Top + 3, Result.Left + 3 + bs, Result.Bottom - 3);
            ddpBottom: Result := RectF(Result.Left + 3, Result.Top + 3, Result.Left + 3 + bs, dr.Top - 3);
          end;
        end;
        bbpTop:
        begin
          case DropDownPosition of
            ddpRight: Result := RectF(Result.Left + 3, Result.Top + 3, dr.Left - 3, Result.Top + 3 + bs);
            ddpBottom: Result := RectF(Result.Left + 3, Result.Top + 3, r.Right - 3, Result.Top + 3 + bs);
          end;
        end;
      end;
    end
    else if not TextVisible or (Text = '') then
    begin
      Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, r.Bottom - 3);
      if (bs <> -1) and not StretchBitmapIfNoText then
      begin
        Result.Left := Round(r.Left + ((r.Right - r.Left) - bs) / 2);
        Result.Top := Round(r.Top + ((r.Bottom - r.Top) - bs) / 2);
        Result.Right := Result.Left + bs;
        Result.Bottom := Result.Top + bs;
      end;      
    end
    else if TextVisible and not (Text = '') then
    begin
      case BitmapPosition of
        bbpLeft: Result := RectF(r.Left + 3, r.Top + 3, r.Left + 3 + bs, r.Bottom - 3);
        bbpTop: Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, r.Top + 3 + bs);
      end;
    end;
  end;
end;

function TTMSFNCCustomToolBarButton.GetDropDownButtonClass: TTMSFNCToolBarDropDownButtonClass;
begin
  Result := TTMSFNCToolBarDropDownButton;
end;

function TTMSFNCCustomToolBarButton.GetDropDownButtonControl: TTMSFNCToolBarDropDownButton;
begin
  Result := FDropDownButton;
end;

function TTMSFNCCustomToolBarButton.GetDropDownRect: TRectF;
begin
  Result := inherited GetDropDownRect;
  if Assigned(FDropDownButton) and (DropDownKind <> ddkNormal) then
  begin
    if DropDownKind = ddkDropDown then
    begin
      case DropDownPosition of
        ddpRight: Result := RectF(Width - FDropDownButton.Width, 0, Width, Height);
        ddpBottom: Result := RectF(0, Height - FDropDownButton.Height, Width, Height);
      end;
    end
    else
    begin
      {$IFDEF FMXLIB}
      Result := RectF(FDropDownButton.Position.X, FDropDownButton.Position.Y, FDropDownButton.Position.X + FDropDownButton.Width, FDropDownButton.Position.Y + FDropDownButton.Height);
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      Result := RectF(FDropDownButton.Left, FDropDownButton.Top, FDropDownButton.Left + FDropDownButton.Width, FDropDownButton.Top + FDropDownButton.Height);
      {$ENDIF}
    end;
  end;
end;

function TTMSFNCCustomToolBarButton.GetTextRect: TRectF;
var
  bmpr: TRectF;
  dr: TRectF;
  r: TRectF;
begin
  r := LocalRect;
  bmpr := GetBitmapRect(r);
  dr := GetDropDownRect;
  if DropDownKind <> ddkNormal then
  begin
    if not StretchText then
    begin
      case BitmapPosition of
        bbpLeft:
        begin
          case DropDownPosition of
            ddpRight: Result := RectF(bmpr.Right + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
            ddpBottom: Result := RectF(bmpr.Right + 3, r.Top + 3, r.Right - 3, dr.Top - 3);
          end;
        end;
        bbpTop:
        begin
          case DropDownPosition of
            ddpRight: Result := RectF(r.Left + 3, bmpr.Bottom + 3, dr.Left - 3, r.Bottom - 3);
            ddpBottom: Result := RectF(r.Left + 3, bmpr.Bottom + 3, r.Right - 3, dr.Top - 3);
          end;
        end;
      end;
    end
    else
    begin
      case DropDownPosition of
        ddpRight: Result := RectF(r.Left + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
        ddpBottom: Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, dr.Top - 3);
      end;
    end;
  end
  else
  begin
    if not StretchText then
    begin
      case BitmapPosition of
        bbpLeft: Result := RectF(bmpr.Right + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
        bbpTop: Result := RectF(r.Left + 3, bmpr.Bottom + 3, dr.Left - 3, r.Bottom - 3)
      end;
    end
    else
      Result := RectF(r.Left + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
  end;
end;

procedure TTMSFNCCustomToolBarButton.HandleMouseDown(Button: TTMSFNCMouseButton;
  Shift: TShiftState; X, Y: Single);
begin
  inherited;
  if DropDownKind = ddkDropDown then
    DropDown;
end;

procedure TTMSFNCCustomToolBarButton.Loaded;
begin
  inherited;
  {$IFDEF VCLLIB}
  {$HINTS OFF}
  {$IF (COMPILERVERSION >= 33) AND (COMPILERVERSION < 36)}
  FDropDownButton.ScaleForPPI(CurrentPPI);
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
end;

procedure TTMSFNCCustomToolBarButton.LoadSettingsFromFile(AFileName: string);
begin
  inherited;
  if Assigned(FDropDownButton) then
  begin
    FDropDownButton.Appearance.ShowInnerStroke := Appearance.ShowInnerStroke;
    FDropDownButton.Appearance.InnerStroke.Assign(Appearance.InnerStroke);
    FDropDownButton.Appearance.NormalFill.Assign(Appearance.NormalFill);
    FDropDownButton.Appearance.NormalStroke.Assign(Appearance.NormalStroke);
    FDropDownButton.Appearance.HoverFill.Assign(Appearance.HoverFill);
    FDropDownButton.Appearance.HoverStroke.Assign(Appearance.HoverStroke);
    FDropDownButton.Appearance.DownFill.Assign(Appearance.DownFill);
    FDropDownButton.Appearance.DownStroke.Assign(Appearance.DownStroke);
    FDropDownButton.Appearance.DisabledFill.Assign(Appearance.DisabledFill);
    FDropDownButton.Appearance.DisabledStroke.Assign(Appearance.DisabledStroke);
    FDropDownButton.Appearance.FlatStyle := Appearance.FlatStyle;
    FDropDownButton.Fill.Assign(Fill);
    FDropDownButton.Stroke.Assign(Stroke);
  end;
end;

procedure TTMSFNCCustomToolBarButton.LoadSettingsFromStream(AStream: TStream);
begin
  inherited;
  if Assigned(FDropDownButton) then
  begin
    FDropDownButton.Appearance.ShowInnerStroke := Appearance.ShowInnerStroke;
    FDropDownButton.Appearance.InnerStroke.Assign(Appearance.InnerStroke);
    FDropDownButton.Appearance.NormalFill.Assign(Appearance.NormalFill);
    FDropDownButton.Appearance.NormalStroke.Assign(Appearance.NormalStroke);
    FDropDownButton.Appearance.HoverFill.Assign(Appearance.HoverFill);
    FDropDownButton.Appearance.HoverStroke.Assign(Appearance.HoverStroke);
    FDropDownButton.Appearance.DownFill.Assign(Appearance.DownFill);
    FDropDownButton.Appearance.DownStroke.Assign(Appearance.DownStroke);
    FDropDownButton.Appearance.DisabledFill.Assign(Appearance.DisabledFill);
    FDropDownButton.Appearance.DisabledStroke.Assign(Appearance.DisabledStroke);
    FDropDownButton.Appearance.FlatStyle := Appearance.FlatStyle;
    FDropDownButton.Fill.Assign(Fill);
    FDropDownButton.Stroke.Assign(Stroke);
  end;
end;

function TTMSFNCDefaultToolBarButton.GetBitmap: TTMSFNCBitmap;
begin
  Result := TTMSFNCGraphics.GetScaledBitmap(Bitmaps, 0, FBitmapContainer);
end;

function TTMSFNCDefaultToolBarButton.GetBitmapContainer: TTMSFNCBitmapContainer;
begin
  Result := FBitmapContainer;
end;

function TTMSFNCDefaultToolBarButton.GetBitmapRect(ARect: TRectF): TRectF;
var
  r: TRectF;
  bs: Single;
begin
  bs := GetBitmapSize;
  case Layout of
    bblLarge: bs := GetLargeLayoutBitmapSize;
  end;

  r := ARect;
  Result := RectF(r.Left, r.Top, r.Left, r.Bottom);
  if BitmapVisible then
  begin
    case BitmapPosition of
      bbpLeft: Result := RectF(Result.Left + 3, Result.Top + 3, Result.Left + 3 + bs, Result.Bottom - 3);
      bbpTop: Result := RectF(Result.Left + 3, Result.Top + 3, Result.Right - 3, Result.Top + 3 + bs);
    end;
  end;
end;

function TTMSFNCDefaultToolBarButton.GetBitmapSize: Single;
var
  bmp: TTMSFNCBitmap;
begin
  Result := BitmapSize;
  if AutoBitmapSize then
  begin
    bmp := TTMSFNCGraphics.GetScaledBitmap(Bitmaps, 0, BitmapContainer);
    if Assigned(bmp) and not IsBitmapEmpty(bmp) then
      Result := Max(bmp.Height, bmp.Width);
  end;
end;

function TTMSFNCDefaultToolBarButton.GetBitmapRect: TRectF;
begin
  Result := GetBitmapRect(LocalRect);
end;

function TTMSFNCDefaultToolBarButton.GetDropDownRect: TRectF;
var
  r: TRectF;
begin
  r := LocalRect;
  Result := RectF(r.Right, r.Top, r.Right, r.Bottom);
end;

function TTMSFNCDefaultToolBarButton.GetHintString: String;
begin
  Result := Hint;
end;

function TTMSFNCDefaultToolBarButton.GetLargeLayoutBitmapSize: Single;
var
  bmp: TTMSFNCBitmap;
begin
  Result := LargeLayoutBitmapSize;
  if LargeLayoutAutoBitmapSize then
  begin
    bmp := TTMSFNCGraphics.GetScaledBitmap(LargeLayoutBitmaps, 0, BitmapContainer);
    if Assigned(bmp) and not IsBitmapEmpty(bmp) then
      Result := Max(bmp.Height, bmp.Width);
  end;
end;

function TTMSFNCDefaultToolBarButton.GetPopupControl: TTMSFNCPopup;
begin
  Result := FPopup;
end;

function TTMSFNCDefaultToolBarButton.GetText: String;
begin
  Result := FText;
end;

function TTMSFNCDefaultToolBarButton.GetTextRect: TRectF;
var
  bmpr: TRectF;
  dr: TRectF;
  r: TRectF;
begin
  r := LocalRect;
  bmpr := GetBitmapRect;
  dr := GetDropDownRect;
  if not StretchText then
  begin
    case BitmapPosition of
      bbpLeft: Result := RectF(bmpr.Right + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
      bbpTop: Result := RectF(r.Left + 3, bmpr.Bottom + 3, dr.Left - 3, r.Bottom - 3);
    end;
  end
  else
    Result := RectF(r.Left + 3, r.Top + 3, dr.Left - 3, r.Bottom - 3);
end;

function TTMSFNCDefaultToolBarButton.GetTextSize: TSizeF;
var
  g: TTMSFNCGraphics;
  r: TRectF;
begin
  Result.cx := 0;
  Result.cy := 0;
  if TextVisible and (Text <> '') then
  begin
    g := TTMSFNCGraphics.CreateBitmapCanvas(1, 1, NativeCanvas);
    if not NativeCanvas then
      g.BeginScene;
    g.BitmapContainer := BitmapContainer;
    g.OptimizedHTMLDrawing := OptimizedHTMLDrawing;
    try
      g.Font.Assign(Font);
      r := LocalRect;
      InflateRectEx(r, ScalePaintValue(-2), ScalePaintValue(-2));
      Result := g.CalculateTextSize(Text, r, WordWrapping);
    finally
      if not NativeCanvas then
        g.EndScene;
      g.Free;
    end;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.InitializePopup;
begin

end;

function TTMSFNCDefaultToolBarButton.IsBitmapSizeStored: Boolean;
begin
  Result := BitmapSize <> 24;
end;

function TTMSFNCDefaultToolBarButton.IsDropDownHeightStored: Boolean;
begin
  Result := DropDownHeight <> 135;
end;

function TTMSFNCDefaultToolBarButton.IsDropDownWidthStored: Boolean;
begin
  Result := DropDownWidth <> 135;
end;

function TTMSFNCDefaultToolBarButton.IsLargeLayoutBitmapSizeStored: Boolean;
begin
  Result := LargeLayoutBitmapSize <> 32;
end;

procedure TTMSFNCDefaultToolBarButton.HandleKeyDown(var Key: Word; Shift: TShiftState);
begin
  inherited;
  case Key of
    KEY_HOME: SelectFirstValue;
    KEY_END: SelectLastValue;
    KEY_UP, KEY_LEFT:  SelectPreviousValue;
    KEY_DOWN, KEY_RIGHT: SelectNextValue;
    KEY_SPACE: Click;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.HandleKeyPress(var Key: Char);
begin
  inherited;
  if (Key >= #32) and not (Ord(Key) in [KEY_F2, KEY_RETURN, KEY_SPACE, KEY_ESCAPE, KEY_HOME, KEY_END, KEY_UP, KEY_LEFT, KEY_DOWN, KEY_RIGHT]) then
    SelectValueWithCharacter(Key);
end;

procedure TTMSFNCDefaultToolBarButton.HandleKeyUp(var Key: Word; Shift: TShiftState);
begin
  inherited;
  if Shift <> [] then
    Exit;

  case Key of
    KEY_RETURN, KEY_F4:
    begin
      if CanDropDown then
        DropDown;
    end;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.HandleMouseDown(Button: TTMSFNCMouseButton;
  Shift: TShiftState; X, Y: Single);
begin
  inherited;
  if CanFocus then
    SetFocus;

  FDown := True;
  Invalidate;
end;

procedure TTMSFNCDefaultToolBarButton.HandleMouseMove(Shift: TShiftState; X,
  Y: Single);
begin
  inherited;
  FHover := True;
  if FPrevHover <> FHover then
    Invalidate;

  FPrevHover := FHover;
end;

procedure TTMSFNCDefaultToolBarButton.HandleMouseUp(Button: TTMSFNCMouseButton;
  Shift: TShiftState; X, Y: Single);
begin
  inherited;
  FDown := False;
  Invalidate;
end;

function TTMSFNCDefaultToolBarButton.HasHint: Boolean;
begin
  Result := Hint <> '';
end;

procedure TTMSFNCDefaultToolBarButton.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited;
  if (Operation = opRemove) and (AComponent = FBitmapContainer) then
    FBitmapContainer := nil;

  if (Operation = opRemove) and (AComponent = FDropDownControl) then
    FDropDownControl := nil;
end;

procedure TTMSFNCDefaultToolBarButton.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  r: TRectF;
begin
  inherited;
  if not Appearance.Transparent then
  begin
    if Enabled then
    begin
      if FDown or FDownState then
      begin
        AGraphics.Fill.Assign(Appearance.DownFill);
        AGraphics.Stroke.Assign(Appearance.DownStroke);
      end
      else if FHover then
      begin
        AGraphics.Fill.Assign(Appearance.HoverFill);
        AGraphics.Stroke.Assign(Appearance.HoverStroke);
      end
      else
      begin
        AGraphics.Fill.Assign(Appearance.NormalFill);
        AGraphics.Stroke.Assign(Appearance.NormalStroke);
      end;
    end
    else
    begin
      AGraphics.Fill.Assign(Appearance.DisabledFill);
      AGraphics.Stroke.Assign(Appearance.DisabledStroke);
    end;

    r := LocalRect;

    if Appearance.FlatStyle then
    begin
      AGraphics.Fill.Kind := gfkSolid;
      AGraphics.DrawRectangle(r);
    end
    else
      AGraphics.DrawRoundRectangle(r, Appearance.Rounding, Appearance.Corners);

    if Appearance.ShowInnerStroke and not Appearance.FlatStyle then
    begin
      InflateRectEx(r, -1, -1);
      AGraphics.Stroke.Assign(Appearance.InnerStroke);
      AGraphics.Fill.Kind := gfkNone;
      AGraphics.DrawRoundRectangle(r, Appearance.Rounding, Appearance.Corners);
    end;
  end;

  DrawBitmap(AGraphics, ARect);
  DrawText(AGraphics);
  DrawButton(AGraphics);

  if ShowFocus and IsFocused then
  begin
    r := GetTextRect;
    AGraphics.DrawFocusRectangle(r);
  end;

  if IsDesignTime and CanDrawDesignTime then
    AGraphics.DrawFocusRectangle(ARect, gcBlack);
end;

procedure TTMSFNCDefaultToolBarButton.DoClosePopup(Sender: TObject);
begin
  if Assigned(OnCloseDropDown) then
    OnCloseDropDown(Self);
end;

procedure TTMSFNCDefaultToolBarButton.ResetToDefaultStyle;
begin
  inherited;
  Font.Color := gcBlack;
  Appearance.NormalFill.Color := gcWhite;
  Appearance.HoverFill.Color := gcWhite;
  Appearance.DownFill.Color := gcWhite;
  Appearance.DisabledFill.Color := gcLightgray;
  Appearance.NormalStroke.Color := gcGray;
  Appearance.InnerStroke.Color := gcWhite;
  Appearance.HoverStroke.Color := gcGray;
  Appearance.DownStroke.Color := gcGray;
  Appearance.DisabledStroke.Color := gcGray;

  Appearance.NormalFill.Kind := gfkGradient;
  Appearance.HoverFill.Kind := gfkGradient;
  Appearance.DownFill.Kind := gfkGradient;
  Appearance.DisabledFill.Kind := gfkSolid;
  Appearance.NormalStroke.Kind := gskSolid;
  Appearance.InnerStroke.Kind := gskSolid;
  Appearance.HoverStroke.Kind := gskSolid;
  Appearance.DownStroke.Kind := gskSolid;
  Appearance.DisabledStroke.Kind := gskSolid;

  Appearance.NormalFill.Color := MakeGraphicsColor(249, 251, 252);
  Appearance.NormalFill.ColorTo := MakeGraphicsColor(230, 235, 235);
  Appearance.NormalFill.ColorMirror := MakeGraphicsColor(220, 220, 236);
  Appearance.NormalFill.ColorMirrorTo := MakeGraphicsColor(220, 225, 236);

  Appearance.HoverFill.Color := MakeGraphicsColor(229, 231, 232);
  Appearance.HoverFill.ColorTo := MakeGraphicsColor(210, 215, 215);
  Appearance.HoverFill.ColorMirror := MakeGraphicsColor(200, 200, 216);
  Appearance.HoverFill.ColorMirrorTo := MakeGraphicsColor(200, 205, 216);

  Appearance.DownFill.Color := MakeGraphicsColor(219, 221, 222);
  Appearance.DownFill.ColorTo := MakeGraphicsColor(200, 205, 205);
  Appearance.DownFill.ColorMirror := MakeGraphicsColor(190, 190, 206);
  Appearance.DownFill.ColorMirrorTo := MakeGraphicsColor(190, 195, 206);
end;

procedure TTMSFNCDefaultToolBarButton.SelectFirstValue;
begin

end;

procedure TTMSFNCDefaultToolBarButton.SelectLastValue;
begin

end;

procedure TTMSFNCDefaultToolBarButton.SelectNextValue;
begin

end;

procedure TTMSFNCDefaultToolBarButton.SelectPreviousValue;
begin

end;

procedure TTMSFNCDefaultToolBarButton.SelectValueWithCharacter(
  ACharacter: Char);
begin

end;

procedure TTMSFNCDefaultToolBarButton.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FPopup) then
    FPopup.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCDefaultToolBarButton.SetAppearance(
  const Value: TTMSFNCToolBarButtonAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetAutoBitmapSize(const Value: Boolean);
begin
  if FAutoBitmapSize <> Value then
  begin
    FAutoBitmapSize := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetBitmaps(const Value: TTMSFNCScaledBitmaps);
begin
  FBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetBitmapSize(const Value: Single);
begin
  if FBitmapSize <> Value then
  begin
    FBitmapSize := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
begin
  FBitmapContainer := Value;
  UpdateLayout;
  Invalidate;
end;

procedure TTMSFNCDefaultToolBarButton.SetBitmapPosition(
  const Value: TTMSFNCToolBarButtonBitmapPosition);
begin
  if FBitmapPosition <> Value then
  begin
    FBitmapPosition := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetBitmapVisible(const Value: Boolean);
begin
  FBitmapVisible := Value;
  UpdateLayout;
  Invalidate;
end;

procedure TTMSFNCDefaultToolBarButton.SetLargeLayoutAutoBitmapSize(
  const Value: Boolean);
begin
  if FLargeLayoutAutoBitmapSize <> Value then
  begin
    FLargeLayoutAutoBitmapSize := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetLargeLayoutBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FLargeLayoutBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetLargeLayoutBitmapSize(
  const Value: Single);
begin
  if FLargeLayoutBitmapSize <> Value then
  begin
    FLargeLayoutBitmapSize := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetLargeLayoutDisabledBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FLargeLayoutDisabledBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetLargeLayoutHoverBitmaps(
  const Value: TTMSFNCScaledBitmaps);
begin
  FLargeLayoutHoverBitmaps.Assign(Value);
end;

procedure TTMSFNCDefaultToolBarButton.SetLayout(
  const Value: TTMSFNCToolBarButtonLayout);
begin
  if FLayout <> Value then
  begin
    FLayout := Value;
    UpdateLayout;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetCloseOnSelection(const Value: Boolean);
begin
  if FCloseOnSelection <> Value then
  begin
    FCloseOnSelection := Value;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetCompactLayout(
  const Value: TTMSFNCToolBarButtonLayout);
begin
  if FCompactLayout <> Value then
    FCompactLayout := Value;
end;

procedure TTMSFNCDefaultToolBarButton.SetName(const Value: TComponentName);
var
  ChangeText: Boolean;
begin
  ChangeText := not (csLoading in ComponentState) and (Name = Text) and
    ((not Assigned(Owner)) or not (Owner is TComponent) or not (csLoading in TComponent(Owner).ComponentState));
  inherited SetName(Value);
  if ChangeText and ApplyName and CanChangeText then
    Text := StringReplace(Text, 'TMSFNCToolBar', '', [rfReplaceAll]);
end;

procedure TTMSFNCDefaultToolBarButton.SetShowFocus(const Value: Boolean);
begin
  if FShowFocus <> Value then
  begin
    FShowFocus := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetStretchBitmapIfNoText(
  const Value: Boolean);
begin
  if FStretchBitmapIfNoText <> Value then
  begin
    FStretchBitmapIfNoText := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetStretchText(const Value: Boolean);
begin
  if FStretchText <> Value then
  begin
    FStretchText := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetText(const Value: String);
begin
  if FText <> Value then
  begin
    FText := Value;
    FTextVisible := Value <> '';
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetTextVisible(const Value: Boolean);
begin
  if FTextVisible <> Value then
  begin
    FTextVisible := Value;
    UpdateLayout;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetTrimming(
  const Value: TTMSFNCGraphicsTextTrimming);
begin
  if FTrimming <> Value then
  begin
    FTrimming := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetUseStyledDropDownIcon(
  const Value: Boolean);
begin
  if FUseStyledDropDownIcon <> Value then
  begin
    FUseStyledDropDownIcon := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetVerticalTextAlign(
  const Value: TTMSFNCGraphicsTextAlign);
begin
  if FVerticalTextAlign <> Value then
  begin
    FVerticalTextAlign := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.SetWordWrapping(const Value: Boolean);
begin
  if FWordWrapping <> Value then
  begin
    FWordWrapping := Value;
    Invalidate;
  end;
end;

procedure TTMSFNCDefaultToolBarButton.UpdateControlAfterResize;
begin
  inherited;
  if Layout = bblLarge then
    FOldHeight := Height;
end;

procedure TTMSFNCDefaultToolBarButton.UpdateLayout;
var
  sz: TSizeF;
  w: Single;
begin
  if (Layout = bblNone) or FBlockUpdate then
    Exit;

  FBlockUpdate := True;
  case Layout of
    bblBitmap:
    begin
      TextVisible := False;
      BitmapPosition := bbpLeft;
      StretchText := False;
      Height := Round(GetBitmapSize + 6);
      Width := Round(GetBitmapSize + 6);
    end;
    bblLabel:
    begin
      TextVisible := True;
      BitmapPosition := bbpLeft;
      StretchText := False;
      sz := GetTextSize;
      if BitmapVisible then
      begin
        Height := Round(Max(GetBitmapSize, sz.cy) + 6);
        Width := Round(GetBitmapSize + sz.cx + 12);
      end
      else if TextVisible and (Text <> '') then
      begin
        Height := Round(sz.cy + 6);
        Width := Round(sz.cx + 6);
      end
      else
      begin
        Width := 75;
        Height := 24;
      end;
    end;
    bblLarge:
    begin
      TextVisible := True;
      BitmapPosition := bbpTop;
      StretchText := not BitmapVisible;

      sz := GetTextSize;
      w := 30;
      if BitmapVisible then
        w := Max(w, GetLargeLayoutBitmapSize + 6);

      if TextVisible and (Text <> '') then
        w := Max(w, sz.cx + 12);

      Width := Round(w);

      if FOldHeight <> -1 then
        Height := Round(FOldHeight);
    end;
  end;
  FBlockUpdate := False;

  UpdateToolBar;
end;

procedure TTMSFNCDefaultToolBarButton.UpdateState;
var
  f: Single;
begin
  inherited;
  case FState of
    esNormal: f := 0.8;
    esLarge: f := 1.25;
    else
      f := 1;
  end;

  if not (csLoading in ComponentState) then
  begin
    DropDownWidth := DropDownWidth * f;
    DropDownHeight := DropDownHeight * f;
    {$IFDEF FMXLIB}
    Font.Size := Font.Size * f;
    SetBounds(Position.X, Position.Y, int(Width * f), int(Height * f));
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    Font.Size := Round(Font.Size * f);
    SetBounds(Left, Top, Round(Width * f), Round(Height * f));
    {$ENDIF}
  end;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetCorners(const Value: TTMSFNCGraphicsCorners);
begin
  if FCorners <> Value then
  begin
    FCorners := Value;
    Changed;
  end;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetRounding(const Value: Single);
begin
  if FRounding <> Value then
  begin
    FRounding := Value;
    Changed;
  end;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.StrokeChanged(Sender: TObject);
begin
  Changed;
end;

{ TTMSFNCCustomToolBarSeparator }

procedure TTMSFNCCustomToolBarSeparator.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomToolBarSeparator then
  begin
    FAppearance.Assign((Source as TTMSFNCCustomToolBarSeparator).Appearance);
    Invalidate;
  end;
end;

constructor TTMSFNCCustomToolBarSeparator.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF FMXLIB}
  Width := 3;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Width := 2;
  {$ENDIF}
  Height := 30;
  FOrientation := tbsoVertical;
  FAppearance := TTMSFNCToolBarSeparatorAppearance.Create(Self);
end;

destructor TTMSFNCCustomToolBarSeparator.Destroy;
begin
  FAppearance.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBarSeparator.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  cp: TPointF;
  r: TRectF;
begin
  inherited;
  r := LocalRect;
  {$IFDEF FMXLIB}
  cp := r.CenterPoint;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  cp := PointF(r.Left, r.Top);
  {$ENDIF}
  case Orientation of
    tbsoVertical:
    begin
      AGraphics.Stroke.Assign(Appearance.Stroke);
      AGraphics.DrawLine(PointF(cp.X, r.Top), PointF(cp.X, r.Bottom));
      AGraphics.Stroke.Assign(Appearance.InnerStroke);
      AGraphics.DrawLine(PointF(cp.X + 1, r.Top), PointF(cp.X + 1, r.Bottom));
    end;
    tbsoHorizontal:
    begin
      AGraphics.Stroke.Assign(Appearance.Stroke);
      AGraphics.DrawLine(PointF(r.Left, cp.Y), PointF(r.Right, cp.Y));
      AGraphics.Stroke.Assign(Appearance.InnerStroke);
      AGraphics.DrawLine(PointF(r.Left, cp.Y + 1), PointF(r.Right, cp.Y + 1));
    end;
  end;
end;

procedure TTMSFNCCustomToolBarSeparator.SetAppearance(
  const Value: TTMSFNCToolBarSeparatorAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCCustomToolBarSeparator.SetOrientation(const Value: TTMSFNCToolBarSeperatorOrientation);
var
  {$IFDEF FMXLIB}
  t: Single;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  t: Integer;
  {$ENDIF}
begin
  if FOrientation <> Value then
  begin
    FOrientation := Value;

    t := Width;
    Width := Height;
    Height := t;

    Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBarSeparator.UpdateState;
var
  f: Single;
begin
  inherited;
  case State of
    esNormal: f := 0.8;
    esLarge: f := 1.25;
    else
      f := 1;
  end;

  if not (csLoading in ComponentState) then
  begin
    {$IFDEF FMXLIB}
    SetBounds(Position.X, Position.Y, Width, int(Height * f));
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetBounds(Left, Top, Width, Round(Height * f));
    {$ENDIF}
  end;
end;

{ TTMSFNCToolBarCustomButtonAppearance }

procedure TTMSFNCToolBarCustomButtonAppearance.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCToolBarCustomButtonAppearance then
  begin
    FNormalFill.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).NormalFill);
    FDisabledFill.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).DisabledFill);
    FHoverFill.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).HoverFill);
    FDownFill.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).DownFill);
    FNormalStroke.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).NormalStroke);
    FDisabledStroke.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).DisabledStroke);
    FHoverStroke.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).HoverStroke);
    FDownStroke.Assign((Source as TTMSFNCToolBarCustomButtonAppearance).DownStroke);
    FRounding := (Source as TTMSFNCToolBarCustomButtonAppearance).Rounding;
    FCorners := (Source as TTMSFNCToolBarCustomButtonAppearance).Corners;
    FShowInnerStroke := (Source as TTMSFNCToolBarCustomButtonAppearance).ShowInnerStroke;
    FTransparent := (Source as TTMSFNCToolBarCustomButtonAppearance).Transparent;
    FFlatStyle := (Source as TTMSFNCToolBarCustomButtonAppearance).FlatStyle;
  end
  else
    inherited;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.Changed;
begin
  if Assigned(FOwner) then
    FOwner.AppearanceChanged
  else if Assigned(OnChange) then
    OnChange(Self);
end;

constructor TTMSFNCToolBarCustomButtonAppearance.Create(AOwner: TTMSFNCDefaultToolBarButton);
begin
  FOwner := AOwner;
  FCorners := [gcTopLeft, gcTopRight, gcBottomLeft, gcBottomRight];
  FRounding := 3;
  FTransparent := False;
  FShowInnerStroke := True;
  FFlatStyle := False;

  FNormalFill := TTMSFNCGraphicsFill.Create(gfkGradient, MakeGraphicsColor(249, 251, 252), MakeGraphicsColor(230, 235, 235), MakeGraphicsColor(220, 220, 236), MakeGraphicsColor(220, 225, 236));
  FHoverFill := TTMSFNCGraphicsFill.Create(gfkGradient, MakeGraphicsColor(229, 231, 232), MakeGraphicsColor(210, 215, 215), MakeGraphicsColor(200, 200, 216), MakeGraphicsColor(200, 205, 216));
  FDownFill := TTMSFNCGraphicsFill.Create(gfkGradient, MakeGraphicsColor(219, 221, 222), MakeGraphicsColor(200, 205, 205), MakeGraphicsColor(190, 190, 206), MakeGraphicsColor(190, 195, 206));
  FDisabledFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcLightgray);
  FNormalStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);
  FInnerStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcWhite);
  FHoverStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);
  FDownStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);
  FDisabledStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);

  FNormalFill.OnChanged := @FillChanged;
  FHoverFill.OnChanged := @FillChanged;
  FDownFill.OnChanged := @FillChanged;
  FDisabledFill.OnChanged := @FillChanged;

  FInnerStroke.OnChanged := @StrokeChanged;
  FNormalStroke.OnChanged := @StrokeChanged;
  FHoverStroke.OnChanged := @StrokeChanged;
  FDownStroke.OnChanged := @StrokeChanged;
  FDisabledStroke.OnChanged := @StrokeChanged;
end;

destructor TTMSFNCToolBarCustomButtonAppearance.Destroy;
begin
  FNormalFill.Free;
  FHoverFill.Free;
  FDownFill.Free;
  FDisabledFill.Free;

  FInnerStroke.Free;
  FNormalStroke.Free;
  FHoverStroke.Free;
  FDownStroke.Free;
  FDisabledStroke.Free;
  inherited;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.FillChanged(Sender: TObject);
begin
  Changed;
end;

function TTMSFNCToolBarCustomButtonAppearance.IsRoundingStored: Boolean;
begin
  Result := Rounding <> 3;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetDisabledFill(const Value: TTMSFNCGraphicsFill);
begin
  FDisabledFill.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetDisabledStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FDisabledStroke.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetDownFill(const Value: TTMSFNCGraphicsFill);
begin
  FDownFill.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetDownStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FDownStroke.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetFlatStyle(const Value: Boolean);
var
  c: TControl;
  I: Integer;
begin
  if FFlatStyle <> Value then
  begin
    FFlatStyle := Value;
    if Assigned(FOwner) then
    begin
      for I := 0 to FOwner.ControlCount - 1 do
      begin
        c := FOwner.Controls[I];
        {$IFDEF FMXLIB}
        if Supports(c, IDesignerControl) then
          Continue;
        {$ENDIF}

        if c is TTMSFNCDefaultToolBarButton then
          (c as TTMSFNCDefaultToolBarButton).Appearance.FlatStyle := FlatStyle;

        if c is TTMSFNCCustomToolBar then
          (c as TTMSFNCCustomToolBar).Appearance.FlatStyle := FlatStyle;
      end;
    end;

    Changed;
  end;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetHoverFill(const Value: TTMSFNCGraphicsFill);
begin
  FHoverFill.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetHoverStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FHoverStroke.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetInnerStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FInnerStroke.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetNormalFill(const Value: TTMSFNCGraphicsFill);
begin
  FNormalFill.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetNormalStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FNormalStroke.Assign(Value);
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetShowInnerStroke(
  const Value: Boolean);
begin
  if FShowInnerStroke <> Value then
  begin
    FShowInnerStroke := Value;
    Changed;
  end;
end;

procedure TTMSFNCToolBarCustomButtonAppearance.SetTransparent(
  const Value: Boolean);
begin
  if FTransparent <> Value then
  begin
    FTransparent := Value;
    Changed;
  end;
end;

{ TTMSFNCCustomToolBarAppearance }

procedure TTMSFNCCustomToolBarAppearance.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCCustomToolBarAppearance then
  begin
    FSeparatorStroke.Assign((Source as TTMSFNCCustomToolBarAppearance).SeparatorStroke);
    FSeparator := (Source as TTMSFNCCustomToolBarAppearance).Separator;
    FFill.Assign((Source as TTMSFNCCustomToolBarAppearance).Fill);
    FStroke.Assign((Source as TTMSFNCCustomToolBarAppearance).Stroke);
    FHorizontalSpacing := (Source as TTMSFNCCustomToolBarAppearance).HorizontalSpacing;
    FVerticalSpacing := (Source as TTMSFNCCustomToolBarAppearance).VerticalSpacing;
    FDragGripColor := (Source as TTMSFNCCustomToolBarAppearance).DragGripColor;
    FDragGrip := (Source as TTMSFNCCustomToolBarAppearance).DragGrip;
    FFlatStyle := (Source as TTMSFNCCustomToolBarAppearance).FlatStyle;
  end;
end;

constructor TTMSFNCCustomToolBarAppearance.Create(AOwner: TTMSFNCCustomToolBar);
begin
  FOwner := AOwner;
  FFont := TTMSFNCGraphicsFont.Create;
  FFlatStyle := False;
  FHorizontalSpacing := 3;
  FVerticalSpacing := 3;
  FDragGrip := True;
  FDragGripColor := gcLightgray;
  FFill := TTMSFNCGraphicsFill.Create(gfkGradient, gcWhite, MakeGraphicsColor(230, 230, 230));
  FStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);

  FFill.OnChanged := @FillChanged;
  FStroke.OnChanged := @StrokeChanged;

  FSeparatorStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcWhite);
  FSeparatorStroke.OnChanged := @StrokeChanged;
end;

destructor TTMSFNCCustomToolBarAppearance.Destroy;
begin
  FSeparatorStroke.Free;
  FFont.Free;
  FFill.Free;
  FStroke.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBarAppearance.FillChanged(Sender: TObject);
begin
  FOwner.Invalidate;
end;

function TTMSFNCCustomToolBarAppearance.IsHorizontalSpacingStored: Boolean;
begin
  Result := HorizontalSpacing <> 3;
end;

function TTMSFNCCustomToolBarAppearance.IsVerticalSpacingStored: Boolean;
begin
  Result := VerticalSpacing <> 3;
end;

procedure TTMSFNCCustomToolBarAppearance.SetDragGrip(const Value: Boolean);
begin
  if FDragGrip <> Value then
  begin
    FDragGrip := Value;
    FOwner.UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.SetDragGripColor(
  const Value: TTMSFNCGraphicsColor);
begin
  if FDragGripColor <> Value then
  begin
    FDragGripColor := Value;
    FOwner.Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  FFill.Assign(Value);
end;

procedure TTMSFNCCustomToolBarAppearance.SetFlatStyle(const Value: Boolean);
begin
  if FFlatStyle <> Value then
  begin
    FFlatStyle := Value;
    if Assigned(FOwner) then
      FOwner.ApplyFlatStyle;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.SetHorizontalSpacing(
  const Value: Single);
begin
  if FHorizontalSpacing <> Value then
  begin
    FHorizontalSpacing := Value;
    FOwner.UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.SetSeparator(const Value: Boolean);
begin
  if FSeparator <> Value then
  begin
    FSeparator := Value;
    FOwner.Invalidate;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.SetSeparatorStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FSeparatorStroke.Assign(Value);
end;

procedure TTMSFNCCustomToolBarAppearance.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

procedure TTMSFNCCustomToolBarAppearance.SetVerticalSpacing(
  const Value: Single);
begin
  if FVerticalSpacing <> Value then
  begin
    FVerticalSpacing := Value;
    FOwner.UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBarAppearance.StrokeChanged(Sender: TObject);
begin
  FOwner.Invalidate;
end;

{ TTMSFNCCustomToolBarSeparatorAppearance }

procedure TTMSFNCCustomToolBarSeparatorAppearance.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCCustomToolBarSeparatorAppearance then
  begin
    Stroke.Assign((Source as TTMSFNCCustomToolBarSeparatorAppearance).Stroke);
    InnerStroke.Assign((Source as TTMSFNCCustomToolBarSeparatorAppearance).InnerStroke);
  end
  else
    inherited;
end;

constructor TTMSFNCCustomToolBarSeparatorAppearance.Create(
  AOwner: TTMSFNCCustomToolBarSeparator);
begin
  FOwner := AOwner;
  FStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);
  FStroke.OnChanged := @StrokeChanged;
  FInnerStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcWhite);
  FInnerStroke.OnChanged := @StrokeChanged;
end;

destructor TTMSFNCCustomToolBarSeparatorAppearance.Destroy;
begin
  FInnerStroke.Free;
  FStroke.Free;
  inherited;
end;

procedure TTMSFNCCustomToolBarSeparatorAppearance.SetInnerStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FInnerStroke.Assign(Value);
end;

procedure TTMSFNCCustomToolBarSeparatorAppearance.SetStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

procedure TTMSFNCCustomToolBarSeparatorAppearance.StrokeChanged(
  Sender: TObject);
begin
  FOwner.Invalidate;
end;

{ TTMSFNCCustomDockPanel }

function TTMSFNCCustomDockPanel.AddToolBar(AIndex: Integer = -1): TTMSFNCToolBar;
begin
  FBlockUpdate := True;
  Result := TTMSFNCToolBar.Create(Self);
  {$IFDEF FMXLIB}
  if (AIndex >= 0) and (AIndex <= Self.ControlCount - 1) then
    InsertObject(AIndex, Result)
  else
    AddObject(Result);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result.Parent := Self;
  {$ENDIF}

  FBlockUpdate := False;
  UpdateControls;
end;

procedure TTMSFNCCustomDockPanel.ApplyStyle;
var
  c: TTMSFNCGraphicsColor;
begin
  inherited;
  c := gcNull;
  if TTMSFNCStyles.GetStyleHeaderFillColor(c) then
  begin
    Appearance.Fill.Kind := gfkSolid;
    Appearance.Fill.Color := c;
  end;

  if TTMSFNCStyles.GetStyleHeaderFillColorTo(c) then
  begin
    Appearance.Fill.Kind := gfkGradient;
    Appearance.Fill.ColorTo := c;
  end;
end;

procedure TTMSFNCCustomDockPanel.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomDockPanel then
  begin
    Appearance.Assign((Source as TTMSFNCCustomDockPanel).Appearance);
    AutoSize := (Source as TTMSFNCCustomDockPanel).AutoSize;
    AutoAlign := (Source as TTMSFNCCustomDockPanel).AutoAlign;
    State := (Source as TTMSFNCCustomDockPanel).State;
  end
  else
    inherited;
end;

constructor TTMSFNCCustomDockPanel.Create(AOwner: TComponent);
begin
  inherited;
  FState := esNormal;
  FAppearance := TTMSFNCDockPanelAppearance.Create(Self);
  FAutoSize := True;
  FAutoAlign := True;
  {$IFDEF FMXLIB}
  Align := TAlignLayout.Top;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Align := alTop;
  {$ENDIF}
  Height := 40;
end;

destructor TTMSFNCCustomDockPanel.Destroy;
begin
  FAppearance.Free;
  inherited;
end;

{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomDockPanel.AlignControls(AControl: TControl; var Rect: TRect);
begin
  inherited;
  UpdateControls;
end;
{$ENDIF}

{$IFDEF FMXLIB}
procedure TTMSFNCCustomDockPanel.DoAddObject(const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomDockPanel.DoInsertObject(Index: Integer;
  const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomDockPanel.SetBounds(X, Y, AWidth, AHeight: Single);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomDockPanel.DoRemoveObject(
  const AObject: TFmxObject);
begin
  inherited;
  UpdateControls;
end;
{$ENDIF}

function TTMSFNCCustomDockPanel.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncuipack/components/ttmsfnctoolbar';
end;

function TTMSFNCCustomDockPanel.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCCustomDockPanel.InitializeControls;
var
  I: Integer;
  c: TControl;
begin
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];
    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if c is TTMSFNCCustomToolBar then
    begin
      (c as TTMSFNCCustomToolBar).OnUpdateDockPanel := @UpdateDockPanel;
      if (c as TTMSFNCCustomToolBar).FDragGripMoving then
        Continue;
    end;

    if c.Visible then
    begin
      {$IFDEF FMXLIB}
      if c.Position.y < Appearance.Margins.Top then
        c.Position.y := Appearance.Margins.Top;
      if c.Position.x < Appearance.Margins.Left then
        c.Position.x := Appearance.Margins.Left
      else if c.Position.x + c.Width > Width - Appearance.Margins.Right then
        c.Position.x := Width - Appearance.Margins.Right - c.Width;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      if c.Top < Appearance.Margins.Top then
        c.Top := Round(Appearance.Margins.Top);
      if c.Left < Appearance.Margins.Left then
        c.Left := Round(Appearance.Margins.Left)
      else if c.Left + c.Width > Width - Appearance.Margins.Right then
        c.Left := Round(Width - Appearance.Margins.Right - c.Width);
      {$ENDIF}
    end;
  end;
end;

procedure TTMSFNCCustomDockPanel.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  r: TRectF;
begin
  inherited;
  AGraphics.Fill.Assign(Appearance.Fill);
  AGraphics.Stroke.Assign(Appearance.Stroke);

  r := LocalRect;
  AGraphics.DrawRectangle(r);
end;

procedure TTMSFNCCustomDockPanel.RearrangeControls;
var
  c, cl: TControl;
  cr, clr: TRectF;
  I, J: Integer;
begin
  for I := 0 to Self.ControlCount - 1 do
  begin
    c := Self.Controls[I];

    {$IFDEF FMXLIB}
    if Supports(c, IDesignerControl) then
      Continue;
    {$ENDIF}

    if not c.Visible then
      Continue;

    if c is TTMSFNCCustomToolBar then
    begin
      if (c as TTMSFNCCustomToolBar).FDragGripMoving then
        Continue;
    end;

    for J := 0 to Self.ControlCount - 1 do
    begin
      cl := Self.Controls[J];

      if (cl = c) or not cl.Visible then
        Continue;

      {$IFDEF FMXLIB}
      if Supports(cl, IDesignerControl) then
        Continue;
      {$ENDIF}

      {$IFDEF FMXLIB}
      cr := RectF(c.Position.X, c.Position.Y, c.Position.X + c.Width, c.Position.Y + c.Height);
      clr := RectF(cl.Position.X, cl.Position.Y, cl.Position.X + cl.Width, cl.Position.Y + cl.Height);

      if (clr.Left >= cr.Left - 3) and (clr.Left <= cr.Right + 3) then
      begin
        if (clr.Top < CenterPointEx(cr).Y) and (clr.Top >= cr.Top - 3) then
        begin
          cl.Position.X := c.Position.X + c.Width + 3;
          cl.Position.Y := c.Position.Y;
        end
        else if (clr.Top >= CenterPointEx(cr).Y) and (clr.Top <= cr.Bottom + 3) then
        begin
          cl.Position.Y := c.Position.Y + c.Height + 3;
          cl.Position.X := c.Position.X;
        end;
      end;
      {$ENDIF}

      {$IFDEF CMNWEBLIB}
      cr := RectF(c.Left, c.Top, c.Left + c.Width, c.Top + c.Height);
      clr := RectF(cl.Left, cl.Top, cl.Left + cl.Width, cl.Top + cl.Height);

      if (clr.Left >= cr.Left - 3) and (clr.Left <= cr.Right + 3) then
      begin
        if (clr.Top < CenterPointEx(cr).Y) and (clr.Top >= cr.Top - 3) then
        begin
          cl.Left := c.Left + c.Width + 3;
          cl.Top := c.Top;
        end
        else if (clr.Top >= CenterPointEx(cr).Y) and (clr.Top <= cr.Bottom + 3) then
        begin
          cl.Top := c.Top + c.Height + 3;
          cl.Left := c.Left;
        end;
      end;
      {$ENDIF}
    end;
  end;
end;

procedure TTMSFNCCustomDockPanel.ResetToDefaultStyle;
begin
  inherited;

end;

procedure TTMSFNCCustomDockPanel.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  UpdateControls;
end;

procedure TTMSFNCCustomDockPanel.SetAppearance(
  const Value: TTMSFNCDockPanelAppearance);
begin
  FAppearance.Assign(Value);
end;

procedure TTMSFNCCustomDockPanel.SetAutoAlign(const Value: Boolean);
begin
  if FAutoAlign <> Value then
  begin
    FAutoAlign := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomDockPanel.SetAS(const Value: Boolean);
begin
  if FAutoSize <> Value then
  begin
    FAutoSize := Value;
    UpdateControls;
  end;
end;

procedure TTMSFNCCustomDockPanel.SetState(
  const Value: TTMSFNCToolBarElementState);
var
  I: Integer;
  c: TControl;
begin
  if FState <> Value then
  begin
    FState := Value;
    for I := 0 to Self.ControlCount - 1 do
    begin
      c := Self.Controls[I];
      if c is TTMSFNCCustomToolBar then
        (c as TTMSFNCCustomToolBar).State := FState;
    end;
  end;
end;

procedure TTMSFNCCustomDockPanel.UpdateControls;
var
  I: Integer;
  {$IFDEF FMXLIB}
  h, hsm: Single;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  h, hsm: Integer;
  {$ENDIF}
  c: TControl;
  {$IFDEF FNCLIB}
  ia: ITMSFNCAdaptToStyle;
  {$ENDIF}
begin
  if FBlockUpdate or IsLoading or IsDestroying then
    Exit;

  FBlockUpdate := True;
  h := 0;
  hsm := ScalePaintValue(30);

  if AutoAlign then
  begin
    InitializeControls;
    RearrangeControls;
  end;

  if AutoSize then
  begin
    for I := 0 to Self.ControlCount - 1 do
    begin
      c := Self.Controls[I];
      {$IFDEF FMXLIB}
      if Supports(c, IDesignerControl) then
        Continue;

      if c.Visible then
        h := Max(h, c.Position.y + c.Height + Appearance.Margins.Bottom);
      {$ENDIF}

      {$IFDEF FNCLIB}
      if Supports(c, ITMSFNCAdaptToStyle, ia) then
        ia.AdaptToStyle := AdaptToStyle;
      {$ENDIF}

      {$IFDEF CMNWEBLIB}
      if c.Visible then
        h := Round(Max(h, c.Top + c.Height + Appearance.Margins.Bottom));
      {$ENDIF}
    end;

    if h = 0 then
      h := hsm;

    if csDesigning in ComponentState then
      h := h + ScalePaintValue(15);

    {$IFDEF FMXLIB}
    SetBounds(Position.X, Position.Y, Width, h);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetBounds(Left, Top, Width, h);
    {$ENDIF}
  end;

  FBlockUpdate := False;
end;

procedure TTMSFNCCustomDockPanel.UpdateDockPanel(Sender: TObject);
begin
  UpdateControls;
end;

{ TTMSFNCCustomDockPanelAppearance }

constructor TTMSFNCCustomDockPanelAppearance.Create(AOwner: TTMSFNCCustomDockPanel);
begin
  FOwner := AOwner;
  FFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcWhite);
  FStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcGray);

  FFill.OnChanged := @FillChanged;
  FStroke.OnChanged := @StrokeChanged;
  FMargins := TTMSFNCMargins.Create;
  FMargins.Left := 3;
  FMargins.Top := 3;
  FMargins.Bottom := 3;
  FMargins.Right := 3;
end;

destructor TTMSFNCCustomDockPanelAppearance.Destroy;
begin
  FMargins.Free;
  FFill.Free;
  FStroke.Free;
  inherited;
end;

procedure TTMSFNCCustomDockPanelAppearance.FillChanged(Sender: TObject);
begin
  FOwner.Invalidate;
end;

procedure TTMSFNCCustomDockPanelAppearance.MarginsChanged(
  Sender: TObject);
begin
  FOwner.UpdateControls;
end;

procedure TTMSFNCCustomDockPanelAppearance.SetFill(const Value: TTMSFNCGraphicsFill);
begin
  FFill.Assign(Value);
end;

procedure TTMSFNCCustomDockPanelAppearance.SetMargins(
  const Value: TTMSFNCMargins);
begin
  FMargins.Assign(Value);
end;

procedure TTMSFNCCustomDockPanelAppearance.SetStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FStroke.Assign(Value);
end;

procedure TTMSFNCCustomDockPanelAppearance.StrokeChanged(Sender: TObject);
begin
  FOwner.Invalidate;
end;

{ TTMSFNCCustomToolBarElement }

procedure TTMSFNCCustomToolBarElement.UpdateToolBarControl;
begin
  if Assigned(OnUpdateToolBarControl) then
    OnUpdateToolBarControl(Self);
end;

procedure TTMSFNCCustomToolBarElement.ReadControlIndex(Reader: TReader);
begin
  ControlIndex := Reader.ReadInteger;
end;

procedure TTMSFNCCustomToolBarElement.WriteControlIndex(Writer: TWriter);
begin
  Writer.WriteInteger(ControlIndex);
end;

procedure TTMSFNCCustomToolBarElement.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCCustomToolBarElement then
  begin
    FState := (Source as TTMSFNCCustomToolBarElement).State;
    FLastElement := (Source as TTMSFNCCustomToolBarElement).LastElement;
    FCanCopy := (Source as TTMSFNCCustomToolBarElement).CanCopy;
  end;
end;

constructor TTMSFNCCustomToolBarElement.Create(AOwner: TComponent);
begin
  inherited;
  DisableBackground;
  {$IFDEF CMNLIB}
  ParentColor := True;
  {$IFDEF VCLLIB}
  ParentBackground := True;
  {$ENDIF}
  {$ENDIF}
  FLastElement := False;
  FCanCopy := True;
  FState := esNormal;
end;

procedure TTMSFNCCustomToolBarElement.DefineProperties(Filer: TFiler);
begin
  inherited;
  {$IFDEF LCLWEBLIB}
  Filer.DefineProperty('ControlIndex', @ReadControlIndex, @WriteControlIndex, True);
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  Filer.DefineProperty('ControlIndex', ReadControlIndex, WriteControlIndex, True);
  {$ENDIF}
end;

destructor TTMSFNCCustomToolBarElement.Destroy;
begin
  inherited;
end;

function TTMSFNCCustomToolBarElement.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncuipack/components/ttmsfnctoolbar';
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBarElement.DoMatrixChanged(Sender: TObject);
begin
  inherited;
  UpdateToolBar;
end;
{$ENDIF}

procedure TTMSFNCCustomToolBarElement.UpdateControlAfterResize;
begin
  inherited;
  UpdateToolBar;
end;

procedure TTMSFNCCustomToolBarElement.SetLastElement(const Value: Boolean);
begin
  if FLastElement <> Value then
  begin
    FLastElement := Value;
    UpdateToolBar;
  end;
end;

procedure TTMSFNCCustomToolBarElement.SetState(
  const Value: TTMSFNCToolBarElementState);
begin
  if FState <> Value then
  begin
    FState := Value;
    UpdateState;
  end;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomToolBarElement.SetVisible(const Value: Boolean);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomToolBarElement.VisibleChanging;
{$ENDIF}
begin
  inherited;
  {$IFDEF FMXLIB}
  if Visible <> Value then
  {$ENDIF}
    UpdateToolBar;
end;

procedure TTMSFNCCustomToolBarElement.UpdateState;
begin

end;

procedure TTMSFNCCustomToolBarElement.UpdateToolBar;
begin
  if Assigned(OnUpdateToolBar) and not FBlockUpdate then
    OnUpdateToolBar(Self);
end;

{ TTMSFNCToolBarControl }

constructor TTMSFNCToolBarControl.Create;
begin
  FBitmap := TTMSFNCBitmap.Create;
end;

destructor TTMSFNCToolBarControl.Destroy;
begin 
  FBitmap.Free;
  inherited;
end;

{ TTMSFNCCustomToolBarOptionsMenu }

procedure TTMSFNCCustomToolBarOptionsMenu.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCCustomToolBarOptionsMenu then
  begin
    FShowItemText := (Source as TTMSFNCCustomToolBarOptionsMenu).ShowItemText;
    FShowItemBitmap := (Source as TTMSFNCCustomToolBarOptionsMenu).ShowItemBitmap;
    FShowButton := (Source as TTMSFNCCustomToolBarOptionsMenu).ShowButton;
    FAutoItemBitmapWidth := (Source as TTMSFNCCustomToolBarOptionsMenu).AutoItemBitmapWidth;
    FItemBitmapWidth := (Source as TTMSFNCCustomToolBarOptionsMenu).ItemBitmapWidth;
  end;
end;

constructor TTMSFNCCustomToolBarOptionsMenu.Create(
  AOwner: TTMSFNCCustomToolBar);
begin
  FOwner := AOwner;
  FShowItemText := True;
  FShowButton := True;
  FShowItemBitmap := True;
  FAutoItemBitmapWidth := True;
  FItemBitmapWidth := 50;
end;

destructor TTMSFNCCustomToolBarOptionsMenu.Destroy;
begin

  inherited;
end;

function TTMSFNCCustomToolBarOptionsMenu.IsItemBitmapWidthStored: Boolean;
begin
  Result := ItemBitmapWidth <> 50;
end;

procedure TTMSFNCCustomToolBarOptionsMenu.SetAutoItemBitmapWidth(
  const Value: Boolean);
begin
  if FAutoItemBitmapWidth <> Value then
  begin
    FAutoItemBitmapWidth := Value;
  end;
end;

procedure TTMSFNCCustomToolBarOptionsMenu.SetItemBitmapWidth(
  const Value: Single);
begin
  if FItemBitmapWidth <> Value then
  begin
    FItemBitmapWidth := Value;
  end;
end;

procedure TTMSFNCCustomToolBarOptionsMenu.SetShowButton(const Value: Boolean);
begin
  if FShowButton <> Value then
  begin
    FShowButton := Value;
    FOwner.FOptionsMenuButton.Visible := FShowButton;
    if FShowButton then
      FOwner.FOptionsMenuButton.Parent := FOwner
    else
      FOwner.FOptionsMenuButton.Parent := nil;

    FOwner.UpdateControls;
  end;
end;

procedure TTMSFNCCustomToolBarOptionsMenu.SetShowItemBitmap(
  const Value: Boolean);
begin
  if FShowItemBitmap <> Value then
  begin
    FShowItemBitmap := Value;
  end;
end;

procedure TTMSFNCCustomToolBarOptionsMenu.SetShowItemText(const Value: Boolean);
begin
  if FShowItemText <> Value then
  begin
    FShowItemText := Value;
  end;
end;

{ TTMSFNCToolBarFontNamePicker }

constructor TTMSFNCToolBarFontNamePicker.Create(AOwner: TComponent);
begin
  inherited;
  AutoOptionsMenuText := 'Font Name';
  TTMSFNCUtils.GetFonts(FItems);
  {$IFDEF LCLLIB}
  FItems.Insert(0, 'Default');
  {$ENDIF}
end;

procedure TTMSFNCToolBarFontNamePicker.DoItemSelected;
begin
  inherited;
  if Assigned(OnFontNameSelected) then
    OnFontNameSelected(Self, SelectedFontName);
end;

function TTMSFNCToolBarFontNamePicker.GetSelectedFontName: String;
begin
  Result := GetSelectedItem;
end;

procedure TTMSFNCToolBarFontNamePicker.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarFontNamePicker);
end;

procedure TTMSFNCToolBarFontNamePicker.SetSelectedFontName(const Value: String);
begin
  SelectedItem := Value;
end;

{ TTMSFNCToolBarFontNamePicker }

constructor TTMSFNCToolBarFontSizePicker.Create(AOwner: TComponent);
begin
  inherited;
  AutoOptionsMenuText := 'Font Size';
  FItems.Add('8');
  FItems.Add('9');
  FItems.Add('10');
  FItems.Add('11');
  FItems.Add('12');
  FItems.Add('14');
  FItems.Add('16');
  FItems.Add('18');
  FItems.Add('20');
  FItems.Add('22');
  FItems.Add('24');
  FItems.Add('26');
  FItems.Add('28');
  FItems.Add('36');
  FItems.Add('48');
  FItems.Add('72');
end;

procedure TTMSFNCToolBarFontSizePicker.DoItemSelected;
begin
  inherited;
  if Assigned(OnFontSizeSelected) then
    OnFontSizeSelected(Self, SelectedFontSize);
end;

function TTMSFNCToolBarFontSizePicker.GetSelectedFontSize: Single;
var
  s: String;
begin
  Result := -1;
  s := GetSelectedItem;
  if s <> '' then
    Result := StrToFloat(GetSelectedItem)
end;

procedure TTMSFNCToolBarFontSizePicker.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarFontSizePicker);
end;

procedure TTMSFNCToolBarFontSizePicker.SetSelectedFontSize(const Value: Single);
begin
  SelectedItem := FloatToStr(Value);
end;

{ TTMSFNCToolBarColorPicker }

function TTMSFNCToolBarColorPicker.BlockChange: Boolean;
begin
  Result := FColorSelector.BlockChange;
end;

function TTMSFNCToolBarColorPicker.CanChangeText: Boolean;
begin
  Result := not (csLoading in ComponentState) and not (csDesigning in ComponentState);
end;

procedure TTMSFNCToolBarColorPicker.ColorSelected(Sender: TObject;
  AColor: TTMSFNCGraphicsColor);
begin
  if CloseOnSelection and not BlockChange then
    CloseDropDown;
  DoColorSelected(AColor);
  Invalidate;
end;

function TTMSFNCToolBarColorPicker.ColorSelector: TTMSFNCColorSelector;
begin
  Result := FColorSelector;
end;

constructor TTMSFNCToolBarColorPicker.Create(AOwner: TComponent);
begin
  inherited;
  Width := 40;
  Height := 24;
  AutoOptionsMenuText := 'Color';
  FColorSelector := TTMSFNCColorSelector.Create(Self);
  FColorSelector.Appearance.HorizontalSpacing := 2;
  FColorSelector.Appearance.VerticalSpacing := 2;
  FColorSelector.Mode := csmExtended;
  FColorSelector.Width := 175;
  FColorSelector.Height := 125;
  FColorSelector.Stored := False;
  FColorSelector.SelectedColor := gcBlack;
  FColorSelector.OnColorSelected := @ColorSelected;

  DropDownControl := FColorSelector;
  DropDownWidth := FColorSelector.Width;
  DropDownHeight := FColorSelector.Height;
  DropDownKind := ddkDropDownButton;
end;

procedure TTMSFNCToolBarColorPicker.DoColorSelected(AColor: TTMSFNCGraphicsColor);
begin
  if Assigned(OnColorSelected) then
    OnColorSelected(Self, AColor);
end;

procedure TTMSFNCToolBarColorPicker.DrawColor(AColor: TTMSFNCGraphicsColor;
  ARect: TRectF; AGraphics: TTMSFNCGraphics);
var
  r: TRectF;
  rounding: integer;
  I, J: Integer;
  st: TTMSFNCGraphicsSaveState;
begin
  R := ARect;

  rounding := Round(Max(ScalePaintValue(3.5), Appearance.Rounding / 4));

  InflateRectEx(R, -rounding, -rounding);
  OffsetRectEx(R, ScalePaintValue(0.5), ScalePaintValue(0.5));
  st := AGraphics.SaveState;
  try
    AGraphics.ClipRect(R);
    AGraphics.Stroke.Kind := gskNone;
    AGraphics.Fill.Kind := gfkSolid;
    AGraphics.Stroke.Width := 1;
    AGraphics.Fill.Color := MakeGraphicsColor(255, 255, 255);
    AGraphics.DrawRectangle(R);
    AGraphics.Fill.Color := MakeGraphicsColor(211 , 211 , 211 );
    for I := 0 to Trunc((r.Right - r.Left) / 5) + 1 do
      for J := 0 to Trunc((r.Bottom - r.Top) / 5) + 1 do
        if Odd(I + J) then
          AGraphics.DrawRectangle(RectF(I * 5, J * 5, (I + 1) * 5, (J + 1) * 5), gcrmNone);

    AGraphics.Fill.Kind := gfkSolid;
    AGraphics.Fill.Color := AColor;
    AGraphics.Stroke.Color := gcBlack;
    AGraphics.Stroke.Kind := gskSolid;
    AGraphics.DrawRectangle(R);
  finally
    AGraphics.RestoreState(st);
  end;
end;

procedure TTMSFNCToolBarColorPicker.DrawSelectedColor(
  AGraphics: TTMSFNCGraphics; ARect: TRectF);
var
  R: TRectF;
  c: TTMSFNCGraphicsColor;
  ct: TTMSFNCToolBarDropDownButton;
begin
  ct := GetDropDownButtonControl;
  if Assigned(ct) then
  begin
    R := RectF(0, 0, Width - ct.Width, Height);
    c := SelectedColor;
    DrawColor(c, r, AGraphics);
  end;
end;

function TTMSFNCToolBarColorPicker.GetItems: TTMSFNCColorSelectorItems;
begin
  Result := FColorSelector.Items;
end;

function TTMSFNCToolBarColorPicker.GetSelectedColor: TTMSFNCGraphicsColor;
begin
  Result := FColorSelector.SelectedColor;
end;

function TTMSFNCToolBarColorPicker.GetSelectedItemIndex: Integer;
begin
  Result := FColorSelector.SelectedItemIndex;
end;

procedure TTMSFNCToolBarColorPicker.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarColorPicker);
end;

procedure TTMSFNCToolBarColorPicker.Draw(AGraphics: TTMSFNCGraphics; ARect: TRectF);
begin
  inherited;
  DrawSelectedColor(AGraphics, ARect);
end;

procedure TTMSFNCToolBarColorPicker.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FColorSelector) then
    FColorSelector.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCToolBarColorPicker.SetItems(
  const Value: TTMSFNCColorSelectorItems);
begin
  FColorSelector.Items.Assign(Value);
end;

procedure TTMSFNCToolBarColorPicker.SetSelectedColor(const Value: TTMSFNCGraphicsColor);
begin
  FColorSelector.SelectedColor := Value;
  Invalidate;
end;

procedure TTMSFNCToolBarColorPicker.SetSelectedItemIndex(const Value: Integer);
begin
  FColorSelector.SelectedItemIndex := Value;
  Invalidate;
end;

{ TTMSFNCToolBarBitmapPicker }

function TTMSFNCToolBarBitmapPicker.BitmapSelector: TTMSFNCBitmapSelector;
begin
  Result := FBitmapSelector;
end;

function TTMSFNCToolBarBitmapPicker.BlockChange: Boolean;
begin
  Result := FBitmapSelector.BlockChange;
end;

procedure TTMSFNCToolBarBitmapPicker.BitmapSelected(Sender: TObject;
  ABitmap: TTMSFNCBitmap);
begin
  Bitmaps.Clear;
  DisabledBitmaps.Clear;
  HoverBitmaps.Clear;
  Bitmaps.AddBitmap(ABitmap);
  DisabledBitmaps.AddBitmap(ABitmap);
  HoverBitmaps.AddBitmap(ABitmap);

  if CloseOnSelection and not BlockChange then
    CloseDropDown;
  DoBitmapSelected(ABitmap);
end;

function TTMSFNCToolBarBitmapPicker.CanChangeText: Boolean;
begin
  Result := not (csLoading in ComponentState) and not (csDesigning in ComponentState);
end;

constructor TTMSFNCToolBarBitmapPicker.Create(AOwner: TComponent);
begin
  inherited;
  Width := 40;
  Height := 24;
  AutoOptionsMenuText := 'Bitmap';
  FBitmapSelector := TTMSFNCBitmapSelector.Create(Self);
  FBitmapSelector.Appearance.HorizontalSpacing := 2;
  FBitmapSelector.Appearance.VerticalSpacing := 2;
  FBitmapSelector.Stored := False;
  FBitmapSelector.OnBitmapSelected := @BitmapSelected;

  DropDownControl := FBitmapSelector;
  DropDownWidth := FBitmapSelector.Width;
  DropDownHeight := FBitmapSelector.Height;
  DropDownKind := ddkDropDownButton;
end;

procedure TTMSFNCToolBarBitmapPicker.DoBitmapSelected(ABitmap: TTMSFNCBitmap);
begin
  if Assigned(OnBitmapSelected) then
    OnBitmapSelected(Self, ABitmap);
end;

function TTMSFNCToolBarBitmapPicker.GetBitmapRect(ARect: TRectF): TRectF;
var
  r: TRectF;
  dr: TRectf;
begin
  r := ARect;
  Result := RectF(r.Left, r.Top, r.Right, r.Bottom);
  if BitmapVisible then
  begin
    if DropDownKind <> ddkNormal then
    begin
      dr := GetDropDownRect;
      case DropDownPosition of
        ddpRight: Result := RectF(Result.Left + 3, Result.Top + 3, dr.Left - 3, Result.Bottom - 3);
        ddpBottom: Result := RectF(Result.Left + 3, Result.Top + 3, Result.Right - 3, dr.Top - 3);
      end;
    end
    else
      Result := RectF(Result.Left + 3, Result.Top + 3, Result.Right - 3, Result.Bottom - 3);
  end;
end;

function TTMSFNCToolBarBitmapPicker.GetItems: TTMSFNCBitmapSelectorItems;
begin
  Result := FBitmapSelector.Items;
end;

function TTMSFNCToolBarBitmapPicker.GetSelectedBitmap: TTMSFNCBitmap;
begin
  Result := FBitmapSelector.SelectedBitmap;
end;

function TTMSFNCToolBarBitmapPicker.GetSelectedItemIndex: Integer;
begin
  Result := FBitmapSelector.SelectedItemIndex;
end;

procedure TTMSFNCToolBarBitmapPicker.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarBitmapPicker);
end;

procedure TTMSFNCToolBarBitmapPicker.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FBitmapSelector) then
    FBitmapSelector.AdaptToStyle := AdaptToStyle;
end;

procedure TTMSFNCToolBarBitmapPicker.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
begin
  inherited;
  if Assigned(FBitmapSelector) then
    FBitmapSelector.BitmapContainer := Value;
end;

procedure TTMSFNCToolBarBitmapPicker.SetItems(
  const Value: TTMSFNCBitmapSelectorItems);
begin
  if Assigned(FBitmapSelector) then
    FBitmapSelector.Items.Assign(Value);
end;

procedure TTMSFNCToolBarBitmapPicker.SetSelectedItemIndex(const Value: Integer);
begin
  FBitmapSelector.SelectedItemIndex := Value;
  Bitmaps.Clear;
  DisabledBitmaps.Clear;
  HoverBitmaps.Clear;
  Bitmaps.AddBitmap(SelectedBitmap);
  DisabledBitmaps.AddBitmap(SelectedBitmap);
  HoverBitmaps.AddBitmap(SelectedBitmap);
  Invalidate;
end;

{ TTMSFNCToolBarDropDownButton }

constructor TTMSFNCToolBarDropDownButton.Create(AOwner: TComponent);
begin
  inherited;
  FDefaultStyle := True;
end;

procedure TTMSFNCToolBarDropDownButton.DrawBitmap(AGraphics: TTMSFNCGraphics;
  ARect: TRectF);
var
  bmp: TTMSFNCBitmapHelperClass;
  bmpa: TBitmap;
  r: TRectF;
  g: TTMSFNCGraphics;
begin
  if DefaultStyle then
  begin
    r := ARect;

    if not(Assigned(Owner) and (Owner is TTMSFNCCustomToolBarButton) and ((Owner as TTMSFNCCustomToolBarButton).FDropDownPosition = ddpBottom)) then
      InflateRectEx(r, ScalePaintValue(-2),ScalePaintValue(-2));

    inherited DrawBitmap(AGraphics, r);
  end
  else
  begin
    bmpa := TBitmap.Create;
    bmpa.SetSize(7, 7);
    {$IFDEF CMNLIB}
    bmpa.TransparentMode := tmFixed;
    bmpa.Transparent := True;
    bmpa.TransparentColor := gcWhite;
    {$ENDIF}
    g := TTMSFNCGraphics.Create(bmpa.Canvas);
    try
      g.BeginScene;
      {$IFDEF CMNLIB}
      g.Fill.Color := gcWhite;
      g.Fill.Kind := gfkSolid;
      g.Stroke.Kind := gskSolid;
      g.Stroke.Color := gcWhite;
      g.DrawRectangle(0, 0, bmpa.Width, bmpa.Height);
      {$ENDIF}
      g.Stroke.Kind := gskSolid;
      g.Stroke.Color := gcDarkgray;
      g.DrawLine(PointF(0, 1), PointF(6, 1), gcpmRightDown);
      g.DrawLine(PointF(0, 2), PointF(6, 2), gcpmRightDown);
      g.DrawLine(PointF(1, 3), PointF(5, 3), gcpmRightDown);
      g.DrawLine(PointF(2, 4), PointF(4, 4), gcpmRightDown);
      g.DrawLine(PointF(3, 5), PointF(3, 5), gcpmRightDown);
    finally
      g.EndScene;
      g.Free;
    end;

    try
      r := ARect;
      bmp := TTMSFNCBitmap.Create;
      try
        bmp.Assign(bmpa);
        AGraphics.DrawBitmap(r, bmp);
      finally
        bmp.Free;
      end;
    finally
      bmpa.Free;
    end;
  end;
end;

function TTMSFNCToolBarDropDownButton.GetBitmapRect(ARect: TRectF): TRectF;
var
  r: TRectF;
begin
  r := ARect;
  Result := RectF(r.Left + 3, r.Top + 3, r.Right - 3, r.Bottom - 3);
end;

procedure TTMSFNCToolBarDropDownButton.LoadSettingsFromFile(AFileName: string);
begin
  inherited;
  DefaultStyle := False;
end;

procedure TTMSFNCToolBarDropDownButton.LoadSettingsFromStream(
  AStream: TStream);
begin
  inherited;
  DefaultStyle := False;
end;

procedure TTMSFNCToolBarDropDownButton.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarDropDownButton);
end;

procedure TTMSFNCToolBarDropDownButton.SetDefaultStyle(const Value: Boolean);
begin
  if FDefaultStyle <> Value then
  begin
    FDefaultStyle := Value;
    Invalidate;
  end;
end;

{ TTMSFNCToolBarCustomItemPicker }

function TTMSFNCToolBarCustomItemPicker.CanChangeText: Boolean;
begin
  Result := not (csLoading in ComponentState) and not (csDesigning in ComponentState);
end;

procedure TTMSFNCToolBarCustomItemPicker.ChangeDPIScale(M, D: Integer);
begin
  inherited;
  {$IFDEF CMNLIB}
  FItemSelector.Font.Height := TTMSFNCUtils.MulDivInt(FItemSelector.Font.Height, M, D);
  FItemSelector.ItemHeight := TTMSFNCUtils.MulDivInt(FItemSelector.ItemHeight, M, D);
  {$ENDIF}
end;

constructor TTMSFNCToolBarCustomItemPicker.Create(AOwner: TComponent);
begin
  inherited;
  FTimer := TTimer.Create(Self);
  FTimer.Interval := 1;
  FTimer.OnTimer := @EnterTimerChanged;
  FTimer.Enabled := False;

  FEdit := TEdit.Create(Self);
  FEdit.TabStop := True;
  {$IFDEF FMXLIB}
  FEdit.Align := TAlignLayout.Client;
  FEdit.Stored := False;
  FEdit.OnChangeTracking := @EditChange;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FEdit.Align := alClient;
  FEdit.OnChange := @EditChange;
  {$ENDIF}

  Width := 100;
  Height := 24;
  HorizontalTextAlign := gtaLeading;
  FItemIndex := -1;

  FItemSelector := TListBox.Create(Self);
  FItemSelector.Width := 200;
  FItemSelector.Height := 150;
  {$IFDEF LCLLIB}
  FItemSelector.ClickOnSelChange := False;
  {$ENDIF}
  {$IFDEF FMXLIB}
  FItemSelector.Align := TAlignLayout.Client;
  FItemSelector.OnItemClick := @ItemSelected;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FItemSelector.Font.Height := -11;
  FItemSelector.Align := alClient;
  FItemSelector.OnClick := @ItemSelected;
  {$ENDIF}

  FItemSelector.OnKeyUp := @ItemKeyUp;
  FItemSelector.OnKeyDown := @ItemKeyDown;

  DropDownControl := FItemSelector;
  DropDownKind := ddkDropDownButton;
  DropDownWidth := FItemSelector.Width;
  DropDownHeight := FItemSelector.Height;

  FItems := TStringList.Create;
end;

destructor TTMSFNCToolBarCustomItemPicker.Destroy;
begin
  FTimer.Free;
  FItems.Free;
  inherited;
end;

procedure TTMSFNCToolBarCustomItemPicker.DoEnter;
begin
  inherited;
  FTimer.Enabled := Editable;
end;

procedure TTMSFNCToolBarCustomItemPicker.DoItemSelected;
begin
  if Assigned(FEdit) {$IFDEF CMNWEBLIB} and FEdit.HandleAllocated{$ENDIF} then
  begin
    FEdit.Text := SelectedItem;
    FEdit.SelStart := Length(FEdit.Text);
  end;

  if Assigned(OnItemSelected) then
    OnItemSelected(Self, SelectedItemIndex);
end;

procedure TTMSFNCToolBarCustomItemPicker.Draw(AGraphics: TTMSFNCGraphics;
  ARect: TRectF);
begin
  if not Editable then
    inherited;
end;

procedure TTMSFNCToolBarCustomItemPicker.DropDown;
begin
  inherited;
  if not Assigned(FPopup) then
    Exit;

  {$IFDEF CMNLIB}
  if Assigned(FItemSelector) then
    FItemSelector.Font.Height := ScalePaintValue(-11);
  {$ENDIF}

  if FPopup.IsOpen and Assigned(FItemSelector) then
  begin
    FItemSelector.ItemIndex := -1;
    FItemSelector.ItemIndex := SelectedItemIndex;
  end;
end;

procedure TTMSFNCToolBarCustomItemPicker.EditChange(Sender: TObject);
begin
  SelectedItem := FEdit.Text;
  if Assigned(OnEditChange) then
    OnEditChange(Self);
end;

procedure TTMSFNCToolBarCustomItemPicker.EnterTimerChanged(Sender: TObject);
begin
  FEdit.SetFocus;
  FTimer.Enabled := False;
end;

function TTMSFNCToolBarCustomItemPicker.GetSelectedItem: String;
begin
  Result := '';
  if Assigned(FItems) and (FItemIndex >= 0) and (FItemIndex <= FItems.Count - 1) then
    Result := FItems[FItemIndex]
end;

function TTMSFNCToolBarCustomItemPicker.GetSelectedItemIndex: Integer;
begin
  Result := FItemIndex;
end;

function TTMSFNCToolBarCustomItemPicker.GetText: String;
begin
  if Editable then
    Result := FEdit.Text
  else
    Result := SelectedItem;
end;

procedure TTMSFNCToolBarCustomItemPicker.HandleDialogKey(var Key: Word;
  Shift: TShiftState);
begin
  inherited;
  if Shift <> [] then
    Exit;

  if Editable and FEdit.IsFocused then
  begin
    case Key of
      KEY_F4:
      begin
        if not (ssAlt in Shift) then
          DropDown;
      end;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomItemPicker.InitializePopup;
begin
  {$IFDEF FMXLIB}
  FItemSelector.BeginUpdate;
  {$ENDIF}
  FItemSelector.Items.Clear;
  FItemSelector.Items.Assign(FItems);
  FItemSelector.ItemIndex := FItemIndex;
  {$IFDEF FMXLIB}
  FItemSelector.EndUpdate;
  {$ENDIF}
end;

{$IFDEF FMXLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  FKeyboardUsed := True;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemKeyUp(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if (Key = KEY_RETURN) or (Key = KEY_SPACE) then
  begin
    NotifyDataBinderEdit;
    FItemIndex := FItemSelector.ItemIndex;
    NotifyDataBinderValueChanged;

    if CloseOnSelection then
      DropDown;

    DoItemSelected;
    Invalidate;
  end;

  FKeyBoardUsed := False;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemSelected(const Sender: TCustomListBox; const Item: TListBoxItem);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCToolBarCustomItemPicker.ItemSelected(Sender: TObject);
{$ENDIF}
begin
  if FKeyBoardUsed then
    Exit;

  NotifyDataBinderEdit;
  FItemIndex := FItemSelector.ItemIndex;
  NotifyDataBinderValueChanged;

  if CloseOnSelection then
    DropDown;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectFirstValue;
begin
  inherited;
  NotifyDataBinderEdit;
  FItemIndex := 0;
  NotifyDataBinderValueChanged;
  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectLastValue;
begin
  inherited;
  NotifyDataBinderEdit;
  FItemIndex := FItems.Count - 1;
  NotifyDataBinderValueChanged;
  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectNextValue;
begin
  inherited;
  NotifyDataBinderEdit;
  if FItemIndex = -1 then
    FItemIndex := 0
  else
    FItemIndex := Min(FItems.Count - 1, FItemIndex + 1);
  NotifyDataBinderValueChanged;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectPreviousValue;
begin
  inherited;
  NotifyDataBinderEdit;
  if FItemIndex = -1 then
    FItemIndex := 0
  else
    FItemIndex := Max(0, FItemIndex - 1);
  NotifyDataBinderValueChanged;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectValueWithCharacter(
  ACharacter: Char);
var
  I: Integer;
begin
  inherited;
  for I := 0 to Items.Count - 1 do
  begin
    if TTMSFNCUtils.MatchStrEx(ACharacter + '*', Items[I], False) then
    begin
      FItemIndex := I;
      DoItemSelected;
      Invalidate;
      Break;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomItemPicker.SelectValueWithString(AValue: string);
var
  I: Integer;
begin
  inherited;
  for I := 0 to Items.Count - 1 do
  begin
    if TTMSFNCUtils.MatchStrEx(AValue + '*', Items[I], False) then
    begin
      FItemIndex := I;
      DoItemSelected;
      Invalidate;
      Break;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomItemPicker.SetEditable(const Value: Boolean);
begin
  if FEditable <> Value then
  begin
    FEditable := Value;
    if Assigned(FEdit) then
    begin
      if FEditable then
      begin
        FEdit.Parent := Self;
      end
      else
        FEdit.Parent := nil;

      FEdit.Visible := FEditable;
    end;
    Invalidate;
  end;
end;

procedure TTMSFNCToolBarCustomItemPicker.SetItems(const Value: TStringList);
begin
  FItems.Assign(Value);
end;

procedure TTMSFNCToolBarCustomItemPicker.SetSelectedItem(const Value: String);
begin
  FItemIndex := FItems.IndexOf(Value);
  Invalidate;
end;

procedure TTMSFNCToolBarCustomItemPicker.SetSelectedItemIndex(
  const Value: Integer);
begin
  FItemIndex := Value;
  Invalidate;
end;

{$IFDEF FNCLIB}

{ TTMSFNCToolBarCustomComboBox }

function TTMSFNCToolBarCustomComboBox.CanChangeText: Boolean;
begin
  Result := not (csLoading in ComponentState) and not (csDesigning in ComponentState);
end;

procedure TTMSFNCToolBarCustomComboBox.ChangeDPIScale(M, D: Integer);
begin
  inherited;
  {$IFDEF CMNLIB}
  FItemSelector.Font.Height := TTMSFNCUtils.MulDivInt(FItemSelector.Font.Height, M, D);
  {$ENDIF}
end;

constructor TTMSFNCToolBarCustomComboBox.Create(AOwner: TComponent);
begin
  inherited;
  FTimer := TTimer.Create(Self);
  FTimer.Interval := 1;
  FTimer.OnTimer := @EnterTimerChanged;
  FTimer.Enabled := False;

  FEdit := TEdit.Create(Self);
  FEdit.TabStop := True;
  {$IFDEF FMXLIB}
  FEdit.Align := TAlignLayout.Client;
  FEdit.Stored := False;
  FEdit.OnChangeTracking := @EditChange;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FEdit.Align := alClient;
  FEdit.OnChange := @EditChange;
  {$ENDIF}

  Width := 100;
  Height := 24;
  HorizontalTextAlign := gtaLeading;
  FItemIndex := -1;

  FItemSelector := TTMSFNCListBox.Create(Self);
  FItemSelector.Width := 200;
  FItemSelector.Height := 150;
  {$IFDEF FMXLIB}
  FItemSelector.Align := TAlignLayout.Client;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FItemSelector.Align := alClient;
  {$ENDIF}
  FItemSelector.OnItemSelected := @ItemSelected;

  FItemSelector.OnKeyUp := @ItemKeyUp;
  FItemSelector.OnKeyDown := @ItemKeyDown;

  DropDownControl := FItemSelector;
  DropDownKind := ddkDropDownButton;
  DropDownWidth := FItemSelector.Width;
  DropDownHeight := FItemSelector.Height;

  FItems := TStringList.Create;
end;

destructor TTMSFNCToolBarCustomComboBox.Destroy;
begin
  FTimer.Free;
  FItems.Free;
  inherited;
end;

procedure TTMSFNCToolBarCustomComboBox.DoEnter;
begin
  inherited;
  FTimer.Enabled := Editable;
end;

procedure TTMSFNCToolBarCustomComboBox.DoItemSelected;
begin
  if Assigned(FEdit) {$IFDEF CMNWEBLIB} and FEdit.HandleAllocated{$ENDIF} then
  begin
    FEdit.Text := SelectedItem;
    FEdit.SelStart := Length(FEdit.Text);
  end;

  if Assigned(OnItemSelected) then
    OnItemSelected(Self, SelectedItemIndex);
end;

procedure TTMSFNCToolBarCustomComboBox.Draw(AGraphics: TTMSFNCGraphics;
  ARect: TRectF);
begin
  if not Editable then
    inherited;
end;

procedure TTMSFNCToolBarCustomComboBox.DropDown;
begin
  inherited;
  if not Assigned(FPopup) then
    Exit;

  {$IFDEF CMNLIB}
  if Assigned(FItemSelector) then
    FItemSelector.Font.Height := ScalePaintValue(-11);
  {$ENDIF}

  if FPopup.IsOpen and Assigned(FItemSelector) then
  begin
    FItemSelector.ItemIndex := -1;
    FItemSelector.ItemIndex := SelectedItemIndex;
  end;
end;

procedure TTMSFNCToolBarCustomComboBox.EditChange(Sender: TObject);
begin
  SelectedItem := FEdit.Text;
  if Assigned(OnEditChange) then
    OnEditChange(Self);
end;

procedure TTMSFNCToolBarCustomComboBox.EnterTimerChanged(Sender: TObject);
begin
  FEdit.SetFocus;
  FTimer.Enabled := False;
end;

function TTMSFNCToolBarCustomComboBox.GetSelectedItem: String;
begin
  Result := '';
  if Assigned(FItems) and (FItemIndex >= 0) and (FItemIndex <= FItems.Count - 1) then
    Result := FItems[FItemIndex]
end;

function TTMSFNCToolBarCustomComboBox.GetSelectedItemIndex: Integer;
begin
  Result := FItemIndex;
end;

function TTMSFNCToolBarCustomComboBox.GetText: String;
begin
  if Editable then
    Result := FEdit.Text
  else
    Result := SelectedItem;
end;

procedure TTMSFNCToolBarCustomComboBox.HandleDialogKey(var Key: Word;
  Shift: TShiftState);
begin
  inherited;
  if Shift <> [] then
    Exit;

  if Editable and FEdit.IsFocused then
  begin
    case Key of
      KEY_F4:
      begin
        if not (ssAlt in Shift) then
          DropDown;
      end;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomComboBox.InitializePopup;
begin
  FItemSelector.BeginUpdate;
  FItemSelector.Items.Clear;
  FItemSelector.LoadFromStrings(FItems);
  FItemSelector.ItemIndex := FItemIndex;
  FItemSelector.EndUpdate;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCToolBarCustomComboBox.ItemKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCToolBarCustomComboBox.ItemKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  FKeyboardUsed := True;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCToolBarCustomComboBox.ItemKeyUp(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCToolBarCustomComboBox.ItemKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if (Key = KEY_RETURN) or (Key = KEY_SPACE) then
  begin
    NotifyDataBinderEdit;
    FItemIndex := FItemSelector.ItemIndex;
    NotifyDataBinderValueChanged;

    if CloseOnSelection then
      DropDown;

    DoItemSelected;
    Invalidate;
  end;

  FKeyBoardUsed := False;
end;

procedure TTMSFNCToolBarCustomComboBox.ItemSelected(Sender: TObject; AItem: TTMSFNCListBoxItem);
begin
  if FKeyBoardUsed then
    Exit;

  NotifyDataBinderEdit;
  FItemIndex := FItemSelector.ItemIndex;
  NotifyDataBinderValueChanged;

  if CloseOnSelection then
    DropDown;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectFirstValue;
begin
  inherited;
  NotifyDataBinderEdit;
  FItemIndex := 0;
  NotifyDataBinderValueChanged;
  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectLastValue;
begin
  inherited;
  NotifyDataBinderEdit;
  FItemIndex := FItems.Count - 1;
  NotifyDataBinderValueChanged;
  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectNextValue;
begin
  inherited;
  NotifyDataBinderEdit;
  if FItemIndex = -1 then
    FItemIndex := 0
  else
    FItemIndex := Min(FItems.Count - 1, FItemIndex + 1);
  NotifyDataBinderValueChanged;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectPreviousValue;
begin
  inherited;
  NotifyDataBinderEdit;
  if FItemIndex = -1 then
    FItemIndex := 0
  else
    FItemIndex := Max(0, FItemIndex - 1);
  NotifyDataBinderValueChanged;

  DoItemSelected;
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectValueWithCharacter(
  ACharacter: Char);
var
  I: Integer;
begin
  inherited;
  for I := 0 to Items.Count - 1 do
  begin
    if TTMSFNCUtils.MatchStrEx(ACharacter + '*', Items[I], False) then
    begin
      FItemIndex := I;
      DoItemSelected;
      Invalidate;
      Break;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomComboBox.SelectValueWithString(AValue: string);
var
  I: Integer;
begin
  inherited;
  for I := 0 to Items.Count - 1 do
  begin
    if TTMSFNCUtils.MatchStrEx(AValue + '*', Items[I], False) then
    begin
      FItemIndex := I;
      DoItemSelected;
      Invalidate;
      Break;
    end;
  end;
end;

procedure TTMSFNCToolBarCustomComboBox.SetEditable(const Value: Boolean);
begin
  if FEditable <> Value then
  begin
    FEditable := Value;
    if Assigned(FEdit) then
    begin
      if FEditable then
      begin
        FEdit.Parent := Self;
      end
      else
        FEdit.Parent := nil;

      FEdit.Visible := FEditable;
    end;
    Invalidate;
  end;
end;

procedure TTMSFNCToolBarCustomComboBox.SetItems(const Value: TStringList);
begin
  FItems.Assign(Value);
end;

procedure TTMSFNCToolBarCustomComboBox.SetSelectedItem(const Value: String);
begin
  FItemIndex := FItems.IndexOf(Value);
  Invalidate;
end;

procedure TTMSFNCToolBarCustomComboBox.SetSelectedItemIndex(
  const Value: Integer);
begin
  FItemIndex := Value;
  Invalidate;
end;

{$ENDIF}

{ TTMSFNCToolBarButton }

procedure TTMSFNCToolBarButton.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarButton);
end;

{ TTMSFNCToolBarSeparator }

procedure TTMSFNCToolBarSeparator.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarSeparator);
end;

{ TTMSFNCToolBar }

procedure TTMSFNCToolBar.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBar);
end;

{ TTMSFNCToolBarItemPicker }

procedure TTMSFNCToolBarItemPicker.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarItemPicker);
end;

{$IFDEF FNCLIB}

{ TTMSFNCToolBarComboBox }

procedure TTMSFNCToolBarComboBox.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCToolBarComboBox);
end;

{$ENDIF}

{$IFDEF WEBLIB}
function TTMSFNCToolBarControlObjectList.GetItem(
  Index: Integer): TTMSFNCToolBarControl;
begin
  Result := TTMSFNCToolBarControl(inherited Items[Index]);
end;

procedure TTMSFNCToolBarControlObjectList.SetItem(Index: Integer; const Value: TTMSFNCToolBarControl);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCToolBarControlList.GetItem(
  Index: Integer): TTMSFNCToolBarControl;
begin
  Result := TTMSFNCToolBarControl(inherited Items[Index]);
end;

procedure TTMSFNCToolBarControlList.SetItem(Index: Integer; const Value: TTMSFNCToolBarControl);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCControlList.GetItem(Index: Integer): TControl;
begin
  Result := TControl(inherited Items[Index]);
end;

procedure TTMSFNCControlList.SetItem(Index: Integer; const Value: TControl);
begin
  inherited Items[Index] := Value;
end;
{$ENDIF}

initialization
  RegisterClass(TTMSFNCToolBarButton);
  {$IFDEF WEBLIB}
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBAREXPANDSVG);
  {$ENDIF}

end.
